/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yaml` */
/* eslint-disable @typescript-eslint/ban-types,no-duplicate-imports,@typescript-eslint/no-unused-vars */
import { DocumentNode } from 'graphql';
import { gql } from 'graphql-tag';
export type PostcodeFieldsFragment = { _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null };

export type TerminalReaderFieldsFragment = { id: string, label: string, deviceType: string, serialNumber: string, status?: string | null, ipAddress?: string | null, locationId?: string | null, staticLocationId?: string | null, lastSeenAt?: any | null };

export type TerminalTipSettingsFieldsFragment = { percentages: Array<number> };

export type SaasSettingsStaticLocationFieldsFragment = { _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null };

export type SalonMembershipFieldsFragment = { _id: string, salonId: string, memberId: string, color: string, displayName: string, picture?: string | null, title?: string | null, permissions: Array<SalonMemberPermission>, status: SalonMemberStatus, createdAt?: any | null, updatedAt?: any | null, businessName: string, salonEmailAddress?: string | null, onlinePaymentsEnabled?: boolean | null, colleagues?: Array<{ memberId: string, displayName: string, color: string, picture?: string | null }> | null, locations: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> };

export type UserFieldsFragment = { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null };

export type ChatFieldsFragment = { _id: string, professionalId: string, clientId: string, professional?: { firstName?: string | null, lastName?: string | null } | null, client?: { firstName?: string | null, lastName?: string | null } | null, lastMessage: { message?: string | null, sentAt?: any | null }, messageCount: { professional: { unreadMessages: number, sent: number }, client: { unreadMessages: number, sent: number } } };

export type BookingsFieldsFragment = { _id: string, status?: string | null, date?: any | null, address?: any | null, totalPrice?: number | null, totalDuration?: number | null, totalFee?: number | null, title?: string | null, note?: string | null, type?: string | null, requestedFavouriteIds?: Array<string | null> | null, rejectedByIds?: Array<string | null> | null, userId?: string | null, items?: Array<any | null> | null, clientNote?: string | null, clientPictures?: Array<string | null> | null, professionalId?: string | null, timezone?: string | null, crossSellPromoCode?: string | null, calendarId?: string | null, clientReview?: { rating?: number | null, comment?: string | null } | null, clientDetails?: Array<{ firstName?: string | null, gender?: string | null, contactNumber?: string | null, note?: string | null, accountOwner?: boolean | null } | null> | null, postcode?: { _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null, adminFees?: Array<{ name?: string | null, amount?: number | null } | null> | null, requestedProfessionalResponses?: Array<{ professionalId?: string | null, status?: string | null, respondedAt?: any | null, availabilityAdded?: Array<any | null> | null } | null> | null };

export type BookingFieldsFragment = { payoutDate?: any | null, _id: string, status?: string | null, date?: any | null, address?: any | null, totalPrice?: number | null, totalDuration?: number | null, totalFee?: number | null, title?: string | null, note?: string | null, type?: string | null, requestedFavouriteIds?: Array<string | null> | null, rejectedByIds?: Array<string | null> | null, userId?: string | null, items?: Array<any | null> | null, clientNote?: string | null, clientPictures?: Array<string | null> | null, professionalId?: string | null, timezone?: string | null, crossSellPromoCode?: string | null, calendarId?: string | null, adjustments?: Array<{ _id?: string | null, adjustmentType?: string | null, note?: string | null, amount?: number | null, payoutDate?: any | null, professionalId?: string | null } | null> | null, clientReview?: { rating?: number | null, comment?: string | null } | null, clientDetails?: Array<{ firstName?: string | null, gender?: string | null, contactNumber?: string | null, note?: string | null, accountOwner?: boolean | null } | null> | null, postcode?: { _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null, adminFees?: Array<{ name?: string | null, amount?: number | null } | null> | null, requestedProfessionalResponses?: Array<{ professionalId?: string | null, status?: string | null, respondedAt?: any | null, availabilityAdded?: Array<any | null> | null } | null> | null };

export type SaasSettingsFieldsFragment = { bookNowUrl?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, businessName?: string | null, salonMemberOnly?: boolean | null, subtext?: string | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, isPublic?: boolean | null, themePrimary?: string | null, themeBackground?: string | null, themeTextColor?: string | null, emailThemeBackground?: string | null, emailThemeTextColor?: string | null, emailThemePrimary?: string | null, requireTermsAndConditions?: boolean | null, receiveClientEmails?: boolean | null, branding?: any | null, requestsBlockCalendar?: boolean | null, defaultPaymentMethod?: PaymentMethodOptionId | null, defaultCancellationText?: string | null, linkDescription?: string | null, treatmentCategoriesOrder?: Array<string> | null, treatmentsDisplayName?: string | null, pinnedReviewId?: string | null, requireBirthday?: boolean | null, requireBirthdayExplaination?: string | null, rescheduleRequestsEnabled?: boolean | null, reschedulingTimeFrame?: number | null, themeSettings: { colorPrimary: string, colorSecondary: string, colorNeutralLight: string, colorNeutralDark: string, cornerStyle: string, shadowStyle: string, titlesFont: string, titlesMotif: string, bodyFont: string }, features?: { hours?: string | null } | null, lookBook?: Array<{ imageUrl: string, caption: string }> | null, info: Array<{ title: string, body: string }>, mobileLocation?: { _id: string, enabled: boolean, fee: number, summary?: string | null, travelDistanceMiles?: number | null, externalAddressId?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null, requestParkingInformation?: boolean | null } | null, staticLocations?: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> | null, paymentMethods?: Array<{ label: string, type: SaasPaymentMethodType }> | null, contactDetails?: Array<{ type: ContactType, value: string }> | null, clientDepositSettings?: Array<{ clientType: string, depositRequired: string, depositAmount: number, useFixedAmount?: boolean | null, disableApplePay?: boolean | null }> | null, seoSettings?: { metaTitle: string, metaDescription: string, pageH1: string, pageH2: string } | null, localBusinessVisibility?: { addressVisibility?: FooterAddressVisibilityOption | null, showPhoneNumber?: boolean | null } | null };

export type SubscriptionDetailsFieldsFragment = { chargeBeeId?: string | null, entitlementOverrides?: Array<string> | null, isUpdating?: number | null, saasBookingsThisPeriod?: { value?: number | null } | null, trialExtensions?: Array<{ date: any, plan: string }> | null, saasReceipts?: Array<{ productId?: string | null, token?: string | null }> | null, saasSubscriptions?: Array<{ plan: string, status: string, platform: SoloSubscriptionPlatform, nextBilling?: any | null, planType: PlanType, couponIds: Array<string>, totalDiscount?: number | null, inTrial?: boolean | null, trialEnd?: any | null, trialStart?: any | null, entitlements: Array<{ id?: string | null, value?: string | null }> }> | null, entitlements?: Array<{ id?: string | null, value?: string | null, enabled?: boolean | null, updatedAt?: any | null, lastActiveAt?: any | null }> | null };

export type ProfessionalFieldsFragment = { _id: string, role?: AuthRole | null, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, emailConfirmed?: boolean | null, guestKey?: string | null, mobile?: string | null, mobileConfirmed?: boolean | null, gender?: string | null, genderSelfDescription?: string | null, stripeConnectedAccount?: string | null, stripePayoutEnabled?: boolean | null, stripeAccountStatus?: string | null, stripePayoutInterval?: string | null, soloServiceFee?: number | null, acceptedTermsPA?: boolean | null, acceptedTermsSaaS?: boolean | null, lastHealthPPECheck?: any | null, healthPPEConfirmed?: boolean | null, profileUrl?: string | null, blocked?: boolean | null, createdAt?: any | null, referralCode?: string | null, attributionData?: any | null, soloReferralId?: string | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, stripeLimits?: { tapToPay?: number | null, dailyTransactions?: number | null } | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, information?: any | null, createdAt?: any | null, genderPreference?: string | null, saasProfileUrl?: string | null, averageExternalReview: number, externalReviewCount: number, completedSetupSteps: Array<string>, completedSetupTasks: Array<string>, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, saasSettings?: { bookNowUrl?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, businessName?: string | null, salonMemberOnly?: boolean | null, subtext?: string | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, isPublic?: boolean | null, themePrimary?: string | null, themeBackground?: string | null, themeTextColor?: string | null, emailThemeBackground?: string | null, emailThemeTextColor?: string | null, emailThemePrimary?: string | null, requireTermsAndConditions?: boolean | null, receiveClientEmails?: boolean | null, branding?: any | null, requestsBlockCalendar?: boolean | null, defaultPaymentMethod?: PaymentMethodOptionId | null, defaultCancellationText?: string | null, linkDescription?: string | null, treatmentCategoriesOrder?: Array<string> | null, treatmentsDisplayName?: string | null, pinnedReviewId?: string | null, requireBirthday?: boolean | null, requireBirthdayExplaination?: string | null, rescheduleRequestsEnabled?: boolean | null, reschedulingTimeFrame?: number | null, themeSettings: { colorPrimary: string, colorSecondary: string, colorNeutralLight: string, colorNeutralDark: string, cornerStyle: string, shadowStyle: string, titlesFont: string, titlesMotif: string, bodyFont: string }, features?: { hours?: string | null } | null, lookBook?: Array<{ imageUrl: string, caption: string }> | null, info: Array<{ title: string, body: string }>, mobileLocation?: { _id: string, enabled: boolean, fee: number, summary?: string | null, travelDistanceMiles?: number | null, externalAddressId?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null, requestParkingInformation?: boolean | null } | null, staticLocations?: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> | null, paymentMethods?: Array<{ label: string, type: SaasPaymentMethodType }> | null, contactDetails?: Array<{ type: ContactType, value: string }> | null, clientDepositSettings?: Array<{ clientType: string, depositRequired: string, depositAmount: number, useFixedAmount?: boolean | null, disableApplePay?: boolean | null }> | null, seoSettings?: { metaTitle: string, metaDescription: string, pageH1: string, pageH2: string } | null, localBusinessVisibility?: { addressVisibility?: FooterAddressVisibilityOption | null, showPhoneNumber?: boolean | null } | null } | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null, giftCardSettings?: { enabled: boolean, daysBeforeExpires: number } | null } | null, stripeCapabilities?: { card_payments?: string | null, transfers?: string | null } | null, subscriptionDetails?: { chargeBeeId?: string | null, entitlementOverrides?: Array<string> | null, isUpdating?: number | null, saasBookingsThisPeriod?: { value?: number | null } | null, trialExtensions?: Array<{ date: any, plan: string }> | null, saasReceipts?: Array<{ productId?: string | null, token?: string | null }> | null, saasSubscriptions?: Array<{ plan: string, status: string, platform: SoloSubscriptionPlatform, nextBilling?: any | null, planType: PlanType, couponIds: Array<string>, totalDiscount?: number | null, inTrial?: boolean | null, trialEnd?: any | null, trialStart?: any | null, entitlements: Array<{ id?: string | null, value?: string | null }> }> | null, entitlements?: Array<{ id?: string | null, value?: string | null, enabled?: boolean | null, updatedAt?: any | null, lastActiveAt?: any | null }> | null } | null, googleBusinessAuth?: { refreshToken: string, accessToken: string, selectedLocationId?: string | null, selectedAccountId?: string | null, scopes: Array<string>, placeId?: string | null, localBusinessSchemaData?: { name?: string | null } | null } | null, googleCalendarAuth?: { refreshToken: string, accessToken: string, calendarId?: string | null } | null };

export type ExternalClientFieldsFragment = { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null };

export type EmailCampaignFieldsFragment = { _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, emailSubject: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null, themeColors: { themePrimary: string, themeBackground: string, themeTextColor: string, contrastTextColor: string }, emailContent: Array<{ _id: string, blockType: EmailContentBlockType, text: string, url?: string | null, data?: { promocodeId?: string | null } | null }> };

export type SmsCampaignFieldsFragment = { _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, messageContent: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null };

export type ExternalTreatmentFieldsFragment = { _id: string, name: string, price: number, category: string, duration: number, bufferTime: number, showOnPortal: boolean, description: string, order?: number | null, professionalId?: string | null, locations: Array<{ locationId: string, enabled: boolean, price?: number | null }>, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null, memberOverrides: Array<{ professionalId: string, price?: number | null, duration?: number | null, canPerformTreatment: boolean }> };

export type ExternalPromocodeFieldsFragment = { _id: string, code: string, redeemedBy: Array<string | null>, redeemableBy: RedeemableBy, expiryDate: any, active: boolean, treatmentIds: Array<string | null>, discountAmount: number, discountType: DiscountType, professionalId: string, createdAt: any, customRedeemableExternalClientIds?: Array<string | null> | null, maxRedemptions?: number | null, applyToAllTreatments: boolean, applyToAllClients: boolean, label: string, externalClientId?: string | null };

export type PrivatePaymentFieldsFragment = { sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null };

export type ExternalBookingFieldsFragment = { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null };

export type ExternalAddressFieldsFragment = { _id: string, professionalId?: string | null, placeId: string, line1: string, line2: string, region: string, postalCode: string, timezone?: string | null, location: { type: GeoJsonPointType, coordinates: Array<number> }, staticLocation?: { _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null } | null };

export type ExternalReviewFieldsFragment = { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null };

export type InAppMessageFieldsFragment = { _id: string, name: string, platform: Platform, eventName: string, match: string, contentType: MessageType, updatedAt: any };

export type ConsultationFormFieldsFragment = { _id: string, name: string, professionalId?: string | null, treatmentIds: Array<string>, applyToAllTreatments: boolean };

export type ConsultationFormQuestionFieldsFragment = { _id: string, question: string, type: QuestionType, options: Array<string>, required: boolean, placeholder?: string | null, helpText?: string | null, templateName?: string | null, autofillId?: string | null };

export type AutomatedCampaignFieldsFragment = { campaignId: string, triggerType: AutomatedTriggerType, daysOffset: number, active: boolean, sendAtHour: number, messageType: CampaignMessageType, sendLog: Array<{ date: any, sentCount: number, errors: Array<string> }> };

export type ScheduledCampaignFieldsFragment = { campaignId: string, messageType: CampaignMessageType, scheduledFor?: any | null, externalClientIds: Array<string>, status: ScheduledCampaignStatus };

export type ButtonFieldsFragment = { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean };

export type WebPageFieldsFragment = { _id: string, title: string, path: string, group: string, order?: number | null, showPageNavigation: boolean, visibility: WebPageVisibility, headerBlock: { _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
      | { type: WebPageBlockType, title?: string | null, titleSize?: number | null, text?: string | null, layout: number, shape: string, textPosition: string, textColor: string, borderStyle: string, imageUrl: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
      | Record<PropertyKey, never>
     }, seoSettings?: { metaTitle: string, metaDescription: string } | null, actionButton?: { content: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } } | null, blocks: Array<{ _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
      | { label: string, url: string, title?: string | null, type: WebPageBlockType }
      | { layout: number, imageUrl: string, alt?: string | null, title?: string | null, titleSize?: number | null, text?: string | null, type: WebPageBlockType, filter: string, shape: string, textPosition: string, textColor: string, borderStyle: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
      | { layout: number, title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, alt: string, imageUrl: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
      | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, heading: string, text: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
      | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, iconName?: string | null, label: string, subtext?: string | null, url: string, linkType: WebPageBlockButtonType }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
      | { type: WebPageBlockType, title?: string | null, text?: string | null, hideFullAddress?: boolean | null, locationId?: string | null, syncWithGoogle?: boolean | null, data?: { placeId: string, staticLocationLat: number, staticLocationLng: number, localBusinessData?: { address?: { street?: string | null, city?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null }
      | { layout: number, logos: Array<string>, title?: string | null, type: WebPageBlockType }
      | { title?: string | null, type: WebPageBlockType, items: Array<{ alt: string, imageUrl: string }> }
      | { type: WebPageBlockType, title?: string | null, layout: number, reviewIds: Array<string>, reviewsDisplayType: WebPageExternalReviewsDisplay, data?: { reviews: Array<{ _id: string, rating: number, publicComment: string, privateComment: string, visible: boolean, externalClientName: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
      | { type: WebPageBlockType, title?: string | null, layout: number, data?: { members: Array<{ _id: string, memberDisplayName?: string | null, picture?: string | null, title?: string | null }> } | null }
      | { text?: string | null, title?: string | null, type: WebPageBlockType, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
      | { treatmentsListDisplayType: WebPageTreatmentListDisplayType, title?: string | null, type: WebPageBlockType, groupedCategories?: boolean | null, items: Array<{ _id: string }>, data?: { items: Array<{ _id: string, name: string, description: string, price: number, category: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
      | Record<PropertyKey, never>
     }> };

export type LoyaltySchemeFieldsFragment = { _id: string, professionalId: string, status: LoyaltySchemeStatus, startDate: any, goal: LoyaltySchemeGoalType, goalNumber: number, minBookingFee: number, applyToAllClients: boolean, externalClientIds: Array<string>, createdAt?: any | null, updatedAt?: any | null, schemeUsage?: LoyaltySchemeUsageType | null, promoCodeSettings: { discountAmount: number, discountType: string, validityDays: number, applyToAllTreatments: boolean, treatmentIds: Array<string> }, referralCodeSettings?: { discountAmount: number, discountType: string, validityDays: number, applyToAllTreatments: boolean, treatmentIds: Array<string> } | null };

export type ExternalGiftCardFieldsFragment = { _id: string, code: string, amount: number, expirationDate: any, receiverEmail: string, message: string, senderEmail: string, status: GiftCardStatus, balance: number, transactions: Array<{ date: any, amount: number, type: GiftCardTransactionType, externalBookingId?: string | null }> };

export type BusinessProfileDataFieldsFragment = { _id: string, reviewsWithTextCount: number, reviewsWithin60DaysCount: number, averageRating?: number | null, reviewResponseRate?: number | null, photosCount: number, clientPhotosCount: number, photosWithin60DaysCount: number, postsCount: number, lastPostDate?: any | null, hasDescription: boolean, hasAddress: boolean, hasWebsite: boolean, isVerified: boolean, hasOpeningHours: boolean, servicesCount: number, hasPrimaryCategory: boolean, createdAt: any, professionalId: string, updatedAt: any, fetchedAt: any };

export type GetConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigQuery = { checkBlockedUser?: boolean | null, appVer?: { apiVersion?: string | null, minConsumerAppVer?: string | null, minProAppVer?: string | null } | null, settings?: { _id?: string | null, platform?: string | null, settings?: any | null } | null };

export type GetConfigAndMessagesQueryVariables = Exact<{
  filter: InAppMessageFilter;
}>;


export type GetConfigAndMessagesQuery = { checkBlockedUser?: boolean | null, appVer?: { apiVersion?: string | null, minConsumerAppVer?: string | null, minProAppVer?: string | null } | null, settings?: { _id?: string | null, platform?: string | null, settings?: any | null } | null, inAppMessages: Array<{ _id: string, name: string, platform: Platform, eventName: string, match: string, contentType: MessageType, updatedAt: any }> };

export type CheckBlockedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckBlockedUserQuery = { checkBlockedUser?: boolean | null };

export type SendPreviewEmailQueryVariables = Exact<{
  eventName: Scalars['String']['input'];
}>;


export type SendPreviewEmailQuery = { sendPreviewEmail?: boolean | null };

export type PlansWithPriceQueryVariables = Exact<{
  currencyCode: Scalars['String']['input'];
  period: PeriodUnit;
}>;


export type PlansWithPriceQuery = { plansWithPrice: Array<{ id: string, currency_code: string, price_pennies: number, period_unit: PlanPeriodUnit, type: PlanType, name: string }> };

export type AddonPricesQueryVariables = Exact<{
  currencyCode: Scalars['String']['input'];
  period: PeriodUnit;
}>;


export type AddonPricesQuery = { addonPrices: Array<{ addonId: string, priceId: string, type: AddonType, price_pennies: number, period_unit: PlanPeriodUnit, currency_code: string, name: string }> };

export type LogoutMutationVariables = Exact<{
  uniqueDeviceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogoutMutation = { logout?: boolean | null };

export type GetMagicLinkTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetMagicLinkTokenMutation = { getMagicLinkToken: { token: string, expiresAt: string } };

export type GetUserTraitsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTraitsQuery = { getUserTraits?: any | null };

export type AppVerQueryVariables = Exact<{ [key: string]: never; }>;


export type AppVerQuery = { appVer?: { apiVersion?: string | null, minConsumerAppVer?: string | null, minProAppVer?: string | null } | null };

export type DeleteSaasDataMutationVariables = Exact<{
  models: Array<DeletableModelNames> | DeletableModelNames;
}>;


export type DeleteSaasDataMutation = { deleteSaasData?: boolean | null };

export type IdentifyWithMobileQueryVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']['input']>;
}>;


export type IdentifyWithMobileQuery = { identifyWithMobile?: { authToken?: { role: AuthRole, auth: string } | null, user?: { role?: AuthRole | null } | null } | null };

export type SendMobileVerificationQueryVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']['input']>;
  silent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SendMobileVerificationQuery = { sendMobileVerification?: { authToken?: { role: AuthRole, auth: string } | null } | null };

export type VerifyMobileAndSignInMutationVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyMobileAndSignInMutation = { verifyMobileAndSignIn?: { authToken?: { role: AuthRole, auth: string } | null, user?: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } | null } | null };

export type SignInAsSalonMutationVariables = Exact<{
  salonId: Scalars['String']['input'];
}>;


export type SignInAsSalonMutation = { signInAsSalon: { authToken?: { role: AuthRole, auth: string } | null, user?: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } | null } };

export type SignOutOfSalonMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutOfSalonMutation = { signOutOfSalon: { authToken?: { role: AuthRole, auth: string } | null, user?: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } | null } };

export type AddReferralToUserMutationVariables = Exact<{
  referredBy: Scalars['String']['input'];
}>;


export type AddReferralToUserMutation = { addReferralToUser?: boolean | null };

export type ReviewsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ReviewsQuery = { reviews?: Array<{ _id?: string | null, professionalId?: string | null, comment?: string | null, createdAt?: any | null, rating?: number | null, user?: { firstName?: string | null, lastName?: string | null, _id: string } | null } | null> | null };

export type AnswersMutationVariables = Exact<{
  answers: QuestionAnswer;
}>;


export type AnswersMutation = { answers?: { profile?: any | null } | null };

export type ChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatsQuery = { chats: Array<{ _id: string, professionalId: string, clientId: string, professional?: { firstName?: string | null, lastName?: string | null } | null, client?: { firstName?: string | null, lastName?: string | null } | null, lastMessage: { message?: string | null, sentAt?: any | null }, messageCount: { professional: { unreadMessages: number, sent: number }, client: { unreadMessages: number, sent: number } } } | null> };

export type MarketplaceListingQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplaceListingQuery = { marketplaceListing?: { _id: string, name: string, userId?: string | null, tags?: Array<{ category: MarketplaceTagCategory, marketplaceSlug: string, name: string }> | null } | null };

export type MarkChatAsReadMutationVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type MarkChatAsReadMutation = { markChatAsRead?: boolean | null };

export type FindOrCreateChatMutationVariables = Exact<{
  clientId: Scalars['String']['input'];
}>;


export type FindOrCreateChatMutation = { findOrCreateChat: { _id: string, professionalId: string, clientId: string, professional?: { firstName?: string | null, lastName?: string | null } | null, client?: { firstName?: string | null, lastName?: string | null } | null, lastMessage: { message?: string | null, sentAt?: any | null }, messageCount: { professional: { unreadMessages: number, sent: number }, client: { unreadMessages: number, sent: number } } } };

export type GetUnreadMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadMessagesQuery = { getUnreadMessages: number };

export type BookingsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type BookingsQuery = { bookings?: Array<{ _id: string, status?: string | null, date?: any | null, address?: any | null, totalPrice?: number | null, totalDuration?: number | null, totalFee?: number | null, title?: string | null, note?: string | null, type?: string | null, requestedFavouriteIds?: Array<string | null> | null, rejectedByIds?: Array<string | null> | null, userId?: string | null, items?: Array<any | null> | null, clientNote?: string | null, clientPictures?: Array<string | null> | null, professionalId?: string | null, timezone?: string | null, crossSellPromoCode?: string | null, calendarId?: string | null, clientReview?: { rating?: number | null, comment?: string | null } | null, clientDetails?: Array<{ firstName?: string | null, gender?: string | null, contactNumber?: string | null, note?: string | null, accountOwner?: boolean | null } | null> | null, postcode?: { _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null, adminFees?: Array<{ name?: string | null, amount?: number | null } | null> | null, requestedProfessionalResponses?: Array<{ professionalId?: string | null, status?: string | null, respondedAt?: any | null, availabilityAdded?: Array<any | null> | null } | null> | null } | null> | null };

export type BookingQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookingQuery = { booking?: { payoutDate?: any | null, _id: string, status?: string | null, date?: any | null, address?: any | null, totalPrice?: number | null, totalDuration?: number | null, totalFee?: number | null, title?: string | null, note?: string | null, type?: string | null, requestedFavouriteIds?: Array<string | null> | null, rejectedByIds?: Array<string | null> | null, userId?: string | null, items?: Array<any | null> | null, clientNote?: string | null, clientPictures?: Array<string | null> | null, professionalId?: string | null, timezone?: string | null, crossSellPromoCode?: string | null, calendarId?: string | null, adjustments?: Array<{ _id?: string | null, adjustmentType?: string | null, note?: string | null, amount?: number | null, payoutDate?: any | null, professionalId?: string | null } | null> | null, clientReview?: { rating?: number | null, comment?: string | null } | null, clientDetails?: Array<{ firstName?: string | null, gender?: string | null, contactNumber?: string | null, note?: string | null, accountOwner?: boolean | null } | null> | null, postcode?: { _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null, adminFees?: Array<{ name?: string | null, amount?: number | null } | null> | null, requestedProfessionalResponses?: Array<{ professionalId?: string | null, status?: string | null, respondedAt?: any | null, availabilityAdded?: Array<any | null> | null } | null> | null } | null };

export type RejectBookingMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
}>;


export type RejectBookingMutation = { rejectBooking?: boolean | null };

export type AcceptBookingMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
  ignoreConflictingBookings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AcceptBookingMutation = { acceptBooking?: boolean | null };

export type HasBookingClashQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
}>;


export type HasBookingClashQuery = { hasBookingClash?: boolean | null };

export type ProfessionalRequestResponseMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  availabilityAdded?: InputMaybe<Array<InputMaybe<Scalars['JSONObject']['input']>> | InputMaybe<Scalars['JSONObject']['input']>>;
}>;


export type ProfessionalRequestResponseMutation = { professionalRequestResponse?: { _id: string, requestedProfessionalResponses?: Array<{ professionalId?: string | null, status?: string | null, respondedAt?: any | null, availabilityAdded?: Array<any | null> | null } | null> | null } | null };

export type UpdateBookingStatusMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBookingStatusMutation = { updateBookingStatus?: boolean | null };

export type CreateReviewMutationVariables = Exact<{
  data?: InputMaybe<NewReview>;
}>;


export type CreateReviewMutation = { createReview?: string | null };

export type CreateMockReviewMutationVariables = Exact<{
  data?: InputMaybe<NewMockReview>;
}>;


export type CreateMockReviewMutation = { createMockReview?: { _id?: string | null, professionalId?: string | null, comment?: string | null, createdAt?: any | null, rating?: number | null, user?: { firstName?: string | null, lastName?: string | null, _id: string } | null } | null };

export type GetProfessionalAvailabilityQueryVariables = Exact<{
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  memberIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetProfessionalAvailabilityQuery = { getProfessionalAvailability?: Array<{ professionalId?: string | null, day?: string | null, status?: number | null, times?: Array<number | null> | null, workingTimes?: Array<Array<number | null> | null> | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, transportMode?: string | null, bookingId?: string | null, defaultForDay?: number | null, locationId?: string | null } | null> | null };

export type ProfessionalsAvailableAtLocationsQueryVariables = Exact<{
  locationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  professionalIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProfessionalsAvailableAtLocationsQuery = { professionalsAvailableAtLocations: Array<{ professionalId: string, locationIds: Array<string> }> };

export type AvailabilitySuggestionsQueryVariables = Exact<{
  includeNearby?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AvailabilitySuggestionsQuery = { availabilitySuggestions?: Array<{ _id?: string | null, day: string, treatmentIds: Array<string | null>, postcodeIds: Array<string | null>, treatmentType: string } | null> | null };

export type GetProfessionalAgendasQueryVariables = Exact<{
  days?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  memberId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfessionalAgendasQuery = { getProfessionalAgendas?: Array<{ day: string, isCustom: boolean, events: Array<{ date: any, title: string, color: string, bookingId: string, professionalId: string, startHour: number, durationHours: number, outerCode: string, type: string, bookingStatus: string, warningStatus: DiaryEventWarningStatus, paymentStatus?: string | null, consultationFormStatus?: string | null, treatments: Array<string>, categories: Array<string>, clientFirstName: string, clientLastName: string, repeating: boolean, rescheduleRequested: boolean, colors: Array<{ color: string, percentage: number }>, segments?: Array<{ durationHours: number, type: DiarySegmentType, color: string }> | null }>, availability?: { day?: string | null, status?: number | null, times?: Array<number | null> | null, workingTimes?: Array<Array<number | null> | null> | null, locationId?: string | null } | null } | null> | null };

export type ExternalBookingQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type ExternalBookingQuery = { externalBooking?: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } | null };

export type SendReminderMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  reminder: Scalars['String']['input'];
}>;


export type SendReminderMutation = { sendReminder: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type ExternalBookingsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ExternalBookingsQuery = { externalBookings?: Array<{ _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } | null> | null };

export type RefundStripePaymentMutationVariables = Exact<{
  data: RefundPaymentInput;
}>;


export type RefundStripePaymentMutation = { refundStripePayment: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type CreateOrUpdateExternalBookingMutationVariables = Exact<{
  data?: InputMaybe<ExternalBookingInput>;
  unsetFields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateOrUpdateExternalBookingMutation = { createOrUpdateExternalBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type UpdateSpecificExternalBookingDataMutationVariables = Exact<{
  data: ExternalBookingSpecificInput;
}>;


export type UpdateSpecificExternalBookingDataMutation = { updateSpecificExternalBookingData: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type BookingHasConflictsQueryVariables = Exact<{
  data: BookingConflictsInput;
}>;


export type BookingHasConflictsQuery = { bookingHasConflicts?: boolean | null };

export type DeleteExternalBookingMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteExternalBookingMutation = { deleteExternalBooking?: number | null };

export type AcceptRescheduledBookingMutationVariables = Exact<{
  originalBookingId: Scalars['String']['input'];
}>;


export type AcceptRescheduledBookingMutation = { acceptRescheduledBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type RejectRescheduledBookingMutationVariables = Exact<{
  originalBookingId: Scalars['String']['input'];
}>;


export type RejectRescheduledBookingMutation = { rejectRescheduledBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type ResolveRescheduledBookingMutationVariables = Exact<{
  originalBookingId: Scalars['String']['input'];
  date: Scalars['Date']['input'];
}>;


export type ResolveRescheduledBookingMutation = { resolveRescheduledBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type AcceptExternalBookingMutationVariables = Exact<{
  data: ExternalBookingInput;
}>;


export type AcceptExternalBookingMutation = { acceptExternalBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type DeclineExternalBookingMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  deleteClient: Scalars['Boolean']['input'];
}>;


export type DeclineExternalBookingMutation = { declineExternalBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type CancelAndRefundExternalBookingMutationVariables = Exact<{
  data: CancelAndRefundExternalBookingInput;
}>;


export type CancelAndRefundExternalBookingMutation = { cancelAndRefundExternalBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type CancelAndChargeExternalBookingMutationVariables = Exact<{
  data: CancelAndChargeExternalBookingInput;
}>;


export type CancelAndChargeExternalBookingMutation = { cancelAndChargeExternalBooking: { charged: boolean, error?: string | null, externalBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } } };

export type ChargeExternalBookingMutationVariables = Exact<{
  data: ChargeExternalBookingInput;
}>;


export type ChargeExternalBookingMutation = { chargeExternalBooking: { charged: boolean, error?: string | null, externalBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } } };

export type CompleteExternalBookingMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  data: CompleteExternalBookingInput;
}>;


export type CompleteExternalBookingMutation = { completeExternalBooking: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type CreateOrUpdateProfessionalAvailabilityMutationVariables = Exact<{
  data: CreateUpdateAvailabilityInput;
}>;


export type CreateOrUpdateProfessionalAvailabilityMutation = { createOrUpdateProfessionalAvailability?: Array<{ day?: string | null, status?: number | null, times?: Array<number | null> | null, workingTimes?: Array<Array<number | null> | null> | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, locationId?: string | null, bookingId?: string | null, defaultForDay?: number | null } | null> | null };

export type RemoveProfessionalAvailabilityMutationVariables = Exact<{
  filter?: InputMaybe<ProfessionalAvailabilityInput>;
  memberId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveProfessionalAvailabilityMutation = { removeProfessionalAvailability?: number | null };

export type GetProfessionalQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfessionalQuery = { getProfessional?: { _id: string, role?: AuthRole | null, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, emailConfirmed?: boolean | null, guestKey?: string | null, mobile?: string | null, mobileConfirmed?: boolean | null, gender?: string | null, genderSelfDescription?: string | null, stripeConnectedAccount?: string | null, stripePayoutEnabled?: boolean | null, stripeAccountStatus?: string | null, stripePayoutInterval?: string | null, soloServiceFee?: number | null, acceptedTermsPA?: boolean | null, acceptedTermsSaaS?: boolean | null, lastHealthPPECheck?: any | null, healthPPEConfirmed?: boolean | null, profileUrl?: string | null, blocked?: boolean | null, createdAt?: any | null, referralCode?: string | null, attributionData?: any | null, soloReferralId?: string | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, stripeLimits?: { tapToPay?: number | null, dailyTransactions?: number | null } | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, information?: any | null, createdAt?: any | null, genderPreference?: string | null, saasProfileUrl?: string | null, averageExternalReview: number, externalReviewCount: number, completedSetupSteps: Array<string>, completedSetupTasks: Array<string>, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, saasSettings?: { bookNowUrl?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, businessName?: string | null, salonMemberOnly?: boolean | null, subtext?: string | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, isPublic?: boolean | null, themePrimary?: string | null, themeBackground?: string | null, themeTextColor?: string | null, emailThemeBackground?: string | null, emailThemeTextColor?: string | null, emailThemePrimary?: string | null, requireTermsAndConditions?: boolean | null, receiveClientEmails?: boolean | null, branding?: any | null, requestsBlockCalendar?: boolean | null, defaultPaymentMethod?: PaymentMethodOptionId | null, defaultCancellationText?: string | null, linkDescription?: string | null, treatmentCategoriesOrder?: Array<string> | null, treatmentsDisplayName?: string | null, pinnedReviewId?: string | null, requireBirthday?: boolean | null, requireBirthdayExplaination?: string | null, rescheduleRequestsEnabled?: boolean | null, reschedulingTimeFrame?: number | null, themeSettings: { colorPrimary: string, colorSecondary: string, colorNeutralLight: string, colorNeutralDark: string, cornerStyle: string, shadowStyle: string, titlesFont: string, titlesMotif: string, bodyFont: string }, features?: { hours?: string | null } | null, lookBook?: Array<{ imageUrl: string, caption: string }> | null, info: Array<{ title: string, body: string }>, mobileLocation?: { _id: string, enabled: boolean, fee: number, summary?: string | null, travelDistanceMiles?: number | null, externalAddressId?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null, requestParkingInformation?: boolean | null } | null, staticLocations?: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> | null, paymentMethods?: Array<{ label: string, type: SaasPaymentMethodType }> | null, contactDetails?: Array<{ type: ContactType, value: string }> | null, clientDepositSettings?: Array<{ clientType: string, depositRequired: string, depositAmount: number, useFixedAmount?: boolean | null, disableApplePay?: boolean | null }> | null, seoSettings?: { metaTitle: string, metaDescription: string, pageH1: string, pageH2: string } | null, localBusinessVisibility?: { addressVisibility?: FooterAddressVisibilityOption | null, showPhoneNumber?: boolean | null } | null } | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null, giftCardSettings?: { enabled: boolean, daysBeforeExpires: number } | null } | null, stripeCapabilities?: { card_payments?: string | null, transfers?: string | null } | null, subscriptionDetails?: { chargeBeeId?: string | null, entitlementOverrides?: Array<string> | null, isUpdating?: number | null, saasBookingsThisPeriod?: { value?: number | null } | null, trialExtensions?: Array<{ date: any, plan: string }> | null, saasReceipts?: Array<{ productId?: string | null, token?: string | null }> | null, saasSubscriptions?: Array<{ plan: string, status: string, platform: SoloSubscriptionPlatform, nextBilling?: any | null, planType: PlanType, couponIds: Array<string>, totalDiscount?: number | null, inTrial?: boolean | null, trialEnd?: any | null, trialStart?: any | null, entitlements: Array<{ id?: string | null, value?: string | null }> }> | null, entitlements?: Array<{ id?: string | null, value?: string | null, enabled?: boolean | null, updatedAt?: any | null, lastActiveAt?: any | null }> | null } | null, googleBusinessAuth?: { refreshToken: string, accessToken: string, selectedLocationId?: string | null, selectedAccountId?: string | null, scopes: Array<string>, placeId?: string | null, localBusinessSchemaData?: { name?: string | null } | null } | null, googleCalendarAuth?: { refreshToken: string, accessToken: string, calendarId?: string | null } | null } | null };

export type GetProfessionalWithStripeQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfessionalWithStripeQuery = { getProfessional?: { stripeDashboard?: string | null, stripeBusinessName?: string | null, stripeDescriptor?: string | null, _id: string, role?: AuthRole | null, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, emailConfirmed?: boolean | null, guestKey?: string | null, mobile?: string | null, mobileConfirmed?: boolean | null, gender?: string | null, genderSelfDescription?: string | null, stripeConnectedAccount?: string | null, stripePayoutEnabled?: boolean | null, stripeAccountStatus?: string | null, stripePayoutInterval?: string | null, soloServiceFee?: number | null, acceptedTermsPA?: boolean | null, acceptedTermsSaaS?: boolean | null, lastHealthPPECheck?: any | null, healthPPEConfirmed?: boolean | null, profileUrl?: string | null, blocked?: boolean | null, createdAt?: any | null, referralCode?: string | null, attributionData?: any | null, soloReferralId?: string | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, stripeLimits?: { tapToPay?: number | null, dailyTransactions?: number | null } | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, information?: any | null, createdAt?: any | null, genderPreference?: string | null, saasProfileUrl?: string | null, averageExternalReview: number, externalReviewCount: number, completedSetupSteps: Array<string>, completedSetupTasks: Array<string>, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, saasSettings?: { bookNowUrl?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, businessName?: string | null, salonMemberOnly?: boolean | null, subtext?: string | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, isPublic?: boolean | null, themePrimary?: string | null, themeBackground?: string | null, themeTextColor?: string | null, emailThemeBackground?: string | null, emailThemeTextColor?: string | null, emailThemePrimary?: string | null, requireTermsAndConditions?: boolean | null, receiveClientEmails?: boolean | null, branding?: any | null, requestsBlockCalendar?: boolean | null, defaultPaymentMethod?: PaymentMethodOptionId | null, defaultCancellationText?: string | null, linkDescription?: string | null, treatmentCategoriesOrder?: Array<string> | null, treatmentsDisplayName?: string | null, pinnedReviewId?: string | null, requireBirthday?: boolean | null, requireBirthdayExplaination?: string | null, rescheduleRequestsEnabled?: boolean | null, reschedulingTimeFrame?: number | null, themeSettings: { colorPrimary: string, colorSecondary: string, colorNeutralLight: string, colorNeutralDark: string, cornerStyle: string, shadowStyle: string, titlesFont: string, titlesMotif: string, bodyFont: string }, features?: { hours?: string | null } | null, lookBook?: Array<{ imageUrl: string, caption: string }> | null, info: Array<{ title: string, body: string }>, mobileLocation?: { _id: string, enabled: boolean, fee: number, summary?: string | null, travelDistanceMiles?: number | null, externalAddressId?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null, requestParkingInformation?: boolean | null } | null, staticLocations?: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> | null, paymentMethods?: Array<{ label: string, type: SaasPaymentMethodType }> | null, contactDetails?: Array<{ type: ContactType, value: string }> | null, clientDepositSettings?: Array<{ clientType: string, depositRequired: string, depositAmount: number, useFixedAmount?: boolean | null, disableApplePay?: boolean | null }> | null, seoSettings?: { metaTitle: string, metaDescription: string, pageH1: string, pageH2: string } | null, localBusinessVisibility?: { addressVisibility?: FooterAddressVisibilityOption | null, showPhoneNumber?: boolean | null } | null } | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null, giftCardSettings?: { enabled: boolean, daysBeforeExpires: number } | null } | null, stripeCapabilities?: { card_payments?: string | null, transfers?: string | null } | null, subscriptionDetails?: { chargeBeeId?: string | null, entitlementOverrides?: Array<string> | null, isUpdating?: number | null, saasBookingsThisPeriod?: { value?: number | null } | null, trialExtensions?: Array<{ date: any, plan: string }> | null, saasReceipts?: Array<{ productId?: string | null, token?: string | null }> | null, saasSubscriptions?: Array<{ plan: string, status: string, platform: SoloSubscriptionPlatform, nextBilling?: any | null, planType: PlanType, couponIds: Array<string>, totalDiscount?: number | null, inTrial?: boolean | null, trialEnd?: any | null, trialStart?: any | null, entitlements: Array<{ id?: string | null, value?: string | null }> }> | null, entitlements?: Array<{ id?: string | null, value?: string | null, enabled?: boolean | null, updatedAt?: any | null, lastActiveAt?: any | null }> | null } | null, googleBusinessAuth?: { refreshToken: string, accessToken: string, selectedLocationId?: string | null, selectedAccountId?: string | null, scopes: Array<string>, placeId?: string | null, localBusinessSchemaData?: { name?: string | null } | null } | null, googleCalendarAuth?: { refreshToken: string, accessToken: string, calendarId?: string | null } | null } | null };

export type UpdateProfessionalStripeDataMutationVariables = Exact<{
  data?: InputMaybe<ProfessionalStripeDataInput>;
}>;


export type UpdateProfessionalStripeDataMutation = { updateProfessionalStripeData?: string | null };

export type GetProfessionalAvailabilityDataQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfessionalAvailabilityDataQuery = { getProfessional?: { professionalProfile?: { treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null } | null } | null };

export type UpdateSaasUserMutationVariables = Exact<{
  data: UpdateSaasUserInput;
}>;


export type UpdateSaasUserMutation = { updateSaasUser?: boolean | null };

export type UpdateProfessionalProfileMutationVariables = Exact<{
  data?: InputMaybe<UserProfessionalProfileInput>;
}>;


export type UpdateProfessionalProfileMutation = { updateProfessionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, completedSetupSteps: Array<string>, completedSetupTasks: Array<string>, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, saasSettings?: { bookNowUrl?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, businessName?: string | null, salonMemberOnly?: boolean | null, subtext?: string | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, isPublic?: boolean | null, themePrimary?: string | null, themeBackground?: string | null, themeTextColor?: string | null, emailThemeBackground?: string | null, emailThemeTextColor?: string | null, emailThemePrimary?: string | null, requireTermsAndConditions?: boolean | null, receiveClientEmails?: boolean | null, branding?: any | null, requestsBlockCalendar?: boolean | null, defaultPaymentMethod?: PaymentMethodOptionId | null, defaultCancellationText?: string | null, linkDescription?: string | null, treatmentCategoriesOrder?: Array<string> | null, treatmentsDisplayName?: string | null, pinnedReviewId?: string | null, requireBirthday?: boolean | null, requireBirthdayExplaination?: string | null, rescheduleRequestsEnabled?: boolean | null, reschedulingTimeFrame?: number | null, themeSettings: { colorPrimary: string, colorSecondary: string, colorNeutralLight: string, colorNeutralDark: string, cornerStyle: string, shadowStyle: string, titlesFont: string, titlesMotif: string, bodyFont: string }, features?: { hours?: string | null } | null, lookBook?: Array<{ imageUrl: string, caption: string }> | null, info: Array<{ title: string, body: string }>, mobileLocation?: { _id: string, enabled: boolean, fee: number, summary?: string | null, travelDistanceMiles?: number | null, externalAddressId?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null, requestParkingInformation?: boolean | null } | null, staticLocations?: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> | null, paymentMethods?: Array<{ label: string, type: SaasPaymentMethodType }> | null, contactDetails?: Array<{ type: ContactType, value: string }> | null, clientDepositSettings?: Array<{ clientType: string, depositRequired: string, depositAmount: number, useFixedAmount?: boolean | null, disableApplePay?: boolean | null }> | null, seoSettings?: { metaTitle: string, metaDescription: string, pageH1: string, pageH2: string } | null, localBusinessVisibility?: { addressVisibility?: FooterAddressVisibilityOption | null, showPhoneNumber?: boolean | null } | null } | null } | null };

export type CreateOrUpdateDeviceMutationVariables = Exact<{
  data?: InputMaybe<UserDeviceInput>;
}>;


export type CreateOrUpdateDeviceMutation = { createOrUpdateDevice?: { uniqueDeviceId?: string | null, apnsToken?: string | null, fcmToken?: string | null, device?: string | null, platform?: string | null, platformVersion?: string | null, notificationsPermissionStatus?: number | null, notificationAccessRequested?: boolean | null, deviceRegisteredForNotifications?: boolean | null } | null };

export type GetPostcodesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPostcodesQuery = { getPostcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null };

export type PayoutsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type PayoutsQuery = { payouts?: Array<{ _id?: string | null, status?: string | null, amount?: number | null, createdAt?: any | null, items?: Array<{ bookingId?: string | null, adjustmentId?: string | null, amount?: number | null, date?: any | null, note?: string | null, type?: string | null } | null> | null } | null> | null };

export type ExternalBookingPaymentsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ExternalBookingPaymentsQuery = { externalBookingPayments: Array<{ _id: string, date: any, status: ExternalPaymentStatus, amount: number, privatePaymentDetails: { net: number, type: PaymentTypes, externalBooking: { _id: string, title: string, formattedDate: string, externalClientName: string } } }> };

export type PaymentsForExternalBookingQueryVariables = Exact<{
  data: ExternalBookingPaymentsInput;
}>;


export type PaymentsForExternalBookingQuery = { paymentsForExternalBooking: Array<{ _id: string, date: any, status: ExternalPaymentStatus, amount: number, privatePaymentDetails: { net: number, type: PaymentTypes, externalBooking: { _id: string, title: string, formattedDate: string, externalClientName: string } } }> };

export type BookingStubsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type BookingStubsQuery = { bookings?: Array<{ _id: string, status?: string | null, date?: any | null, userId?: string | null, clientDetails?: Array<{ firstName?: string | null, gender?: string | null, contactNumber?: string | null, note?: string | null, accountOwner?: boolean | null } | null> | null, postcode?: { _id?: string | null, code?: string | null } | null } | null> | null };

export type PageQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type PageQuery = { page?: { _id?: string | null, title?: string | null, body?: string | null, type?: string | null } | null };

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsQuery = { settings?: { _id?: string | null, platform?: string | null, settings?: any | null } | null };

export type CreateOrGetReferralMutationVariables = Exact<{
  data?: InputMaybe<ReferralCodeInput>;
}>;


export type CreateOrGetReferralMutation = { createOrGetReferral?: { _id?: string | null, promoCode: string, title: string, description?: string | null, createdAt?: any | null, startDate?: any | null, active?: boolean | null, discountType?: string | null, value: number, useCount?: number | null, redeemAction?: { receiveAmount?: number | null } | null } | null };

export type GetCrossSellPromoCodeMutationVariables = Exact<{
  bookingId: Scalars['String']['input'];
}>;


export type GetCrossSellPromoCodeMutation = { getCrossSellPromoCode?: { _id?: string | null, promoCode: string, value: number, limits?: { excludedTreatmentTypes?: Array<string | null> | null } | null, redeemAction?: { receiveAmount?: number | null } | null } | null };

export type InvalidatePagesMutationVariables = Exact<{ [key: string]: never; }>;


export type InvalidatePagesMutation = { invalidatePages: boolean };

export type AdjustmentsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type AdjustmentsQuery = { adjustments?: Array<{ _id?: string | null, createdAt?: any | null, bookingId?: string | null, professionalId?: string | null, note?: string | null, amount?: number | null, payoutDrafted?: boolean | null, adjustmentType?: string | null } | null> | null };

export type PromoCodeApplicationsQueryVariables = Exact<{
  data?: InputMaybe<PromoCodeApplicationsInput>;
}>;


export type PromoCodeApplicationsQuery = { promoCodeApplications?: Array<{ _id: string, createdAt?: any | null, status?: string | null, user?: { _id: string, firstName?: string | null } | null, booking?: { _id: string, status?: string | null, date?: any | null } | null, promoCode?: { redeemAction?: { receiveAmount?: number | null, action?: string | null } | null } | null } | null> | null };

export type CategoriesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
}>;


export type CategoriesQuery = { categories?: Array<{ _id?: string | null, name?: string | null, treatmentIds?: Array<string | null> | null, slug?: string | null } | null> | null };

export type GetParkingInformationQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
  addressId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetParkingInformationQuery = { getParkingInformation?: { _id: string, locationDetails?: string | null, locationType: string, cost?: string | null, note?: string | null, postcode: string, addressId: string, proComments: Array<any | null> } | null };

export type AddorUpdateParkingInformationMutationVariables = Exact<{
  data: ParkingInformationInput;
}>;


export type AddorUpdateParkingInformationMutation = { addorUpdateParkingInformation?: { _id: string, locationDetails?: string | null, locationType: string, cost?: string | null, note?: string | null, postcode: string, addressId: string, proComments: Array<any | null> } | null };

export type RequestProfessionalPaymentCapabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type RequestProfessionalPaymentCapabilityQuery = { requestProfessionalPaymentCapability?: boolean | null };

export type EmailCampaignsQueryVariables = Exact<{
  filter: Scalars['JSONObject']['input'];
  pagination: Pagination;
}>;


export type EmailCampaignsQuery = { emailCampaigns: Array<{ _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, emailSubject: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null, themeColors: { themePrimary: string, themeBackground: string, themeTextColor: string, contrastTextColor: string }, emailContent: Array<{ _id: string, blockType: EmailContentBlockType, text: string, url?: string | null, data?: { promocodeId?: string | null } | null }> }> };

export type EmailCampaignQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type EmailCampaignQuery = { emailCampaign?: { _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, emailSubject: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null, themeColors: { themePrimary: string, themeBackground: string, themeTextColor: string, contrastTextColor: string }, emailContent: Array<{ _id: string, blockType: EmailContentBlockType, text: string, url?: string | null, data?: { promocodeId?: string | null } | null }> } | null };

export type CreateEmailCampaignMutationVariables = Exact<{
  data: CreateEmailCampaignInput;
}>;


export type CreateEmailCampaignMutation = { createEmailCampaign: { _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, emailSubject: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null, themeColors: { themePrimary: string, themeBackground: string, themeTextColor: string, contrastTextColor: string }, emailContent: Array<{ _id: string, blockType: EmailContentBlockType, text: string, url?: string | null, data?: { promocodeId?: string | null } | null }> } };

export type UpdateEmailCampaignMutationVariables = Exact<{
  data: UpdateEmailCampaignInput;
}>;


export type UpdateEmailCampaignMutation = { updateEmailCampaign: { _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, emailSubject: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null, themeColors: { themePrimary: string, themeBackground: string, themeTextColor: string, contrastTextColor: string }, emailContent: Array<{ _id: string, blockType: EmailContentBlockType, text: string, url?: string | null, data?: { promocodeId?: string | null } | null }> } };

export type DeleteAutomatedCampaignsMutationVariables = Exact<{
  emailCampaignId?: InputMaybe<Scalars['String']['input']>;
  smsCampaignId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteAutomatedCampaignsMutation = { deleteAutomatedCampaigns: boolean };

export type ResetAutomatedEmailThemesMutationVariables = Exact<{
  data?: InputMaybe<ResetAutomatedEmailThemesInput>;
}>;


export type ResetAutomatedEmailThemesMutation = { resetAutomatedEmailThemes: boolean };

export type SendTestEmailQueryVariables = Exact<{
  data: SendTestEmailInput;
}>;


export type SendTestEmailQuery = { sendTestEmail: boolean };

export type SmsCampaignsQueryVariables = Exact<{
  filter: Scalars['JSONObject']['input'];
  pagination: Pagination;
}>;


export type SmsCampaignsQuery = { smsCampaigns: Array<{ _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, messageContent: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null }> };

export type SmsCampaignQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type SmsCampaignQuery = { smsCampaign?: { _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, messageContent: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null } | null };

export type CreateSmsCampaignMutationVariables = Exact<{
  data: CreateSmsCampaignInput;
}>;


export type CreateSmsCampaignMutation = { createSmsCampaign: { _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, messageContent: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null } };

export type UpdateSmsCampaignMutationVariables = Exact<{
  data: UpdateSmsCampaignInput;
}>;


export type UpdateSmsCampaignMutation = { updateSmsCampaign: { _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, messageContent: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null } };

export type ScheduledCampaignQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScheduledCampaignQuery = { scheduledCampaign?: { campaignId: string, messageType: CampaignMessageType, scheduledFor?: any | null, externalClientIds: Array<string>, status: ScheduledCampaignStatus } | null };

export type AutomatedCampaignQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AutomatedCampaignQuery = { automatedCampaign?: { campaignId: string, triggerType: AutomatedTriggerType, daysOffset: number, active: boolean, sendAtHour: number, messageType: CampaignMessageType, sendLog: Array<{ date: any, sentCount: number, errors: Array<string> }> } | null };

export type UpdateAutomatedCampaignMutationVariables = Exact<{
  data: AutomatedCampaignInput;
}>;


export type UpdateAutomatedCampaignMutation = { updateAutomatedCampaign: { campaignId: string, triggerType: AutomatedTriggerType, daysOffset: number, active: boolean, sendAtHour: number, messageType: CampaignMessageType, sendLog: Array<{ date: any, sentCount: number, errors: Array<string> }> } };

export type UpdateScheduledCampaignMutationVariables = Exact<{
  data: ScheduledCampaignInput;
}>;


export type UpdateScheduledCampaignMutation = { updateScheduledCampaign?: { campaignId: string, messageType: CampaignMessageType, scheduledFor?: any | null, externalClientIds: Array<string>, status: ScheduledCampaignStatus } | null };

export type ExternalTreatmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalTreatmentsQuery = { externalTreatments: Array<{ _id: string, name: string, price: number, category: string, duration: number, bufferTime: number, showOnPortal: boolean, description: string, order?: number | null, professionalId?: string | null, locations: Array<{ locationId: string, enabled: boolean, price?: number | null }>, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null, memberOverrides: Array<{ professionalId: string, price?: number | null, duration?: number | null, canPerformTreatment: boolean }> }> };

export type AddOrUpdateExternalTreatmentMutationVariables = Exact<{
  data: ExternalTreatmentInput;
}>;


export type AddOrUpdateExternalTreatmentMutation = { addOrUpdateExternalTreatment: { _id: string, name: string, price: number, category: string, duration: number, bufferTime: number, showOnPortal: boolean, description: string, order?: number | null, professionalId?: string | null, locations: Array<{ locationId: string, enabled: boolean, price?: number | null }>, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null, memberOverrides: Array<{ professionalId: string, price?: number | null, duration?: number | null, canPerformTreatment: boolean }> } };

export type UpdateTreatmentPricingMutationVariables = Exact<{
  defaults: Array<TreatmentDefaultInput> | TreatmentDefaultInput;
  overrides: Array<TreatmentMemberOverrideInput> | TreatmentMemberOverrideInput;
}>;


export type UpdateTreatmentPricingMutation = { updateTreatmentPricing: Array<{ _id: string, name: string, price: number, category: string, duration: number, bufferTime: number, showOnPortal: boolean, description: string, order?: number | null, professionalId?: string | null, locations: Array<{ locationId: string, enabled: boolean, price?: number | null }>, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null, memberOverrides: Array<{ professionalId: string, price?: number | null, duration?: number | null, canPerformTreatment: boolean }> }> };

export type DeleteExternalTreatmentMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteExternalTreatmentMutation = { deleteExternalTreatment: number };

export type ExternalPromocodesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ExternalPromocodesQuery = { externalPromocodes: Array<{ _id: string, code: string, redeemedBy: Array<string | null>, redeemableBy: RedeemableBy, expiryDate: any, active: boolean, treatmentIds: Array<string | null>, discountAmount: number, discountType: DiscountType, professionalId: string, createdAt: any, customRedeemableExternalClientIds?: Array<string | null> | null, maxRedemptions?: number | null, applyToAllTreatments: boolean, applyToAllClients: boolean, label: string, externalClientId?: string | null }> };

export type ExternalPromocodeQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type ExternalPromocodeQuery = { externalPromocode?: { _id: string, code: string, redeemedBy: Array<string | null>, redeemableBy: RedeemableBy, expiryDate: any, active: boolean, treatmentIds: Array<string | null>, discountAmount: number, discountType: DiscountType, professionalId: string, createdAt: any, customRedeemableExternalClientIds?: Array<string | null> | null, maxRedemptions?: number | null, applyToAllTreatments: boolean, applyToAllClients: boolean, label: string, externalClientId?: string | null } | null };

export type CreateExternalPromocodeMutationVariables = Exact<{
  data: CreateExternalPromocodeInput;
}>;


export type CreateExternalPromocodeMutation = { createExternalPromocode?: { _id: string, code: string, redeemedBy: Array<string | null>, redeemableBy: RedeemableBy, expiryDate: any, active: boolean, treatmentIds: Array<string | null>, discountAmount: number, discountType: DiscountType, professionalId: string, createdAt: any, customRedeemableExternalClientIds?: Array<string | null> | null, maxRedemptions?: number | null, applyToAllTreatments: boolean, applyToAllClients: boolean, label: string, externalClientId?: string | null } | null };

export type ValidateExternalPromocodeMutationVariables = Exact<{
  data: ValidateExternalPromocodeInput;
}>;


export type ValidateExternalPromocodeMutation = { validateExternalPromocode: boolean };

export type UpdateExternalPromocodeMutationVariables = Exact<{
  data: UpdateExternalPromocodeInput;
}>;


export type UpdateExternalPromocodeMutation = { updateExternalPromocode?: { _id: string, code: string, redeemedBy: Array<string | null>, redeemableBy: RedeemableBy, expiryDate: any, active: boolean, treatmentIds: Array<string | null>, discountAmount: number, discountType: DiscountType, professionalId: string, createdAt: any, customRedeemableExternalClientIds?: Array<string | null> | null, maxRedemptions?: number | null, applyToAllTreatments: boolean, applyToAllClients: boolean, label: string, externalClientId?: string | null } | null };

export type ExternalTreatmentQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type ExternalTreatmentQuery = { externalTreatment: { _id: string, name: string, price: number, category: string, duration: number, bufferTime: number, showOnPortal: boolean, description: string, order?: number | null, professionalId?: string | null, locations: Array<{ locationId: string, enabled: boolean, price?: number | null }>, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null, memberOverrides: Array<{ professionalId: string, price?: number | null, duration?: number | null, canPerformTreatment: boolean }> } };

export type ExternalClientsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
  groups?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type ExternalClientsQuery = { externalClients: Array<{ _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null }> };

export type ClientGroupCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientGroupCountsQuery = { clientGroupCounts: Array<{ group: string, count: number }> };

export type SearchExternalClientsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchExternalClientsQuery = { searchExternalClients?: Array<{ _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null }> | null };

export type AddOrUpdateExternalClientMutationVariables = Exact<{
  data: ExternalClientInput;
}>;


export type AddOrUpdateExternalClientMutation = { addOrUpdateExternalClient: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } };

export type DeleteExternalClientMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteExternalClientMutation = { deleteExternalClient: boolean };

export type ExternalClientQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type ExternalClientQuery = { externalClient: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } };

export type AddExternalClientsMutationVariables = Exact<{
  data: Array<ExternalClientInput> | ExternalClientInput;
}>;


export type AddExternalClientsMutation = { addExternalClients: number };

export type SwitchClientBookingsMutationVariables = Exact<{
  data: SwitchClientBookingsInput;
}>;


export type SwitchClientBookingsMutation = { switchClientBookings: boolean };

export type ExternalAddressesQueryVariables = Exact<{
  filter?: InputMaybe<ExternalAddressFilter>;
}>;


export type ExternalAddressesQuery = { externalAddresses: Array<{ _id: string, professionalId?: string | null, placeId: string, line1: string, line2: string, region: string, postalCode: string, timezone?: string | null, location: { type: GeoJsonPointType, coordinates: Array<number> }, staticLocation?: { _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null } | null }> };

export type AddOrUpdateExternalAddressMutationVariables = Exact<{
  data: ExternalAddressInput;
}>;


export type AddOrUpdateExternalAddressMutation = { addOrUpdateExternalAddress: { _id: string, professionalId?: string | null, placeId: string, line1: string, line2: string, region: string, postalCode: string, timezone?: string | null, location: { type: GeoJsonPointType, coordinates: Array<number> }, staticLocation?: { _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null } | null } };

export type DeleteExternalAddressMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteExternalAddressMutation = { deleteExternalAddress: number };

export type ExternalAddressQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type ExternalAddressQuery = { externalAddress: { _id: string, professionalId?: string | null, placeId: string, line1: string, line2: string, region: string, postalCode: string, timezone?: string | null, location: { type: GeoJsonPointType, coordinates: Array<number> }, staticLocation?: { _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null } | null } };

export type CheckSaasProfileUrlAvailableQueryVariables = Exact<{
  data: SaasProfileUrlInput;
}>;


export type CheckSaasProfileUrlAvailableQuery = { checkSaasProfileUrlAvailable?: boolean | null };

export type GetBookingsForHomepageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBookingsForHomepageQuery = { getBookingsForHomepage: { instants: number, privateRequests: number, requests: number, cancel: number, complete: number, outstandingPayments: number, outstandingConsultationForms: number, chats: number, reschedule: number, bookings: Array<{ payoutDate?: any | null, _id: string, status?: string | null, date?: any | null, address?: any | null, totalPrice?: number | null, totalDuration?: number | null, totalFee?: number | null, title?: string | null, note?: string | null, type?: string | null, requestedFavouriteIds?: Array<string | null> | null, rejectedByIds?: Array<string | null> | null, userId?: string | null, items?: Array<any | null> | null, clientNote?: string | null, clientPictures?: Array<string | null> | null, professionalId?: string | null, timezone?: string | null, crossSellPromoCode?: string | null, calendarId?: string | null, adjustments?: Array<{ _id?: string | null, adjustmentType?: string | null, note?: string | null, amount?: number | null, payoutDate?: any | null, professionalId?: string | null } | null> | null, clientReview?: { rating?: number | null, comment?: string | null } | null, clientDetails?: Array<{ firstName?: string | null, gender?: string | null, contactNumber?: string | null, note?: string | null, accountOwner?: boolean | null } | null> | null, postcode?: { _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null, adminFees?: Array<{ name?: string | null, amount?: number | null } | null> | null, requestedProfessionalResponses?: Array<{ professionalId?: string | null, status?: string | null, respondedAt?: any | null, availabilityAdded?: Array<any | null> | null } | null> | null }>, externalBookings: Array<{ _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null }> } };

export type SoloBookingsForDashboardQueryVariables = Exact<{
  filters: Array<DashboardBookingFilter> | DashboardBookingFilter;
}>;


export type SoloBookingsForDashboardQuery = { soloBookingsForDashboard: Array<{ filter: DashboardBookingFilter, externalBookingIds: Array<any>, externalBookings: Array<{ _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null }> }> };

export type ExternalReviewsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ExternalReviewsQuery = { externalReviews: Array<{ _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null }> };

export type UpdateExternalReviewVisibleMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
}>;


export type UpdateExternalReviewVisibleMutation = { updateExternalReviewVisible: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } };

export type CreateExternalReviewMutationVariables = Exact<{
  data: ExternalReviewInput;
}>;


export type CreateExternalReviewMutation = { createExternalReview: { _id: string } };

export type CreateSecretSpaExternalReviewMutationVariables = Exact<{
  data: SecretSpaExternalReviewInput;
}>;


export type CreateSecretSpaExternalReviewMutation = { createSecretSpaExternalReview: Array<string> };

export type ConsultationFormQueryVariables = Exact<{
  _id: Scalars['String']['input'];
  professionalId: Scalars['String']['input'];
}>;


export type ConsultationFormQuery = { consultationForm?: { _id: string, name: string, professionalId?: string | null, treatmentIds: Array<string>, applyToAllTreatments: boolean, questions: Array<{ _id: string, question: string, type: QuestionType, options: Array<string>, required: boolean, placeholder?: string | null, helpText?: string | null, templateName?: string | null, autofillId?: string | null }> } | null };

export type ConsultationFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultationFormsQuery = { consultationForms: Array<{ questionIds: Array<string>, _id: string, name: string, professionalId?: string | null, treatmentIds: Array<string>, applyToAllTreatments: boolean }> };

export type CreateOrUpdateConsultationFormMutationVariables = Exact<{
  data: ConsultationFormInput;
}>;


export type CreateOrUpdateConsultationFormMutation = { createOrUpdateConsultationForm: { _id: string, name: string, professionalId?: string | null, treatmentIds: Array<string>, applyToAllTreatments: boolean, questions: Array<{ _id: string, question: string, type: QuestionType, options: Array<string>, required: boolean, placeholder?: string | null, helpText?: string | null, templateName?: string | null, autofillId?: string | null }> } };

export type ConsultationFormDefaultQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultationFormDefaultQuestionsQuery = { consultationFormDefaultQuestions: Array<{ _id: string, question: string, type: QuestionType, options: Array<string>, required: boolean, placeholder?: string | null, helpText?: string | null, templateName?: string | null, autofillId?: string | null }> };

export type ConsultationFormCompletedQueryVariables = Exact<{
  externalBookingId: Scalars['String']['input'];
}>;


export type ConsultationFormCompletedQuery = { consultationFormCompleted: boolean };

export type ConsultationFormAnswersQueryVariables = Exact<{
  externalBookingId: Scalars['String']['input'];
}>;


export type ConsultationFormAnswersQuery = { consultationFormAnswers?: { updatedAt: any, answers: Array<{ _id: string, question: string, answer: any, questionType: QuestionType }> } | null };

export type DeleteConsultationFormMutationVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type DeleteConsultationFormMutation = { deleteConsultationForm: boolean };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  resizeOptions?: InputMaybe<ResizeImageOptions>;
}>;


export type UploadFileMutation = { uploadFile?: boolean | null };

export type DeleteFileMutationVariables = Exact<{
  filename?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteFileMutation = { deleteFile?: boolean | null };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { deleteUser: boolean };

export type CreateNewSaasUserWithMobileMutationVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateNewSaasUserWithMobileMutation = { createNewSaasUserWithMobile?: { authToken?: { role: AuthRole, auth: string } | null } | null };

export type VerifyMobileAndCompleteAccountMutationVariables = Exact<{
  mobile: Scalars['String']['input'];
  code: Scalars['String']['input'];
  userData: RegistrationDetails;
  onboardingId: Scalars['String']['input'];
  trialLength: Scalars['Int']['input'];
}>;


export type VerifyMobileAndCompleteAccountMutation = { verifyMobileAndCompleteAccount?: { authToken?: { role: AuthRole, auth: string } | null, user?: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } | null } | null };

export type InAppMessagesQueryVariables = Exact<{
  filter: InAppMessageFilter;
}>;


export type InAppMessagesQuery = { inAppMessages: Array<{ _id: string, name: string, platform: Platform, eventName: string, match: string, contentType: MessageType, updatedAt: any }> };

export type InAppMessageQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type InAppMessageQuery = { inAppMessage?: { name: string, content: any } | null };

export type SubmitOnboardingAnswersMutationVariables = Exact<{
  data: Array<OnboardingSurveyAnswersInput> | OnboardingSurveyAnswersInput;
  forNewBusiness?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SubmitOnboardingAnswersMutation = { submitOnboardingAnswers?: boolean | null };

export type ExternalTreatmentLibraryQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalTreatmentLibraryQuery = { externalTreatmentLibrary: Array<{ _id: string, name: string, price: number, category: string, duration: number, bufferTime: number, showOnPortal: boolean, description: string, order?: number | null, professionalId?: string | null, locations: Array<{ locationId: string, enabled: boolean, price?: number | null }>, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null, memberOverrides: Array<{ professionalId: string, price?: number | null, duration?: number | null, canPerformTreatment: boolean }> }> };

export type ImportLibraryTreatmentsMutationVariables = Exact<{
  treatmentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ImportLibraryTreatmentsMutation = { importLibraryTreatments: boolean };

export type ManageSoloSubscriptionUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type ManageSoloSubscriptionUrlQuery = { manageSoloSubscriptionUrl: string };

export type SoloSubscriptionUrlQueryVariables = Exact<{
  data: SoloSubscriptionUrlCheckout;
}>;


export type SoloSubscriptionUrlQuery = { soloSubscriptionUrl: string };

export type TestSubscriptionMutationVariables = Exact<{
  data: SoloSubscriptionTestData;
}>;


export type TestSubscriptionMutation = { testSubscription: boolean };

export type SyncWithChargebeeMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncWithChargebeeMutation = { syncWithChargebee: boolean };

export type BookingsForCalendarSyncQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingsForCalendarSyncQuery = { bookingsForCalendarSync: { bookings: Array<{ payoutDate?: any | null, _id: string, status?: string | null, date?: any | null, address?: any | null, totalPrice?: number | null, totalDuration?: number | null, totalFee?: number | null, title?: string | null, note?: string | null, type?: string | null, requestedFavouriteIds?: Array<string | null> | null, rejectedByIds?: Array<string | null> | null, userId?: string | null, items?: Array<any | null> | null, clientNote?: string | null, clientPictures?: Array<string | null> | null, professionalId?: string | null, timezone?: string | null, crossSellPromoCode?: string | null, calendarId?: string | null, adjustments?: Array<{ _id?: string | null, adjustmentType?: string | null, note?: string | null, amount?: number | null, payoutDate?: any | null, professionalId?: string | null } | null> | null, clientReview?: { rating?: number | null, comment?: string | null } | null, clientDetails?: Array<{ firstName?: string | null, gender?: string | null, contactNumber?: string | null, note?: string | null, accountOwner?: boolean | null } | null> | null, postcode?: { _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null, adminFees?: Array<{ name?: string | null, amount?: number | null } | null> | null, requestedProfessionalResponses?: Array<{ professionalId?: string | null, status?: string | null, respondedAt?: any | null, availabilityAdded?: Array<any | null> | null } | null> | null }>, externalBookings: Array<{ _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null }>, cancelledBookings: Array<{ payoutDate?: any | null, _id: string, status?: string | null, date?: any | null, address?: any | null, totalPrice?: number | null, totalDuration?: number | null, totalFee?: number | null, title?: string | null, note?: string | null, type?: string | null, requestedFavouriteIds?: Array<string | null> | null, rejectedByIds?: Array<string | null> | null, userId?: string | null, items?: Array<any | null> | null, clientNote?: string | null, clientPictures?: Array<string | null> | null, professionalId?: string | null, timezone?: string | null, crossSellPromoCode?: string | null, calendarId?: string | null, adjustments?: Array<{ _id?: string | null, adjustmentType?: string | null, note?: string | null, amount?: number | null, payoutDate?: any | null, professionalId?: string | null } | null> | null, clientReview?: { rating?: number | null, comment?: string | null } | null, clientDetails?: Array<{ firstName?: string | null, gender?: string | null, contactNumber?: string | null, note?: string | null, accountOwner?: boolean | null } | null> | null, postcode?: { _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null, adminFees?: Array<{ name?: string | null, amount?: number | null } | null> | null, requestedProfessionalResponses?: Array<{ professionalId?: string | null, status?: string | null, respondedAt?: any | null, availabilityAdded?: Array<any | null> | null } | null> | null }> } };

export type MarketplacesQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplacesQuery = { marketplaces: Array<{ _id: string, websiteSlug: string, name: string, branding: { primaryColor: string, secondaryColor: string } }> };

export type CreateDefaultAvailabilityMutationVariables = Exact<{
  data: CreateDefaultAvailabilityInput;
}>;


export type CreateDefaultAvailabilityMutation = { createDefaultAvailability?: boolean | null };

export type ClientSavedCardQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type ClientSavedCardQuery = { clientSavedCard?: { hasCardId: boolean, last4?: string | null } | null };

export type SaveAttributionSurveyDataMutationVariables = Exact<{
  data: Scalars['JSONObject']['input'];
}>;


export type SaveAttributionSurveyDataMutation = { saveAttributionSurveyData: boolean };

export type EnrollReferralProgramMutationVariables = Exact<{ [key: string]: never; }>;


export type EnrollReferralProgramMutation = { enrollReferralProgram: { _id: string, role?: AuthRole | null, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, emailConfirmed?: boolean | null, guestKey?: string | null, mobile?: string | null, mobileConfirmed?: boolean | null, gender?: string | null, genderSelfDescription?: string | null, stripeConnectedAccount?: string | null, stripePayoutEnabled?: boolean | null, stripeAccountStatus?: string | null, stripePayoutInterval?: string | null, soloServiceFee?: number | null, acceptedTermsPA?: boolean | null, acceptedTermsSaaS?: boolean | null, lastHealthPPECheck?: any | null, healthPPEConfirmed?: boolean | null, profileUrl?: string | null, blocked?: boolean | null, createdAt?: any | null, referralCode?: string | null, attributionData?: any | null, soloReferralId?: string | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, stripeLimits?: { tapToPay?: number | null, dailyTransactions?: number | null } | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, information?: any | null, createdAt?: any | null, genderPreference?: string | null, saasProfileUrl?: string | null, averageExternalReview: number, externalReviewCount: number, completedSetupSteps: Array<string>, completedSetupTasks: Array<string>, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, saasSettings?: { bookNowUrl?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, businessName?: string | null, salonMemberOnly?: boolean | null, subtext?: string | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, isPublic?: boolean | null, themePrimary?: string | null, themeBackground?: string | null, themeTextColor?: string | null, emailThemeBackground?: string | null, emailThemeTextColor?: string | null, emailThemePrimary?: string | null, requireTermsAndConditions?: boolean | null, receiveClientEmails?: boolean | null, branding?: any | null, requestsBlockCalendar?: boolean | null, defaultPaymentMethod?: PaymentMethodOptionId | null, defaultCancellationText?: string | null, linkDescription?: string | null, treatmentCategoriesOrder?: Array<string> | null, treatmentsDisplayName?: string | null, pinnedReviewId?: string | null, requireBirthday?: boolean | null, requireBirthdayExplaination?: string | null, rescheduleRequestsEnabled?: boolean | null, reschedulingTimeFrame?: number | null, themeSettings: { colorPrimary: string, colorSecondary: string, colorNeutralLight: string, colorNeutralDark: string, cornerStyle: string, shadowStyle: string, titlesFont: string, titlesMotif: string, bodyFont: string }, features?: { hours?: string | null } | null, lookBook?: Array<{ imageUrl: string, caption: string }> | null, info: Array<{ title: string, body: string }>, mobileLocation?: { _id: string, enabled: boolean, fee: number, summary?: string | null, travelDistanceMiles?: number | null, externalAddressId?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null, requestParkingInformation?: boolean | null } | null, staticLocations?: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> | null, paymentMethods?: Array<{ label: string, type: SaasPaymentMethodType }> | null, contactDetails?: Array<{ type: ContactType, value: string }> | null, clientDepositSettings?: Array<{ clientType: string, depositRequired: string, depositAmount: number, useFixedAmount?: boolean | null, disableApplePay?: boolean | null }> | null, seoSettings?: { metaTitle: string, metaDescription: string, pageH1: string, pageH2: string } | null, localBusinessVisibility?: { addressVisibility?: FooterAddressVisibilityOption | null, showPhoneNumber?: boolean | null } | null } | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null, giftCardSettings?: { enabled: boolean, daysBeforeExpires: number } | null } | null, stripeCapabilities?: { card_payments?: string | null, transfers?: string | null } | null, subscriptionDetails?: { chargeBeeId?: string | null, entitlementOverrides?: Array<string> | null, isUpdating?: number | null, saasBookingsThisPeriod?: { value?: number | null } | null, trialExtensions?: Array<{ date: any, plan: string }> | null, saasReceipts?: Array<{ productId?: string | null, token?: string | null }> | null, saasSubscriptions?: Array<{ plan: string, status: string, platform: SoloSubscriptionPlatform, nextBilling?: any | null, planType: PlanType, couponIds: Array<string>, totalDiscount?: number | null, inTrial?: boolean | null, trialEnd?: any | null, trialStart?: any | null, entitlements: Array<{ id?: string | null, value?: string | null }> }> | null, entitlements?: Array<{ id?: string | null, value?: string | null, enabled?: boolean | null, updatedAt?: any | null, lastActiveAt?: any | null }> | null } | null, googleBusinessAuth?: { refreshToken: string, accessToken: string, selectedLocationId?: string | null, selectedAccountId?: string | null, scopes: Array<string>, placeId?: string | null, localBusinessSchemaData?: { name?: string | null } | null } | null, googleCalendarAuth?: { refreshToken: string, accessToken: string, calendarId?: string | null } | null } };

export type GetSoloReferralsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSoloReferralsQuery = { getSoloReferrals: Array<{ _id: string, status: SoloReferralStatus, actions: Array<{ action: string, actionDate: any }>, rewards: Array<{ rewardType: string, rewardDate: any, amount?: number | null, status: SoloReferralRewardStatus }>, referredProfessional: { _id: string, firstName: string, lastName: string, saasProfileUrl: string, createdAt: any } }> };

export type CheckSoloReferralCodeQueryVariables = Exact<{
  referralCode: Scalars['String']['input'];
}>;


export type CheckSoloReferralCodeQuery = { checkSoloReferralCode?: { _id: string, firstName: string, lastName: string } | null };

export type CrmInvoicesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type CrmInvoicesQuery = { crmInvoices: Array<{ _id: string, professionalId: string, paid: boolean, totalAmount: number, unpaidAmount: number, startDate: any, endDate: any, usageLines: Array<{ ids: Array<string>, usageType: CrmUsageType }> }> };

export type CrmUsagesQueryVariables = Exact<{
  filter: CrmUsagesFilter;
  pagination?: InputMaybe<Pagination>;
}>;


export type CrmUsagesQuery = { crmUsages: Array<{ _id: string, externalBookingId?: string | null, emailCampaignId?: string | null, smsCampaignId?: string | null, externalClientId: string, professionalId: string, price: number, usageType: CrmUsageType, messageType: CrmMessageType, createdAt: any, invoiceId?: string | null, automatedTriggerType?: AutomatedTriggerType | null, deliveryStatus?: string | null }> };

export type CrmUsageErrorsQueryVariables = Exact<{ [key: string]: never; }>;


export type CrmUsageErrorsQuery = { crmUsageErrors: Array<{ _id: string, externalBookingId?: string | null, professionalId: string, usageType: CrmUsageType, messageType: CrmMessageType, createdAt: any, errorCode: string }> };

export type DeleteCrmUsageErrorsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteCrmUsageErrorsMutation = { deleteCrmUsageErrors: boolean };

export type GetTerminalSecretQueryVariables = Exact<{
  staticLocationId?: InputMaybe<Scalars['String']['input']>;
  externalBookingId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTerminalSecretQuery = { getTerminalSecret: { secret: string, locationId: string } };

export type CreateTerminalPaymentIntentQueryVariables = Exact<{
  data: CreateTerminalPaymentIntentInput;
}>;


export type CreateTerminalPaymentIntentQuery = { createTerminalPaymentIntent: { paymentIntentId: string, clientSecret: string } };

export type CaptureTerminalPaymentQueryVariables = Exact<{
  data: CaptureTerminalPaymentInput;
}>;


export type CaptureTerminalPaymentQuery = { captureTerminalPayment: { id?: string | null, error?: { code?: string | null, message?: string | null } | null, externalBooking?: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } | null } };

export type TerminalReadersQueryVariables = Exact<{ [key: string]: never; }>;


export type TerminalReadersQuery = { terminalReaders: Array<{ id: string, label: string, deviceType: string, serialNumber: string, status?: string | null, ipAddress?: string | null, locationId?: string | null, staticLocationId?: string | null, lastSeenAt?: any | null }> };

export type RegisterTerminalReaderMutationVariables = Exact<{
  data: RegisterTerminalReaderInput;
}>;


export type RegisterTerminalReaderMutation = { registerTerminalReader: { id: string, label: string, deviceType: string, serialNumber: string, status?: string | null, ipAddress?: string | null, locationId?: string | null, staticLocationId?: string | null, lastSeenAt?: any | null } };

export type RemoveTerminalReaderMutationVariables = Exact<{
  readerId: Scalars['String']['input'];
}>;


export type RemoveTerminalReaderMutation = { removeTerminalReader: boolean };

export type TerminalTipSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TerminalTipSettingsQuery = { terminalTipSettings: { percentages: Array<number> } };

export type UpdateTerminalTipSettingsMutationVariables = Exact<{
  data: UpdateTerminalTipSettingsInput;
}>;


export type UpdateTerminalTipSettingsMutation = { updateTerminalTipSettings: { percentages: Array<number> } };

export type GetStripeTransactionsQueryVariables = Exact<{
  filters: StripeTransactionsFilterInput;
}>;


export type GetStripeTransactionsQuery = { getStripeTransactions: Array<
    | { __typename: 'StripeTransactionFee', stripeChargeId: string, type: StripeTransactionType, amount: number, date: number, _id: string }
    | { __typename: 'StripeTransactionPayment', applicationFeeAmount?: number | null, description?: string | null, status: string, customerName?: string | null, paidOn?: number | null, stripeFee?: number | null, type: StripeTransactionType, amount: number, date: number, _id: string }
    | { __typename: 'StripeTransactionPayout', arrivalDate?: number | null, status: string, type: StripeTransactionType, amount: number, date: number, _id: string }
    | { __typename: 'StripeTransactionReferral', soloPayoutId: string, type: StripeTransactionType, amount: number, date: number, _id: string }
    | { __typename: 'StripeTransactionRefund', customerName?: string | null, paymentIntentId?: string | null, description?: string | null, type: StripeTransactionType, amount: number, date: number, _id: string }
    | { __typename: 'StripeTransactionSsPayout', status: string, type: StripeTransactionType, amount: number, date: number, _id: string }
  > };

export type StripeBalancesQueryVariables = Exact<{ [key: string]: never; }>;


export type StripeBalancesQuery = { stripeBalances: { availableNow: number, availableSoon: number, inTransit: number } };

export type GetProfessionalFromSaasUrlQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  professionalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProfessionalFromSaasUrlQuery = { getProfessionalFromSaasUrl?: { _id: string, webPages: Array<{ title: string, path: string }> } | null };

export type GetStripeTransactionDetailsQueryVariables = Exact<{
  data: StripeTransactionDetailsInput;
}>;


export type GetStripeTransactionDetailsQuery = { getStripeTransactionDetails: { externalBooking?: { _id?: string | null, title?: string | null, date?: any | null, totalDuration?: number | null } | null, crmInvoice?: { _id: string, startDate: any, endDate: any, usageLines: Array<{ ids: Array<string>, usageType: CrmUsageType }> } | null, rewards?: Array<{ rewardType: string, rewardDate: any, amount?: number | null }> | null, ssPayout?: { _id: string, status: string, amount: number, items: Array<{ bookingId?: string | null, adjustmentId?: string | null, amount?: number | null, date?: any | null, note?: string | null, type?: string | null } | null> } | null, giftCard?: { _id: string, code: string, amount: number, expirationDate: any, receiverEmail: string, message: string, senderEmail: string, status: GiftCardStatus, balance: number, transactions: Array<{ date: any, amount: number, type: GiftCardTransactionType, externalBookingId?: string | null }> } | null } };

export type GetAccountingDataQueryVariables = Exact<{
  data: AccountingDataInput;
}>;


export type GetAccountingDataQuery = { getAccountingData: { earnings: Array<{ total: number, accountingType: AccountingType }>, expenses: Array<{ total: number, accountingType: AccountingType }> } };

export type WebPageQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type WebPageQuery = { webPage?: { _id: string, title: string, path: string, group: string, order?: number | null, showPageNavigation: boolean, visibility: WebPageVisibility, headerBlock: { _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { type: WebPageBlockType, title?: string | null, titleSize?: number | null, text?: string | null, layout: number, shape: string, textPosition: string, textColor: string, borderStyle: string, imageUrl: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | Record<PropertyKey, never>
       }, seoSettings?: { metaTitle: string, metaDescription: string } | null, actionButton?: { content: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } } | null, blocks: Array<{ _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { label: string, url: string, title?: string | null, type: WebPageBlockType }
        | { layout: number, imageUrl: string, alt?: string | null, title?: string | null, titleSize?: number | null, text?: string | null, type: WebPageBlockType, filter: string, shape: string, textPosition: string, textColor: string, borderStyle: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | { layout: number, title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, alt: string, imageUrl: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, heading: string, text: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, iconName?: string | null, label: string, subtext?: string | null, url: string, linkType: WebPageBlockButtonType }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, text?: string | null, hideFullAddress?: boolean | null, locationId?: string | null, syncWithGoogle?: boolean | null, data?: { placeId: string, staticLocationLat: number, staticLocationLng: number, localBusinessData?: { address?: { street?: string | null, city?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null }
        | { layout: number, logos: Array<string>, title?: string | null, type: WebPageBlockType }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ alt: string, imageUrl: string }> }
        | { type: WebPageBlockType, title?: string | null, layout: number, reviewIds: Array<string>, reviewsDisplayType: WebPageExternalReviewsDisplay, data?: { reviews: Array<{ _id: string, rating: number, publicComment: string, privateComment: string, visible: boolean, externalClientName: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, layout: number, data?: { members: Array<{ _id: string, memberDisplayName?: string | null, picture?: string | null, title?: string | null }> } | null }
        | { text?: string | null, title?: string | null, type: WebPageBlockType, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { treatmentsListDisplayType: WebPageTreatmentListDisplayType, title?: string | null, type: WebPageBlockType, groupedCategories?: boolean | null, items: Array<{ _id: string }>, data?: { items: Array<{ _id: string, name: string, description: string, price: number, category: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | Record<PropertyKey, never>
       }> } | null };

export type CreateWebPageMutationVariables = Exact<{
  data: WebPageInput;
}>;


export type CreateWebPageMutation = { createWebPage: { _id: string, title: string, path: string, group: string, order?: number | null, showPageNavigation: boolean, visibility: WebPageVisibility, headerBlock: { _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { type: WebPageBlockType, title?: string | null, titleSize?: number | null, text?: string | null, layout: number, shape: string, textPosition: string, textColor: string, borderStyle: string, imageUrl: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | Record<PropertyKey, never>
       }, seoSettings?: { metaTitle: string, metaDescription: string } | null, actionButton?: { content: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } } | null, blocks: Array<{ _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { label: string, url: string, title?: string | null, type: WebPageBlockType }
        | { layout: number, imageUrl: string, alt?: string | null, title?: string | null, titleSize?: number | null, text?: string | null, type: WebPageBlockType, filter: string, shape: string, textPosition: string, textColor: string, borderStyle: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | { layout: number, title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, alt: string, imageUrl: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, heading: string, text: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, iconName?: string | null, label: string, subtext?: string | null, url: string, linkType: WebPageBlockButtonType }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, text?: string | null, hideFullAddress?: boolean | null, locationId?: string | null, syncWithGoogle?: boolean | null, data?: { placeId: string, staticLocationLat: number, staticLocationLng: number, localBusinessData?: { address?: { street?: string | null, city?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null }
        | { layout: number, logos: Array<string>, title?: string | null, type: WebPageBlockType }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ alt: string, imageUrl: string }> }
        | { type: WebPageBlockType, title?: string | null, layout: number, reviewIds: Array<string>, reviewsDisplayType: WebPageExternalReviewsDisplay, data?: { reviews: Array<{ _id: string, rating: number, publicComment: string, privateComment: string, visible: boolean, externalClientName: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, layout: number, data?: { members: Array<{ _id: string, memberDisplayName?: string | null, picture?: string | null, title?: string | null }> } | null }
        | { text?: string | null, title?: string | null, type: WebPageBlockType, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { treatmentsListDisplayType: WebPageTreatmentListDisplayType, title?: string | null, type: WebPageBlockType, groupedCategories?: boolean | null, items: Array<{ _id: string }>, data?: { items: Array<{ _id: string, name: string, description: string, price: number, category: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | Record<PropertyKey, never>
       }> } };

export type UpdateWebPageMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  data: WebPageInput;
}>;


export type UpdateWebPageMutation = { updateWebPage: { _id: string, title: string, path: string, group: string, order?: number | null, showPageNavigation: boolean, visibility: WebPageVisibility, headerBlock: { _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { type: WebPageBlockType, title?: string | null, titleSize?: number | null, text?: string | null, layout: number, shape: string, textPosition: string, textColor: string, borderStyle: string, imageUrl: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | Record<PropertyKey, never>
       }, seoSettings?: { metaTitle: string, metaDescription: string } | null, actionButton?: { content: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } } | null, blocks: Array<{ _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { label: string, url: string, title?: string | null, type: WebPageBlockType }
        | { layout: number, imageUrl: string, alt?: string | null, title?: string | null, titleSize?: number | null, text?: string | null, type: WebPageBlockType, filter: string, shape: string, textPosition: string, textColor: string, borderStyle: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | { layout: number, title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, alt: string, imageUrl: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, heading: string, text: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, iconName?: string | null, label: string, subtext?: string | null, url: string, linkType: WebPageBlockButtonType }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, text?: string | null, hideFullAddress?: boolean | null, locationId?: string | null, syncWithGoogle?: boolean | null, data?: { placeId: string, staticLocationLat: number, staticLocationLng: number, localBusinessData?: { address?: { street?: string | null, city?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null }
        | { layout: number, logos: Array<string>, title?: string | null, type: WebPageBlockType }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ alt: string, imageUrl: string }> }
        | { type: WebPageBlockType, title?: string | null, layout: number, reviewIds: Array<string>, reviewsDisplayType: WebPageExternalReviewsDisplay, data?: { reviews: Array<{ _id: string, rating: number, publicComment: string, privateComment: string, visible: boolean, externalClientName: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, layout: number, data?: { members: Array<{ _id: string, memberDisplayName?: string | null, picture?: string | null, title?: string | null }> } | null }
        | { text?: string | null, title?: string | null, type: WebPageBlockType, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { treatmentsListDisplayType: WebPageTreatmentListDisplayType, title?: string | null, type: WebPageBlockType, groupedCategories?: boolean | null, items: Array<{ _id: string }>, data?: { items: Array<{ _id: string, name: string, description: string, price: number, category: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | Record<PropertyKey, never>
       }> } };

export type DeleteWebPageMutationVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type DeleteWebPageMutation = { deleteWebPage: boolean };

export type WebPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type WebPagesQuery = { webPages: Array<{ _id: string, title: string, path: string, group: string, order?: number | null, showPageNavigation: boolean, visibility: WebPageVisibility, headerBlock: { _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { type: WebPageBlockType, title?: string | null, titleSize?: number | null, text?: string | null, layout: number, shape: string, textPosition: string, textColor: string, borderStyle: string, imageUrl: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | Record<PropertyKey, never>
       }, seoSettings?: { metaTitle: string, metaDescription: string } | null, actionButton?: { content: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } } | null, blocks: Array<{ _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { label: string, url: string, title?: string | null, type: WebPageBlockType }
        | { layout: number, imageUrl: string, alt?: string | null, title?: string | null, titleSize?: number | null, text?: string | null, type: WebPageBlockType, filter: string, shape: string, textPosition: string, textColor: string, borderStyle: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | { layout: number, title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, alt: string, imageUrl: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, heading: string, text: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, iconName?: string | null, label: string, subtext?: string | null, url: string, linkType: WebPageBlockButtonType }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, text?: string | null, hideFullAddress?: boolean | null, locationId?: string | null, syncWithGoogle?: boolean | null, data?: { placeId: string, staticLocationLat: number, staticLocationLng: number, localBusinessData?: { address?: { street?: string | null, city?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null }
        | { layout: number, logos: Array<string>, title?: string | null, type: WebPageBlockType }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ alt: string, imageUrl: string }> }
        | { type: WebPageBlockType, title?: string | null, layout: number, reviewIds: Array<string>, reviewsDisplayType: WebPageExternalReviewsDisplay, data?: { reviews: Array<{ _id: string, rating: number, publicComment: string, privateComment: string, visible: boolean, externalClientName: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, layout: number, data?: { members: Array<{ _id: string, memberDisplayName?: string | null, picture?: string | null, title?: string | null }> } | null }
        | { text?: string | null, title?: string | null, type: WebPageBlockType, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { treatmentsListDisplayType: WebPageTreatmentListDisplayType, title?: string | null, type: WebPageBlockType, groupedCategories?: boolean | null, items: Array<{ _id: string }>, data?: { items: Array<{ _id: string, name: string, description: string, price: number, category: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | Record<PropertyKey, never>
       }> }> };

export type CreateDefaultWebPagesMutationVariables = Exact<{
  businessType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDefaultWebPagesMutation = { createDefaultWebPages: Array<{ _id: string, title: string, path: string, group: string, order?: number | null, showPageNavigation: boolean, visibility: WebPageVisibility, headerBlock: { _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { type: WebPageBlockType, title?: string | null, titleSize?: number | null, text?: string | null, layout: number, shape: string, textPosition: string, textColor: string, borderStyle: string, imageUrl: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | Record<PropertyKey, never>
       }, seoSettings?: { metaTitle: string, metaDescription: string } | null, actionButton?: { content: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } } | null, blocks: Array<{ _id: string, type: WebPageBlockType, color: WebPageBlockColor, content:
        | { label: string, url: string, title?: string | null, type: WebPageBlockType }
        | { layout: number, imageUrl: string, alt?: string | null, title?: string | null, titleSize?: number | null, text?: string | null, type: WebPageBlockType, filter: string, shape: string, textPosition: string, textColor: string, borderStyle: string, showReviews?: boolean | null, isPageHeader: boolean, imageBorderWidth: number, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean }, secondaryButton?: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } | null, data?: { breadcrumbs?: Array<{ name: string, path: string }> | null } | null }
        | { layout: number, title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, alt: string, imageUrl: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, heading: string, text: string }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ _id: string, iconName?: string | null, label: string, subtext?: string | null, url: string, linkType: WebPageBlockButtonType }>, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, text?: string | null, hideFullAddress?: boolean | null, locationId?: string | null, syncWithGoogle?: boolean | null, data?: { placeId: string, staticLocationLat: number, staticLocationLng: number, localBusinessData?: { address?: { street?: string | null, city?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null }
        | { layout: number, logos: Array<string>, title?: string | null, type: WebPageBlockType }
        | { title?: string | null, type: WebPageBlockType, items: Array<{ alt: string, imageUrl: string }> }
        | { type: WebPageBlockType, title?: string | null, layout: number, reviewIds: Array<string>, reviewsDisplayType: WebPageExternalReviewsDisplay, data?: { reviews: Array<{ _id: string, rating: number, publicComment: string, privateComment: string, visible: boolean, externalClientName: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { type: WebPageBlockType, title?: string | null, layout: number, data?: { members: Array<{ _id: string, memberDisplayName?: string | null, picture?: string | null, title?: string | null }> } | null }
        | { text?: string | null, title?: string | null, type: WebPageBlockType, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | { treatmentsListDisplayType: WebPageTreatmentListDisplayType, title?: string | null, type: WebPageBlockType, groupedCategories?: boolean | null, items: Array<{ _id: string }>, data?: { items: Array<{ _id: string, name: string, description: string, price: number, category: string }> } | null, button: { label?: string | null, url?: string | null, linkType: WebPageBlockButtonType, showButton: boolean } }
        | Record<PropertyKey, never>
       }> }> };

export type Dev_RemoveAllWebPagesMutationVariables = Exact<{ [key: string]: never; }>;


export type Dev_RemoveAllWebPagesMutation = { dev_RemoveAllWebPages: boolean };

export type GetLoyaltySchemesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoyaltySchemesQuery = { getLoyaltySchemes: Array<{ _id: string, professionalId: string, status: LoyaltySchemeStatus, startDate: any, goal: LoyaltySchemeGoalType, goalNumber: number, minBookingFee: number, applyToAllClients: boolean, externalClientIds: Array<string>, createdAt?: any | null, updatedAt?: any | null, schemeUsage?: LoyaltySchemeUsageType | null, promoCodeSettings: { discountAmount: number, discountType: string, validityDays: number, applyToAllTreatments: boolean, treatmentIds: Array<string> }, referralCodeSettings?: { discountAmount: number, discountType: string, validityDays: number, applyToAllTreatments: boolean, treatmentIds: Array<string> } | null }> };

export type UpdateLoyaltySchemeMutationVariables = Exact<{
  scheme: LoyaltySchemeInput;
}>;


export type UpdateLoyaltySchemeMutation = { updateLoyaltyScheme: { _id: string, professionalId: string, status: LoyaltySchemeStatus, startDate: any, goal: LoyaltySchemeGoalType, goalNumber: number, minBookingFee: number, applyToAllClients: boolean, externalClientIds: Array<string>, createdAt?: any | null, updatedAt?: any | null, schemeUsage?: LoyaltySchemeUsageType | null, promoCodeSettings: { discountAmount: number, discountType: string, validityDays: number, applyToAllTreatments: boolean, treatmentIds: Array<string> }, referralCodeSettings?: { discountAmount: number, discountType: string, validityDays: number, applyToAllTreatments: boolean, treatmentIds: Array<string> } | null } };

export type CreateLoyaltySchemeMutationVariables = Exact<{
  scheme: LoyaltySchemeInput;
}>;


export type CreateLoyaltySchemeMutation = { createLoyaltyScheme: { _id: string, professionalId: string, status: LoyaltySchemeStatus, startDate: any, goal: LoyaltySchemeGoalType, goalNumber: number, minBookingFee: number, applyToAllClients: boolean, externalClientIds: Array<string>, createdAt?: any | null, updatedAt?: any | null, schemeUsage?: LoyaltySchemeUsageType | null, promoCodeSettings: { discountAmount: number, discountType: string, validityDays: number, applyToAllTreatments: boolean, treatmentIds: Array<string> }, referralCodeSettings?: { discountAmount: number, discountType: string, validityDays: number, applyToAllTreatments: boolean, treatmentIds: Array<string> } | null } };

export type CampaignsForLoyaltySchemeQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignsForLoyaltySchemeQuery = { campaignsForLoyaltyScheme: { emails: Array<{ _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, emailSubject: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null, themeColors: { themePrimary: string, themeBackground: string, themeTextColor: string, contrastTextColor: string }, emailContent: Array<{ _id: string, blockType: EmailContentBlockType, text: string, url?: string | null, data?: { promocodeId?: string | null } | null }> }>, sms: Array<{ _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, messageContent: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null }>, automatedCampaigns: Array<{ campaignId: string, triggerType: AutomatedTriggerType, daysOffset: number, active: boolean, sendAtHour: number, messageType: CampaignMessageType, sendLog: Array<{ date: any, sentCount: number, errors: Array<string> }> }> } };

export type CampaignsForClientReferralSchemeQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignsForClientReferralSchemeQuery = { campaignsForClientReferralScheme: { emails: Array<{ _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, emailSubject: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null, themeColors: { themePrimary: string, themeBackground: string, themeTextColor: string, contrastTextColor: string }, emailContent: Array<{ _id: string, blockType: EmailContentBlockType, text: string, url?: string | null, data?: { promocodeId?: string | null } | null }> }>, sms: Array<{ _id: string, label: string, scheduledFor?: any | null, customRecipientIds: Array<string>, applyToAllClients: boolean, recipientClientGroups: Array<ExternalClientGroups>, type: CampaignType, messageType: CampaignMessageType, lastSentAt?: any | null, createdAt: any, messageContent: string, status: CampaignStatus, sentCount: number, triggerType?: AutomatedTriggerType | null }>, automatedCampaigns: Array<{ campaignId: string, triggerType: AutomatedTriggerType, daysOffset: number, active: boolean, sendAtHour: number, messageType: CampaignMessageType, sendLog: Array<{ date: any, sentCount: number, errors: Array<string> }> }> } };

export type ActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivitiesQuery = { activities: Array<{ _id: string, activityId: string, status: ActivityStatus, professionalId: string, priority: number, title: string, body?: string | null, link: string, icon: string, iconColor: string, expiryDate: any, persistAfterInteraction: boolean }> };

export type UpdateActivityStatusMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  status: ActivityStatus;
}>;


export type UpdateActivityStatusMutation = { updateActivityStatus: Array<{ _id: string, activityId: string, status: ActivityStatus, professionalId: string, priority: number, title: string, body?: string | null, link: string, icon: string, iconColor: string, expiryDate: any, persistAfterInteraction: boolean }> };

export type ExternalGiftCardsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']['input']>;
  sort?: InputMaybe<Scalars['JSONObject']['input']>;
  pagination?: InputMaybe<Pagination>;
}>;


export type ExternalGiftCardsQuery = { externalGiftCards: Array<{ _id: string, code: string, amount: number, expirationDate: any, receiverEmail: string, message: string, senderEmail: string, status: GiftCardStatus, balance: number, transactions: Array<{ date: any, amount: number, type: GiftCardTransactionType, externalBookingId?: string | null }> }> };

export type ExternalGiftCardQueryVariables = Exact<{
  _id: Scalars['String']['input'];
}>;


export type ExternalGiftCardQuery = { externalGiftCard?: { _id: string, code: string, amount: number, expirationDate: any, receiverEmail: string, message: string, senderEmail: string, status: GiftCardStatus, balance: number, transactions: Array<{ date: any, amount: number, type: GiftCardTransactionType, externalBookingId?: string | null }> } | null };

export type RefundExternalGiftCardMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
}>;


export type RefundExternalGiftCardMutation = { refundExternalGiftCard: { _id: string, code: string, amount: number, expirationDate: any, receiverEmail: string, message: string, senderEmail: string, status: GiftCardStatus, balance: number, transactions: Array<{ date: any, amount: number, type: GiftCardTransactionType, externalBookingId?: string | null }> } };

export type ApplyExternalGiftCardMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  externalBookingId: Scalars['String']['input'];
}>;


export type ApplyExternalGiftCardMutation = { applyExternalGiftCard: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type CreateExternalGiftCardMutationVariables = Exact<{
  data: CreateExternalGiftCardInput;
}>;


export type CreateExternalGiftCardMutation = { createExternalGiftCard?: { _id: string, code: string, amount: number, expirationDate: any, receiverEmail: string, message: string, senderEmail: string, status: GiftCardStatus, balance: number, transactions: Array<{ date: any, amount: number, type: GiftCardTransactionType, externalBookingId?: string | null }> } | null };

export type UpdateExternalGiftCardMutationVariables = Exact<{
  data: UpdateExternalGiftCardInput;
}>;


export type UpdateExternalGiftCardMutation = { updateExternalGiftCard?: { _id: string, code: string, amount: number, expirationDate: any, receiverEmail: string, message: string, senderEmail: string, status: GiftCardStatus, balance: number, transactions: Array<{ date: any, amount: number, type: GiftCardTransactionType, externalBookingId?: string | null }> } | null };

export type RefundExternalGiftCardPaymentMutationVariables = Exact<{
  _id: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  externalBookingId: Scalars['String']['input'];
}>;


export type RefundExternalGiftCardPaymentMutation = { refundExternalGiftCardPayment: { _id?: string | null, professionalId?: string | null, date?: any | null, color?: string | null, title?: string | null, notes?: string | null, totalFee?: number | null, feeAtBookingTime?: number | null, serviceFeePercentage?: number | null, totalDuration?: number | null, address?: any | null, clientDetails?: any | null, timezone?: string | null, externalReviewId?: string | null, externalClientId?: string | null, type?: string | null, bufferTime?: number | null, status?: ExternalBookingStatus | null, source?: ExternalBookingSource | null, newCustomer?: boolean | null, sourceName?: string | null, platformCommission?: number | null, depositPercentage?: number | null, paymentMethod?: PaymentMethodOptionId | null, cancellationText?: string | null, cancellationReason?: CancellationReason | null, consultationFormStatus?: ConsultationFormStatus | null, consultationFormSectionIds?: Array<string> | null, businessName: string, paymentStatus?: ExternalBookingPaymentStatus | null, promocodeId?: string | null, repeats?: Array<string> | null, termsAndConditionsAccepted?: boolean | null, calendarId?: string | null, depositRequired?: string | null, useFixedAmount?: boolean | null, updatedAt?: any | null, createdAt?: any | null, originalBookingId?: string | null, rescheduleBookingId?: string | null, rescheduleType?: RescheduleType | null, rescheduleReason?: string | null, emailUpdatesEnabled?: boolean | null, isProfessionalAddress?: boolean | null, allocatedProfessionalId?: string | null, externalReview?: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } | null, externalClient?: { _id: string, lastName: string, firstName: string, mobile: string, emailAddress: string, tags: Array<string>, addresses: Array<any>, notes: string, color: string, gender: string, professionalId?: string | null, birthday?: any | null, blocked?: boolean | null, stripeCustomerId?: string | null, isRedacted: boolean, deletedAt?: any | null, stats?: { acceptedOrCompletedBookings: number, totalSpend: number, averageSpend: number, lastBookedDate?: any | null, noShows: number } | null, notifications: { emailCrm?: boolean | null, smsCrm?: boolean | null, emailUpdates?: boolean | null, smsUpdates?: boolean | null }, loyaltyProgress?: Array<{ loyaltySchemeId: string, current: number, totalRedeems: number }> | null } | null, items: Array<{ _id: string, treatmentId?: string | null, name: string, fee: number, duration: number, category?: string | null, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null }>, payments?: Array<{ sessionId: string, amount: number, type?: string | null, description?: string | null, paymentIntent?: string | null, updatedAt?: any | null, externalPaymentId?: string | null, amountRefunded?: number | null, stripeType?: string | null } | null> | null, activityLog?: Array<{ title: string, date: any, properties?: { amount?: number | null, paymentType?: string | null } | null } | null> | null, promocodeDiscount?: { amount: number, type: string, code: string } | null } };

export type SearchExternalGiftCardsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchExternalGiftCardsQuery = { searchExternalGiftCards: Array<{ _id: string, code: string, amount: number, expirationDate: any, receiverEmail: string, message: string, senderEmail: string, status: GiftCardStatus, balance: number, transactions: Array<{ date: any, amount: number, type: GiftCardTransactionType, externalBookingId?: string | null }> }> };

export type EstimateSmsCampaignCostQueryVariables = Exact<{
  data: EstimateSmsCampaignCostInput;
}>;


export type EstimateSmsCampaignCostQuery = { estimateSmsCampaignCost: number };

export type GetHtmlForBlocksQueryVariables = Exact<{
  data: GetHtmlForBlocksInput;
}>;


export type GetHtmlForBlocksQuery = { getHTMLForBlocks: Array<string> };

export type GetEmailTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailTemplatesQuery = { getEmailTemplates: { version: number, emailTemplates: any } };

export type ConnectGoogleAuthUrlQueryVariables = Exact<{
  service: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConnectGoogleAuthUrlQuery = { connectGoogleAuthUrl?: string | null };

export type DisconnectGoogleAuthMutationVariables = Exact<{
  service: Scalars['String']['input'];
}>;


export type DisconnectGoogleAuthMutation = { disconnectGoogleAuth: { _id: string, role?: AuthRole | null, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, emailConfirmed?: boolean | null, guestKey?: string | null, mobile?: string | null, mobileConfirmed?: boolean | null, gender?: string | null, genderSelfDescription?: string | null, stripeConnectedAccount?: string | null, stripePayoutEnabled?: boolean | null, stripeAccountStatus?: string | null, stripePayoutInterval?: string | null, soloServiceFee?: number | null, acceptedTermsPA?: boolean | null, acceptedTermsSaaS?: boolean | null, lastHealthPPECheck?: any | null, healthPPEConfirmed?: boolean | null, profileUrl?: string | null, blocked?: boolean | null, createdAt?: any | null, referralCode?: string | null, attributionData?: any | null, soloReferralId?: string | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, stripeLimits?: { tapToPay?: number | null, dailyTransactions?: number | null } | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, information?: any | null, createdAt?: any | null, genderPreference?: string | null, saasProfileUrl?: string | null, averageExternalReview: number, externalReviewCount: number, completedSetupSteps: Array<string>, completedSetupTasks: Array<string>, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, saasSettings?: { bookNowUrl?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, businessName?: string | null, salonMemberOnly?: boolean | null, subtext?: string | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, isPublic?: boolean | null, themePrimary?: string | null, themeBackground?: string | null, themeTextColor?: string | null, emailThemeBackground?: string | null, emailThemeTextColor?: string | null, emailThemePrimary?: string | null, requireTermsAndConditions?: boolean | null, receiveClientEmails?: boolean | null, branding?: any | null, requestsBlockCalendar?: boolean | null, defaultPaymentMethod?: PaymentMethodOptionId | null, defaultCancellationText?: string | null, linkDescription?: string | null, treatmentCategoriesOrder?: Array<string> | null, treatmentsDisplayName?: string | null, pinnedReviewId?: string | null, requireBirthday?: boolean | null, requireBirthdayExplaination?: string | null, rescheduleRequestsEnabled?: boolean | null, reschedulingTimeFrame?: number | null, themeSettings: { colorPrimary: string, colorSecondary: string, colorNeutralLight: string, colorNeutralDark: string, cornerStyle: string, shadowStyle: string, titlesFont: string, titlesMotif: string, bodyFont: string }, features?: { hours?: string | null } | null, lookBook?: Array<{ imageUrl: string, caption: string }> | null, info: Array<{ title: string, body: string }>, mobileLocation?: { _id: string, enabled: boolean, fee: number, summary?: string | null, travelDistanceMiles?: number | null, externalAddressId?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null, requestParkingInformation?: boolean | null } | null, staticLocations?: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> | null, paymentMethods?: Array<{ label: string, type: SaasPaymentMethodType }> | null, contactDetails?: Array<{ type: ContactType, value: string }> | null, clientDepositSettings?: Array<{ clientType: string, depositRequired: string, depositAmount: number, useFixedAmount?: boolean | null, disableApplePay?: boolean | null }> | null, seoSettings?: { metaTitle: string, metaDescription: string, pageH1: string, pageH2: string } | null, localBusinessVisibility?: { addressVisibility?: FooterAddressVisibilityOption | null, showPhoneNumber?: boolean | null } | null } | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null, giftCardSettings?: { enabled: boolean, daysBeforeExpires: number } | null } | null, stripeCapabilities?: { card_payments?: string | null, transfers?: string | null } | null, subscriptionDetails?: { chargeBeeId?: string | null, entitlementOverrides?: Array<string> | null, isUpdating?: number | null, saasBookingsThisPeriod?: { value?: number | null } | null, trialExtensions?: Array<{ date: any, plan: string }> | null, saasReceipts?: Array<{ productId?: string | null, token?: string | null }> | null, saasSubscriptions?: Array<{ plan: string, status: string, platform: SoloSubscriptionPlatform, nextBilling?: any | null, planType: PlanType, couponIds: Array<string>, totalDiscount?: number | null, inTrial?: boolean | null, trialEnd?: any | null, trialStart?: any | null, entitlements: Array<{ id?: string | null, value?: string | null }> }> | null, entitlements?: Array<{ id?: string | null, value?: string | null, enabled?: boolean | null, updatedAt?: any | null, lastActiveAt?: any | null }> | null } | null, googleBusinessAuth?: { refreshToken: string, accessToken: string, selectedLocationId?: string | null, selectedAccountId?: string | null, scopes: Array<string>, placeId?: string | null, localBusinessSchemaData?: { name?: string | null } | null } | null, googleCalendarAuth?: { refreshToken: string, accessToken: string, calendarId?: string | null } | null } };

export type GetGoogleBusinessDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoogleBusinessDetailsQuery = { getGoogleBusinessDetails: Array<{ name: string, accountName: string, type: string, verificationState: string, vettedState: string, locations: Array<{ name: string, title: string, storefrontAddress?: any | null, websiteUri?: string | null, placeId?: string | null, mapsUri?: string | null }> }> };

export type SelectGoogleBusinessAccountLocationMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  placeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SelectGoogleBusinessAccountLocationMutation = { selectGoogleBusinessAccountLocation: { _id: string, role?: AuthRole | null, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, emailConfirmed?: boolean | null, guestKey?: string | null, mobile?: string | null, mobileConfirmed?: boolean | null, gender?: string | null, genderSelfDescription?: string | null, stripeConnectedAccount?: string | null, stripePayoutEnabled?: boolean | null, stripeAccountStatus?: string | null, stripePayoutInterval?: string | null, soloServiceFee?: number | null, acceptedTermsPA?: boolean | null, acceptedTermsSaaS?: boolean | null, lastHealthPPECheck?: any | null, healthPPEConfirmed?: boolean | null, profileUrl?: string | null, blocked?: boolean | null, createdAt?: any | null, referralCode?: string | null, attributionData?: any | null, soloReferralId?: string | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, stripeLimits?: { tapToPay?: number | null, dailyTransactions?: number | null } | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, information?: any | null, createdAt?: any | null, genderPreference?: string | null, saasProfileUrl?: string | null, averageExternalReview: number, externalReviewCount: number, completedSetupSteps: Array<string>, completedSetupTasks: Array<string>, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, saasSettings?: { bookNowUrl?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, businessName?: string | null, salonMemberOnly?: boolean | null, subtext?: string | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, isPublic?: boolean | null, themePrimary?: string | null, themeBackground?: string | null, themeTextColor?: string | null, emailThemeBackground?: string | null, emailThemeTextColor?: string | null, emailThemePrimary?: string | null, requireTermsAndConditions?: boolean | null, receiveClientEmails?: boolean | null, branding?: any | null, requestsBlockCalendar?: boolean | null, defaultPaymentMethod?: PaymentMethodOptionId | null, defaultCancellationText?: string | null, linkDescription?: string | null, treatmentCategoriesOrder?: Array<string> | null, treatmentsDisplayName?: string | null, pinnedReviewId?: string | null, requireBirthday?: boolean | null, requireBirthdayExplaination?: string | null, rescheduleRequestsEnabled?: boolean | null, reschedulingTimeFrame?: number | null, themeSettings: { colorPrimary: string, colorSecondary: string, colorNeutralLight: string, colorNeutralDark: string, cornerStyle: string, shadowStyle: string, titlesFont: string, titlesMotif: string, bodyFont: string }, features?: { hours?: string | null } | null, lookBook?: Array<{ imageUrl: string, caption: string }> | null, info: Array<{ title: string, body: string }>, mobileLocation?: { _id: string, enabled: boolean, fee: number, summary?: string | null, travelDistanceMiles?: number | null, externalAddressId?: string | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultTravelTime?: number | null, useTravelTime?: boolean | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null, requestParkingInformation?: boolean | null } | null, staticLocations?: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> | null, paymentMethods?: Array<{ label: string, type: SaasPaymentMethodType }> | null, contactDetails?: Array<{ type: ContactType, value: string }> | null, clientDepositSettings?: Array<{ clientType: string, depositRequired: string, depositAmount: number, useFixedAmount?: boolean | null, disableApplePay?: boolean | null }> | null, seoSettings?: { metaTitle: string, metaDescription: string, pageH1: string, pageH2: string } | null, localBusinessVisibility?: { addressVisibility?: FooterAddressVisibilityOption | null, showPhoneNumber?: boolean | null } | null } | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null, giftCardSettings?: { enabled: boolean, daysBeforeExpires: number } | null } | null, stripeCapabilities?: { card_payments?: string | null, transfers?: string | null } | null, subscriptionDetails?: { chargeBeeId?: string | null, entitlementOverrides?: Array<string> | null, isUpdating?: number | null, saasBookingsThisPeriod?: { value?: number | null } | null, trialExtensions?: Array<{ date: any, plan: string }> | null, saasReceipts?: Array<{ productId?: string | null, token?: string | null }> | null, saasSubscriptions?: Array<{ plan: string, status: string, platform: SoloSubscriptionPlatform, nextBilling?: any | null, planType: PlanType, couponIds: Array<string>, totalDiscount?: number | null, inTrial?: boolean | null, trialEnd?: any | null, trialStart?: any | null, entitlements: Array<{ id?: string | null, value?: string | null }> }> | null, entitlements?: Array<{ id?: string | null, value?: string | null, enabled?: boolean | null, updatedAt?: any | null, lastActiveAt?: any | null }> | null } | null, googleBusinessAuth?: { refreshToken: string, accessToken: string, selectedLocationId?: string | null, selectedAccountId?: string | null, scopes: Array<string>, placeId?: string | null, localBusinessSchemaData?: { name?: string | null } | null } | null, googleCalendarAuth?: { refreshToken: string, accessToken: string, calendarId?: string | null } | null } };

export type ImportGoogleReviewsMutationVariables = Exact<{
  minRating: Scalars['Int']['input'];
}>;


export type ImportGoogleReviewsMutation = { importGoogleReviews: boolean };

export type DeleteImportedGoogleReviewsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteImportedGoogleReviewsMutation = { deleteImportedGoogleReviews: boolean };

export type VerifyMagicLinkTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyMagicLinkTokenMutation = { verifyMagicLinkToken: { authToken?: { role: AuthRole, auth: string } | null, user?: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } | null } };

export type GetMagicLinkTokenInfoQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetMagicLinkTokenInfoQuery = { getMagicLinkTokenInfo?: { email: string, userId: string } | null };

export type SendMagicLinkEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  adminEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendMagicLinkEmailMutation = { sendMagicLinkEmail: boolean };

export type GetGoogleStatsQueryVariables = Exact<{
  periods: Array<PeriodsInput> | PeriodsInput;
  testProfileUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGoogleStatsQuery = { getGoogleStats: { currentPeriod: { analytics: Array<{ keys: Array<string>, clicks: number, impressions: number, ctr: number, position: number }>, searchTerms: Array<{ keys: Array<string>, clicks: number, impressions: number, ctr: number, position: number }> }, previousPeriod: { analytics: Array<{ keys: Array<string>, clicks: number, impressions: number, ctr: number, position: number }>, searchTerms: Array<{ keys: Array<string>, clicks: number, impressions: number, ctr: number, position: number }> } } };

export type GetIncomeStatsQueryVariables = Exact<{
  input: IncomeStatsInput;
}>;


export type GetIncomeStatsQuery = { getIncomeStats: Array<{ day: string, income: number, bookings: number }> };

export type GetStatsOverviewQueryVariables = Exact<{
  periods: Array<PeriodsInput> | PeriodsInput;
  memberId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStatsOverviewQuery = { getStatsOverview: { topKeywords: Array<string>, averageBookingDiscount: { currentPeriod: number, previousPeriod: number }, averageBookingHourlyRate: { currentPeriod: number, previousPeriod: number }, averageBookingValue: { currentPeriod: number, previousPeriod: number }, clicks: { currentPeriod: number, previousPeriod: number }, completedBookings: { currentPeriod: number, previousPeriod: number }, impressions: { currentPeriod: number, previousPeriod: number }, newBookings: { currentPeriod: number, previousPeriod: number }, repeatBookings: { currentPeriod: number, previousPeriod: number }, websiteBookings: { currentPeriod: number, previousPeriod: number }, websiteConversionRate: { currentPeriod: number, previousPeriod: number }, websiteVisits: { currentPeriod: number, previousPeriod: number } } };

export type ProfessionalImageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProfessionalImageQuery = { professionalImage: { _id: string, url: string, professionalId: string, createdAt: any, updatedAt: any } };

export type ProfessionalImagesByProfessionalQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfessionalImagesByProfessionalQuery = { professionalImagesByProfessional: Array<{ _id: string, url: string, professionalId: string, createdAt: any, updatedAt: any }> };

export type CreateProfessionalImageMutationVariables = Exact<{
  input: ProfessionalImageInput;
}>;


export type CreateProfessionalImageMutation = { createProfessionalImage: { _id: string, url: string, professionalId: string, createdAt: any, updatedAt: any } };

export type DeleteProfessionalImageMutationVariables = Exact<{
  input: DeleteProfessionalImageInput;
}>;


export type DeleteProfessionalImageMutation = { deleteProfessionalImage: { _id: string, url: string, professionalId: string, createdAt: any, updatedAt: any } };

export type FindPageReferencesQueryVariables = Exact<{
  path: Scalars['String']['input'];
  professionalId: Scalars['String']['input'];
}>;


export type FindPageReferencesQuery = { findPageReferences: { totalCount: number } };

export type GetFeesPerCountryQueryVariables = Exact<{
  currency: Scalars['String']['input'];
}>;


export type GetFeesPerCountryQuery = { getFeesPerCountry: { terminal: { percentage: number, fixed: number }, online: { percentage: number, fixed: number } } };

export type ExtendTrialMutationVariables = Exact<{
  data: ExtendTrialInput;
}>;


export type ExtendTrialMutation = { extendTrial: boolean };

export type SeoAnalysisQueryVariables = Exact<{
  analysisText: SeoPageDataText;
  location: Scalars['String']['input'];
  primaryKeywords: Array<Scalars['String']['input']> | Scalars['String']['input'];
  secondaryKeywords: Array<Scalars['String']['input']> | Scalars['String']['input'];
  businessName: Scalars['String']['input'];
}>;


export type SeoAnalysisQuery = { seoAnalysis: { rank: number, improvementSuggestion: string, alternatives: Array<string> } };

export type GetBusinessProfileDataQueryVariables = Exact<{
  useRandomData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBusinessProfileDataQuery = { getBusinessProfileData?: { _id: string, reviewsWithTextCount: number, reviewsWithin60DaysCount: number, averageRating?: number | null, reviewResponseRate?: number | null, photosCount: number, clientPhotosCount: number, photosWithin60DaysCount: number, postsCount: number, lastPostDate?: any | null, hasDescription: boolean, hasAddress: boolean, hasWebsite: boolean, isVerified: boolean, hasOpeningHours: boolean, servicesCount: number, hasPrimaryCategory: boolean, createdAt: any, professionalId: string, updatedAt: any, fetchedAt: any } | null };

export type ThemePresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type ThemePresetsQuery = { themePresets: Array<{ name: string, blockColor: WebPageBlockColor, themeSettings: { colorPrimary: string, colorSecondary: string, colorNeutralLight: string, colorNeutralDark: string, cornerStyle: string, shadowStyle: string, titlesFont: string, titlesMotif: string, bodyFont: string }, headerBlockSettings: { filter: string, imageBorderWidth: number, titleSize: number, shape: string, textPosition: string, textColor: string, borderStyle: string, showReviews: boolean, noImage?: boolean | null } }> };

export type ScrapeUrlMutationVariables = Exact<{
  url: Scalars['String']['input'];
  onboardingId: Scalars['String']['input'];
}>;


export type ScrapeUrlMutation = { scrapeUrl?: { stageTimings?: any | null, items: Array<{ _id: string, name: string, price: number, category: string, duration: number, bufferTime: number, showOnPortal: boolean, description: string, order?: number | null, professionalId?: string | null, locations: Array<{ locationId: string, enabled: boolean, price?: number | null }>, schedule?: Array<{ duration: number, type: ScheduleEntryType, description?: string | null }> | null, memberOverrides: Array<{ professionalId: string, price?: number | null, duration?: number | null, canPerformTreatment: boolean }> }>, pageInfo: { about: string, businessName: string, galleryImages: Array<string> } } | null };

export type ResetAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetAccountMutation = { resetAccount: boolean };

export type ReplyToGoogleReviewMutationVariables = Exact<{
  reviewId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type ReplyToGoogleReviewMutation = { replyToGoogleReview: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } };

export type DeleteGoogleReviewReplyMutationVariables = Exact<{
  reviewId: Scalars['String']['input'];
}>;


export type DeleteGoogleReviewReplyMutation = { deleteGoogleReviewReply: { _id: string, professionalId: string, externalBookingId?: string | null, secretSpaReviewId?: string | null, externalClientName: string, rating: number, publicComment: string, privateComment: string, visible: boolean, createdAt?: any | null, googleReviewId?: string | null, googleReviewReplyComment?: string | null, googleReviewReplyUpdateTime?: any | null } };

export type SuggestReviewRepliesMutationVariables = Exact<{
  reviewText: Scalars['String']['input'];
  toneOfVoice: ReviewReplyTone;
  starRating?: InputMaybe<Scalars['Int']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  reviewerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuggestReviewRepliesMutation = { suggestReviewReplies: { suggestion: string } };

export type UpdateSalonMemberPermissionsMutationVariables = Exact<{
  salonMemberId: Scalars['String']['input'];
  permissions: Array<SalonMemberPermission> | SalonMemberPermission;
}>;


export type UpdateSalonMemberPermissionsMutation = { updateSalonMemberPermissions: { _id: string, salonId: string, memberId: string, permissions: Array<SalonMemberPermission>, displayName: string } };

export type UpdateSalonMemberMutationVariables = Exact<{
  salonMemberId: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  completedOnboardingSteps?: InputMaybe<Array<SalonMemberOnboardingStep> | SalonMemberOnboardingStep>;
}>;


export type UpdateSalonMemberMutation = { updateSalonMember: { _id: string, color: string, displayName: string, picture?: string | null, title?: string | null, memberId: string, salonId: string, permissions: Array<SalonMemberPermission>, completedOnboardingSteps: Array<SalonMemberOnboardingStep> } };

export type CreateSalonReceptionistAccountMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  color: Scalars['String']['input'];
}>;


export type CreateSalonReceptionistAccountMutation = { createSalonReceptionistAccount: { _id: string, name: string, email: string, createdAt?: any | null } };

export type UpdateSalonReceptionistAccountMutationVariables = Exact<{
  salonMemberId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSalonReceptionistAccountMutation = { updateSalonReceptionistAccount: { _id: string, name: string, email: string, createdAt?: any | null } };

export type ArchiveSalonMemberMutationVariables = Exact<{
  salonMemberId: Scalars['String']['input'];
}>;


export type ArchiveSalonMemberMutation = { archiveSalonMember: boolean };

export type RestoreSalonMemberMutationVariables = Exact<{
  salonMemberId: Scalars['String']['input'];
}>;


export type RestoreSalonMemberMutation = { restoreSalonMember: boolean };

export type ArchivedSalonMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type ArchivedSalonMembersQuery = { archivedSalonMembers: Array<{ _id: string, salonId: string, memberId: string, displayName: string, createdAt?: any | null, updatedAt?: any | null }> };

export type SendReceptionistMagicLinkMutationVariables = Exact<{
  receptionistId: Scalars['String']['input'];
}>;


export type SendReceptionistMagicLinkMutation = { sendReceptionistMagicLink: boolean };

export type InviteMemberMutationVariables = Exact<{
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  color: Scalars['String']['input'];
  addSeat?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InviteMemberMutation = { inviteMember: { _id: string, memberId: string, displayName: string, mobile: string, createdAt: any, inviteSentAt: any } };

export type Dev_SetSalonSeatsMutationVariables = Exact<{
  seats: Scalars['Int']['input'];
}>;


export type Dev_SetSalonSeatsMutation = { dev_setSalonSeats: boolean };

export type Dev_ClearOwnBusinessMutationVariables = Exact<{ [key: string]: never; }>;


export type Dev_ClearOwnBusinessMutation = { dev_clearOwnBusiness: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } };

export type Dev_LeaveSalonMutationVariables = Exact<{
  salonId: Scalars['String']['input'];
}>;


export type Dev_LeaveSalonMutation = { dev_leaveSalon: boolean };

export type Dev_DeleteSalonMutationVariables = Exact<{
  salonId: Scalars['String']['input'];
}>;


export type Dev_DeleteSalonMutation = { dev_deleteSalon: boolean };

export type CancelMemberInviteMutationVariables = Exact<{
  salonMemberId: Scalars['String']['input'];
}>;


export type CancelMemberInviteMutation = { cancelMemberInvite: boolean };

export type ResendMemberInviteMutationVariables = Exact<{
  salonMemberId: Scalars['String']['input'];
}>;


export type ResendMemberInviteMutation = { resendMemberInvite: { _id: string, displayName: string, status: SalonMemberStatus, inviteSentAt?: any | null, inviteCode?: string | null } };

export type CheckInviteCodeQueryVariables = Exact<{
  inviteCode: Scalars['String']['input'];
}>;


export type CheckInviteCodeQuery = { checkInviteCode?: { businessName: string } | null };

export type IdentifyWithInviteCodeMutationVariables = Exact<{
  inviteCode: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
}>;


export type IdentifyWithInviteCodeMutation = { identifyWithInviteCode: { authToken?: { role: AuthRole, auth: string } | null } };

export type VerifyMobileAndJoinSalonMutationVariables = Exact<{
  inviteCode: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  code: Scalars['String']['input'];
  userData: SalonMemberDetails;
}>;


export type VerifyMobileAndJoinSalonMutation = { verifyMobileAndJoinSalon: { authToken?: { role: AuthRole, auth: string } | null, user?: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } | null } };

export type VerifyMobileAndCreateSalonMutationVariables = Exact<{
  mobile: Scalars['String']['input'];
  code: Scalars['String']['input'];
  userData: RegistrationDetails;
  onboardingId: Scalars['String']['input'];
  trialLength: Scalars['Int']['input'];
}>;


export type VerifyMobileAndCreateSalonMutation = { verifyMobileAndCreateSalon: { authToken?: { role: AuthRole, auth: string } | null, user?: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } | null } };

export type CreateSalonMutationVariables = Exact<{
  businessName: Scalars['String']['input'];
  onboardingId?: InputMaybe<Scalars['String']['input']>;
  trialLength?: InputMaybe<Scalars['Int']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSalonMutation = { createSalon: { authToken?: { role: AuthRole, auth: string } | null, user?: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } | null } };

export type JoinSalonMutationVariables = Exact<{
  inviteCode: Scalars['String']['input'];
}>;


export type JoinSalonMutation = { joinSalon: { _id: string, salonId: string, memberId: string, color: string, displayName: string, picture?: string | null, title?: string | null, permissions: Array<SalonMemberPermission>, status: SalonMemberStatus, createdAt?: any | null, updatedAt?: any | null, businessName: string, salonEmailAddress?: string | null, onlinePaymentsEnabled?: boolean | null, colleagues?: Array<{ memberId: string, displayName: string, color: string, picture?: string | null }> | null, locations: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> } };

export type CreateSoloBusinessMutationVariables = Exact<{
  businessName: Scalars['String']['input'];
  onboardingId?: InputMaybe<Scalars['String']['input']>;
  trialLength?: InputMaybe<Scalars['Int']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSoloBusinessMutation = { createSoloBusiness: { _id: string, emailAddress?: string | null, firstName?: string | null, lastName?: string | null, stripeConnectedAccount?: string | null, acceptedTermsSaaS?: boolean | null, countryISOCode?: SupportedCountry | null, currencyCode?: SupportedCurrency | null, timezone?: string | null, professionalProfile?: { bio?: string | null, favouriteCount?: number | null, reviewCount?: number | null, averageReview?: number | null, treatmentIds?: Array<string | null> | null, postcodeIds?: Array<string | null> | null, regions?: Array<string | null> | null, defaultTransportMode?: string | null, numberOfBookings?: number | null, calendarColors?: { categories?: any | null } | null, treatments?: Array<{ _id?: string | null, name?: string | null, type?: string | null } | null> | null, postcodes?: Array<{ _id?: string | null, code?: string | null, name?: string | null, region?: string | null, locality?: string | null, active?: boolean | null, featured?: boolean | null, subRegion?: string | null, congestion?: string | null } | null> | null, notificationPreferences?: { privateBookingsTomorrowSummary: boolean, privateBookingsTodaySummary: boolean } | null } | null } };

export type GetSalonQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalonQuery = { salon?: { salonId: string, salon?: { _id: string } | null, members: Array<{ _id: string, salonId: string, memberId: string, permissions: Array<SalonMemberPermission>, color: string, displayName: string, picture?: string | null, title?: string | null, status: SalonMemberStatus, createdAt?: any | null, inviteSentAt?: any | null, inviteCode?: string | null, completedOnboardingSteps: Array<SalonMemberOnboardingStep>, member?: { _id: string, firstName?: string | null, lastName?: string | null, emailAddress?: string | null, mobile?: string | null } | null }> } | null };

export type MySalonMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySalonMembershipsQuery = { mySalonMemberships: Array<{ _id: string, salonId: string, memberId: string, color: string, displayName: string, picture?: string | null, title?: string | null, permissions: Array<SalonMemberPermission>, status: SalonMemberStatus, createdAt?: any | null, updatedAt?: any | null, businessName: string, salonEmailAddress?: string | null, onlinePaymentsEnabled?: boolean | null, colleagues?: Array<{ memberId: string, displayName: string, color: string, picture?: string | null }> | null, locations: Array<{ _id: string, enabled: boolean, name: string, summary: string, externalAddressId?: string | null, hideFullAddress?: boolean | null, minBookingAmount?: number | null, minBookingDate?: number | null, defaultPackdownTime?: number | null, defaultAvailabilityRange?: number | null, timeSlotInterval?: number | null, autoAcceptBookingRequests?: AutoAcceptBookingRequestOption | null }> }> };

export const TerminalReaderFieldsFragmentDoc = gql`
    fragment TerminalReaderFields on TerminalReader {
  id
  label
  deviceType
  serialNumber
  status
  ipAddress
  locationId
  staticLocationId
  lastSeenAt
}
    `;
export const TerminalTipSettingsFieldsFragmentDoc = gql`
    fragment TerminalTipSettingsFields on TerminalTipSettings {
  percentages
}
    `;
export const SaasSettingsStaticLocationFieldsFragmentDoc = gql`
    fragment SaasSettingsStaticLocationFields on SaasSettingsStaticLocation {
  _id
  enabled
  name
  summary
  externalAddressId
  hideFullAddress
  minBookingAmount
  minBookingDate
  defaultPackdownTime
  defaultAvailabilityRange
  timeSlotInterval
  autoAcceptBookingRequests
}
    `;
export const SalonMembershipFieldsFragmentDoc = gql`
    fragment SalonMembershipFields on SalonMember {
  _id
  salonId
  memberId
  color
  displayName
  picture
  title
  permissions
  colleagues {
    memberId
    displayName
    color
    picture
  }
  status
  createdAt
  updatedAt
  locations {
    ...SaasSettingsStaticLocationFields
  }
  businessName
  salonEmailAddress
  onlinePaymentsEnabled
}
    ${SaasSettingsStaticLocationFieldsFragmentDoc}`;
export const PostcodeFieldsFragmentDoc = gql`
    fragment PostcodeFields on Postcode {
  _id
  code
  name
  region
  locality
  active
  featured
  subRegion
  congestion
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  _id
  emailAddress
  firstName
  lastName
  professionalProfile {
    calendarColors {
      categories
    }
    bio
    favouriteCount
    reviewCount
    averageReview
    treatmentIds
    postcodeIds
    regions
    defaultTransportMode
    treatments {
      _id
      name
      type
    }
    postcodes {
      ...PostcodeFields
    }
    numberOfBookings
    notificationPreferences {
      privateBookingsTomorrowSummary
      privateBookingsTodaySummary
    }
  }
  stripeConnectedAccount
  acceptedTermsSaaS
  countryISOCode
  currencyCode
  timezone
}
    ${PostcodeFieldsFragmentDoc}`;
export const ChatFieldsFragmentDoc = gql`
    fragment ChatFields on Chat {
  _id
  professionalId
  professional {
    firstName
    lastName
  }
  clientId
  client {
    firstName
    lastName
  }
  lastMessage {
    message
    sentAt
  }
  messageCount {
    professional {
      unreadMessages
      sent
    }
    client {
      unreadMessages
      sent
    }
  }
}
    `;
export const BookingsFieldsFragmentDoc = gql`
    fragment BookingsFields on Booking {
  _id
  status
  date
  address
  totalPrice
  totalDuration
  totalFee
  title
  note
  type
  requestedFavouriteIds
  rejectedByIds
  userId
  items
  clientNote
  clientPictures
  professionalId
  clientReview {
    rating
    comment
  }
  clientDetails {
    firstName
    gender
    contactNumber
    note
    accountOwner
  }
  postcode {
    ...PostcodeFields
  }
  adminFees {
    name
    amount
  }
  timezone
  requestedProfessionalResponses {
    professionalId
    status
    respondedAt
    availabilityAdded
  }
  crossSellPromoCode
  calendarId
}
    ${PostcodeFieldsFragmentDoc}`;
export const BookingFieldsFragmentDoc = gql`
    fragment BookingFields on Booking {
  ...BookingsFields
  payoutDate
  adjustments {
    _id
    adjustmentType
    note
    amount
    payoutDate
    professionalId
  }
}
    ${BookingsFieldsFragmentDoc}`;
export const SaasSettingsFieldsFragmentDoc = gql`
    fragment SaasSettingsFields on SaasSettings {
  themeSettings {
    colorPrimary
    colorSecondary
    colorNeutralLight
    colorNeutralDark
    cornerStyle
    shadowStyle
    titlesFont
    titlesMotif
    bodyFont
  }
  bookNowUrl
  minBookingAmount
  minBookingDate
  businessName
  salonMemberOnly
  subtext
  defaultPackdownTime
  defaultTravelTime
  useTravelTime
  isPublic
  themePrimary
  themeBackground
  themeTextColor
  emailThemeBackground
  emailThemeTextColor
  emailThemePrimary
  requireTermsAndConditions
  receiveClientEmails
  branding
  features {
    hours
  }
  lookBook {
    imageUrl
    caption
  }
  info {
    title
    body
  }
  mobileLocation {
    _id
    enabled
    fee
    summary
    travelDistanceMiles
    externalAddressId
    minBookingAmount
    minBookingDate
    defaultPackdownTime
    defaultTravelTime
    useTravelTime
    defaultAvailabilityRange
    timeSlotInterval
    autoAcceptBookingRequests
    requestParkingInformation
  }
  requestsBlockCalendar
  staticLocations {
    ...SaasSettingsStaticLocationFields
  }
  defaultPaymentMethod
  paymentMethods {
    label
    type
  }
  defaultCancellationText
  contactDetails {
    type
    value
  }
  linkDescription
  treatmentCategoriesOrder
  treatmentsDisplayName
  pinnedReviewId
  clientDepositSettings {
    clientType
    depositRequired
    depositAmount
    useFixedAmount
    disableApplePay
  }
  requireBirthday
  requireBirthdayExplaination
  rescheduleRequestsEnabled
  reschedulingTimeFrame
  seoSettings {
    metaTitle
    metaDescription
    pageH1
    pageH2
  }
  localBusinessVisibility {
    addressVisibility
    showPhoneNumber
  }
}
    ${SaasSettingsStaticLocationFieldsFragmentDoc}`;
export const SubscriptionDetailsFieldsFragmentDoc = gql`
    fragment SubscriptionDetailsFields on SoloSubscriptionDetails {
  chargeBeeId
  saasBookingsThisPeriod {
    value
  }
  trialExtensions {
    date
    plan
  }
  saasReceipts {
    productId
    token
  }
  saasSubscriptions {
    plan
    status
    platform
    nextBilling
    entitlements {
      id
      value
    }
    planType
    couponIds
    totalDiscount
    inTrial
    trialEnd
    trialStart
  }
  entitlements {
    id
    value
    enabled
    updatedAt
    lastActiveAt
  }
  entitlementOverrides
  isUpdating
}
    `;
export const ProfessionalFieldsFragmentDoc = gql`
    fragment ProfessionalFields on Professional {
  _id
  role
  emailAddress
  firstName
  lastName
  emailConfirmed
  guestKey
  mobile
  mobileConfirmed
  gender
  genderSelfDescription
  stripeConnectedAccount
  stripePayoutEnabled
  stripeAccountStatus
  stripePayoutInterval
  stripeLimits {
    tapToPay
    dailyTransactions
  }
  soloServiceFee
  acceptedTermsPA
  acceptedTermsSaaS
  lastHealthPPECheck
  healthPPEConfirmed
  profileUrl
  blocked
  createdAt
  referralCode
  professionalProfile {
    calendarColors {
      categories
    }
    bio
    favouriteCount
    reviewCount
    averageReview
    treatmentIds
    postcodeIds
    regions
    defaultTransportMode
    treatments {
      _id
      name
      type
    }
    postcodes {
      ...PostcodeFields
    }
    numberOfBookings
    information
    createdAt
    genderPreference
    saasProfileUrl
    saasSettings {
      ...SaasSettingsFields
    }
    notificationPreferences {
      privateBookingsTomorrowSummary
      privateBookingsTodaySummary
    }
    averageExternalReview
    externalReviewCount
    completedSetupSteps
    completedSetupTasks
    giftCardSettings {
      enabled
      daysBeforeExpires
    }
  }
  stripeCapabilities {
    card_payments
    transfers
  }
  subscriptionDetails {
    ...SubscriptionDetailsFields
  }
  attributionData
  soloReferralId
  countryISOCode
  currencyCode
  timezone
  googleBusinessAuth {
    refreshToken
    accessToken
    selectedLocationId
    selectedAccountId
    scopes
    placeId
    localBusinessSchemaData {
      name
    }
  }
  googleCalendarAuth {
    refreshToken
    accessToken
    calendarId
  }
}
    ${PostcodeFieldsFragmentDoc}
${SaasSettingsFieldsFragmentDoc}
${SubscriptionDetailsFieldsFragmentDoc}`;
export const EmailCampaignFieldsFragmentDoc = gql`
    fragment EmailCampaignFields on EmailCampaign {
  _id
  label
  themeColors {
    themePrimary
    themeBackground
    themeTextColor
    contrastTextColor
  }
  scheduledFor
  customRecipientIds
  applyToAllClients
  recipientClientGroups
  type
  messageType
  lastSentAt
  createdAt
  emailSubject
  emailContent {
    _id
    blockType
    text
    url
    data {
      promocodeId
    }
  }
  status
  sentCount
  triggerType
}
    `;
export const SmsCampaignFieldsFragmentDoc = gql`
    fragment SmsCampaignFields on SmsCampaign {
  _id
  label
  scheduledFor
  customRecipientIds
  applyToAllClients
  recipientClientGroups
  type
  messageType
  lastSentAt
  createdAt
  messageContent
  status
  sentCount
  triggerType
}
    `;
export const ExternalTreatmentFieldsFragmentDoc = gql`
    fragment ExternalTreatmentFields on ExternalTreatment {
  _id
  name
  price
  category
  duration
  bufferTime
  showOnPortal
  description
  order
  professionalId
  locations {
    locationId
    enabled
    price
  }
  schedule {
    duration
    type
    description
  }
  memberOverrides {
    professionalId
    price
    duration
    canPerformTreatment
  }
}
    `;
export const ExternalPromocodeFieldsFragmentDoc = gql`
    fragment ExternalPromocodeFields on ExternalPromocode {
  _id
  code
  redeemedBy
  redeemableBy
  expiryDate
  active
  treatmentIds
  discountAmount
  discountType
  professionalId
  createdAt
  customRedeemableExternalClientIds
  maxRedemptions
  applyToAllTreatments
  applyToAllClients
  label
  externalClientId
}
    `;
export const ExternalReviewFieldsFragmentDoc = gql`
    fragment ExternalReviewFields on ExternalReview {
  _id
  professionalId
  externalBookingId
  secretSpaReviewId
  externalClientName
  rating
  publicComment
  privateComment
  visible
  createdAt
  googleReviewId
  googleReviewReplyComment
  googleReviewReplyUpdateTime
}
    `;
export const ExternalClientFieldsFragmentDoc = gql`
    fragment ExternalClientFields on ExternalClient {
  _id
  lastName
  firstName
  mobile
  emailAddress
  tags
  addresses
  notes
  color
  gender
  professionalId
  birthday
  blocked
  stats {
    acceptedOrCompletedBookings
    totalSpend
    averageSpend
    lastBookedDate
    noShows
  }
  notifications {
    emailCrm
    smsCrm
    emailUpdates
    smsUpdates
  }
  loyaltyProgress {
    loyaltySchemeId
    current
    totalRedeems
  }
  stripeCustomerId
  isRedacted
  deletedAt
}
    `;
export const PrivatePaymentFieldsFragmentDoc = gql`
    fragment PrivatePaymentFields on StripePaymentDetails {
  sessionId
  amount
  type
  description
  paymentIntent
  updatedAt
  externalPaymentId
  amountRefunded
  stripeType
}
    `;
export const ExternalBookingFieldsFragmentDoc = gql`
    fragment ExternalBookingFields on ExternalBooking {
  _id
  professionalId
  date
  color
  title
  notes
  totalFee
  feeAtBookingTime
  serviceFeePercentage
  totalDuration
  address
  clientDetails
  timezone
  externalReviewId
  externalReview {
    ...ExternalReviewFields
  }
  externalClientId
  externalClient {
    ...ExternalClientFields
  }
  items {
    _id
    treatmentId
    name
    fee
    duration
    category
    schedule {
      duration
      type
      description
    }
  }
  payments {
    ...PrivatePaymentFields
  }
  type
  bufferTime
  status
  source
  activityLog {
    title
    date
    properties {
      amount
      paymentType
    }
  }
  newCustomer
  sourceName
  platformCommission
  depositPercentage
  paymentMethod
  cancellationText
  cancellationReason
  consultationFormStatus
  consultationFormSectionIds
  businessName
  paymentStatus
  promocodeId
  promocodeDiscount {
    amount
    type
    code
  }
  repeats
  termsAndConditionsAccepted
  calendarId
  depositRequired
  useFixedAmount
  updatedAt
  createdAt
  originalBookingId
  rescheduleBookingId
  rescheduleType
  rescheduleReason
  emailUpdatesEnabled
  isProfessionalAddress
  allocatedProfessionalId
}
    ${ExternalReviewFieldsFragmentDoc}
${ExternalClientFieldsFragmentDoc}
${PrivatePaymentFieldsFragmentDoc}`;
export const ExternalAddressFieldsFragmentDoc = gql`
    fragment ExternalAddressFields on ExternalAddress {
  _id
  professionalId
  placeId
  line1
  line2
  region
  postalCode
  location {
    type
    coordinates
  }
  timezone
  staticLocation {
    ...SaasSettingsStaticLocationFields
  }
}
    ${SaasSettingsStaticLocationFieldsFragmentDoc}`;
export const InAppMessageFieldsFragmentDoc = gql`
    fragment InAppMessageFields on InAppMessage {
  _id
  name
  platform
  eventName
  match
  contentType
  updatedAt
}
    `;
export const ConsultationFormFieldsFragmentDoc = gql`
    fragment ConsultationFormFields on ConsultationForm {
  _id
  name
  professionalId
  treatmentIds
  applyToAllTreatments
}
    `;
export const ConsultationFormQuestionFieldsFragmentDoc = gql`
    fragment ConsultationFormQuestionFields on ConsultationFormQuestion {
  _id
  question
  type
  options
  required
  placeholder
  helpText
  templateName
  autofillId
}
    `;
export const AutomatedCampaignFieldsFragmentDoc = gql`
    fragment AutomatedCampaignFields on AutomatedCampaign {
  campaignId
  triggerType
  daysOffset
  active
  sendAtHour
  messageType
  sendLog {
    date
    sentCount
    errors
  }
}
    `;
export const ScheduledCampaignFieldsFragmentDoc = gql`
    fragment ScheduledCampaignFields on ScheduledCampaign {
  campaignId
  messageType
  scheduledFor
  externalClientIds
  status
}
    `;
export const ButtonFieldsFragmentDoc = gql`
    fragment ButtonFields on ContentBlockButton {
  label
  url
  linkType
  showButton
}
    `;
export const WebPageFieldsFragmentDoc = gql`
    fragment WebPageFields on WebPage {
  _id
  title
  path
  group
  order
  headerBlock {
    _id
    type
    color
    content {
      ... on ImageBlockContent {
        type
        title
        titleSize
        text
        layout
        shape
        textPosition
        textColor
        borderStyle
        imageUrl
        showReviews
        button {
          ...ButtonFields
        }
        secondaryButton {
          ...ButtonFields
        }
        isPageHeader
        imageBorderWidth
        data {
          breadcrumbs {
            name
            path
          }
        }
      }
    }
  }
  seoSettings {
    metaTitle
    metaDescription
  }
  showPageNavigation
  actionButton {
    content {
      ...ButtonFields
    }
  }
  visibility
  blocks {
    _id
    type
    color
    content {
      ... on TextBlockContent {
        text
        title
        type
        button {
          ...ButtonFields
        }
      }
      ... on ImageBlockContent {
        layout
        imageUrl
        alt
        title
        titleSize
        text
        type
        filter
        shape
        textPosition
        textColor
        borderStyle
        showReviews
        button {
          ...ButtonFields
        }
        secondaryButton {
          ...ButtonFields
        }
        isPageHeader
        imageBorderWidth
        data {
          breadcrumbs {
            name
            path
          }
        }
      }
      ... on LinkListBlockContent {
        items {
          _id
          iconName
          label
          subtext
          url
          linkType
        }
        button {
          ...ButtonFields
        }
        title
        type
      }
      ... on LogoListBlockContent {
        layout
        logos
        title
        type
      }
      ... on InfoBlockContent {
        items {
          _id
          heading
          text
        }
        button {
          ...ButtonFields
        }
        title
        type
      }
      ... on ImageCollectionBlockContent {
        layout
        items {
          _id
          alt
          imageUrl
        }
        title
        type
        button {
          ...ButtonFields
        }
      }
      ... on TreatmentListBlockContent {
        items {
          _id
        }
        data {
          items {
            _id
            name
            description
            price
            category
          }
        }
        treatmentsListDisplayType
        title
        type
        groupedCategories
        button {
          ...ButtonFields
        }
      }
      ... on LookbookBlockContent {
        items {
          alt
          imageUrl
        }
        title
        type
      }
      ... on ButtonBlockContent {
        label
        url
        title
        type
      }
      ... on ReviewsBlockContent {
        type
        title
        data {
          reviews {
            _id
            rating
            publicComment
            privateComment
            visible
            externalClientName
          }
        }
        layout
        reviewIds
        reviewsDisplayType
        button {
          ...ButtonFields
        }
      }
      ... on LocationBlockContent {
        type
        title
        text
        hideFullAddress
        locationId
        syncWithGoogle
        data {
          placeId
          staticLocationLat
          staticLocationLng
          localBusinessData {
            address {
              street
              city
              postalCode
              country
            }
          }
        }
      }
      ... on SalonMemberBlockContent {
        type
        title
        layout
        data {
          members {
            _id
            memberDisplayName
            picture
            title
          }
        }
      }
    }
  }
}
    ${ButtonFieldsFragmentDoc}`;
export const LoyaltySchemeFieldsFragmentDoc = gql`
    fragment LoyaltySchemeFields on LoyaltyScheme {
  _id
  professionalId
  status
  startDate
  goal
  goalNumber
  minBookingFee
  applyToAllClients
  externalClientIds
  createdAt
  updatedAt
  promoCodeSettings {
    discountAmount
    discountType
    validityDays
    applyToAllTreatments
    treatmentIds
  }
  referralCodeSettings {
    discountAmount
    discountType
    validityDays
    applyToAllTreatments
    treatmentIds
  }
  schemeUsage
}
    `;
export const ExternalGiftCardFieldsFragmentDoc = gql`
    fragment ExternalGiftCardFields on ExternalGiftCard {
  _id
  code
  amount
  expirationDate
  receiverEmail
  message
  senderEmail
  status
  balance
  transactions {
    date
    amount
    type
    externalBookingId
  }
}
    `;
export const BusinessProfileDataFieldsFragmentDoc = gql`
    fragment BusinessProfileDataFields on BusinessProfileData {
  _id
  reviewsWithTextCount
  reviewsWithin60DaysCount
  averageRating
  reviewResponseRate
  photosCount
  clientPhotosCount
  photosWithin60DaysCount
  postsCount
  lastPostDate
  hasDescription
  hasAddress
  hasWebsite
  isVerified
  hasOpeningHours
  servicesCount
  hasPrimaryCategory
  createdAt
  professionalId
  updatedAt
  fetchedAt
}
    `;
export const GetConfigDocument = gql`
    query getConfig {
  checkBlockedUser
  appVer {
    apiVersion
    minConsumerAppVer
    minProAppVer
  }
  settings {
    _id
    platform
    settings
  }
}
    `;
export const GetConfigAndMessagesDocument = gql`
    query getConfigAndMessages($filter: InAppMessageFilter!) {
  checkBlockedUser
  appVer {
    apiVersion
    minConsumerAppVer
    minProAppVer
  }
  settings {
    _id
    platform
    settings
  }
  inAppMessages(filter: $filter) {
    ...InAppMessageFields
  }
}
    ${InAppMessageFieldsFragmentDoc}`;
export const CheckBlockedUserDocument = gql`
    query checkBlockedUser {
  checkBlockedUser
}
    `;
export const SendPreviewEmailDocument = gql`
    query sendPreviewEmail($eventName: String!) {
  sendPreviewEmail(eventName: $eventName)
}
    `;
export const PlansWithPriceDocument = gql`
    query plansWithPrice($currencyCode: String!, $period: PeriodUnit!) {
  plansWithPrice(currencyCode: $currencyCode, period: $period) {
    id
    currency_code
    price_pennies
    period_unit
    type
    name
  }
}
    `;
export const AddonPricesDocument = gql`
    query addonPrices($currencyCode: String!, $period: PeriodUnit!) {
  addonPrices(currencyCode: $currencyCode, period: $period) {
    addonId
    priceId
    type
    price_pennies
    period_unit
    currency_code
    name
  }
}
    `;
export const LogoutDocument = gql`
    mutation logout($uniqueDeviceId: String) {
  logout(uniqueDeviceId: $uniqueDeviceId)
}
    `;
export const GetMagicLinkTokenDocument = gql`
    mutation getMagicLinkToken {
  getMagicLinkToken {
    token
    expiresAt
  }
}
    `;
export const GetUserTraitsDocument = gql`
    query getUserTraits {
  getUserTraits
}
    `;
export const AppVerDocument = gql`
    query appVer {
  appVer {
    apiVersion
    minConsumerAppVer
    minProAppVer
  }
}
    `;
export const DeleteSaasDataDocument = gql`
    mutation deleteSaasData($models: [DeletableModelNames!]!) {
  deleteSaasData(models: $models)
}
    `;
export const IdentifyWithMobileDocument = gql`
    query identifyWithMobile($mobile: String) {
  identifyWithMobile(mobile: $mobile) {
    authToken {
      role
      auth
    }
    user {
      role
    }
  }
}
    `;
export const SendMobileVerificationDocument = gql`
    query sendMobileVerification($mobile: String, $silent: Boolean) {
  sendMobileVerification(mobile: $mobile, silent: $silent) {
    authToken {
      role
      auth
    }
  }
}
    `;
export const VerifyMobileAndSignInDocument = gql`
    mutation verifyMobileAndSignIn($mobile: String, $code: String) {
  verifyMobileAndSignIn(mobile: $mobile, code: $code) {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const SignInAsSalonDocument = gql`
    mutation signInAsSalon($salonId: String!) {
  signInAsSalon(salonId: $salonId) {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const SignOutOfSalonDocument = gql`
    mutation signOutOfSalon {
  signOutOfSalon {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const AddReferralToUserDocument = gql`
    mutation addReferralToUser($referredBy: String!) {
  addReferralToUser(referredBy: $referredBy)
}
    `;
export const ReviewsDocument = gql`
    query reviews($filter: JSONObject, $pagination: Pagination) {
  reviews(filter: $filter, pagination: $pagination) {
    _id
    professionalId
    user {
      firstName
      lastName
      _id
    }
    comment
    createdAt
    rating
  }
}
    `;
export const AnswersDocument = gql`
    mutation answers($answers: QuestionAnswer!) {
  answers(answers: $answers) {
    profile
  }
}
    `;
export const ChatsDocument = gql`
    query chats {
  chats {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;
export const MarketplaceListingDocument = gql`
    query marketplaceListing {
  marketplaceListing {
    _id
    name
    userId
    tags {
      category
      marketplaceSlug
      name
    }
  }
}
    `;
export const MarkChatAsReadDocument = gql`
    mutation markChatAsRead($conversationId: String!) {
  markChatAsRead(conversationId: $conversationId)
}
    `;
export const FindOrCreateChatDocument = gql`
    mutation findOrCreateChat($clientId: String!) {
  findOrCreateChat(clientId: $clientId) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`;
export const GetUnreadMessagesDocument = gql`
    query getUnreadMessages {
  getUnreadMessages
}
    `;
export const BookingsDocument = gql`
    query bookings($filter: JSONObject, $sort: JSONObject, $pagination: Pagination) {
  bookings(filter: $filter, sort: $sort, pagination: $pagination) {
    ...BookingsFields
  }
}
    ${BookingsFieldsFragmentDoc}`;
export const BookingDocument = gql`
    query booking($_id: String) {
  booking(_id: $_id) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`;
export const RejectBookingDocument = gql`
    mutation rejectBooking($_id: String) {
  rejectBooking(_id: $_id)
}
    `;
export const AcceptBookingDocument = gql`
    mutation acceptBooking($_id: String, $ignoreConflictingBookings: Boolean) {
  acceptBooking(_id: $_id, ignoreConflictingBookings: $ignoreConflictingBookings)
}
    `;
export const HasBookingClashDocument = gql`
    query hasBookingClash($_id: String) {
  hasBookingClash(_id: $_id)
}
    `;
export const ProfessionalRequestResponseDocument = gql`
    mutation professionalRequestResponse($_id: String, $status: String, $availabilityAdded: [JSONObject]) {
  professionalRequestResponse(
    _id: $_id
    status: $status
    availabilityAdded: $availabilityAdded
  ) {
    _id
    requestedProfessionalResponses {
      professionalId
      status
      respondedAt
      availabilityAdded
    }
  }
}
    `;
export const UpdateBookingStatusDocument = gql`
    mutation updateBookingStatus($_id: String, $status: String) {
  updateBookingStatus(_id: $_id, status: $status)
}
    `;
export const CreateReviewDocument = gql`
    mutation createReview($data: NewReview) {
  createReview(data: $data)
}
    `;
export const CreateMockReviewDocument = gql`
    mutation createMockReview($data: NewMockReview) {
  createMockReview(data: $data) {
    _id
    professionalId
    user {
      firstName
      lastName
      _id
    }
    comment
    createdAt
    rating
  }
}
    `;
export const GetProfessionalAvailabilityDocument = gql`
    query getProfessionalAvailability($from: String, $to: String, $filter: JSONObject, $memberIds: [String!]) {
  getProfessionalAvailability(
    from: $from
    to: $to
    filter: $filter
    memberIds: $memberIds
  ) {
    professionalId
    day
    status
    times
    workingTimes
    treatmentIds
    postcodeIds
    transportMode
    bookingId
    defaultForDay
    locationId
  }
}
    `;
export const ProfessionalsAvailableAtLocationsDocument = gql`
    query professionalsAvailableAtLocations($locationIds: [String!]!, $professionalIds: [String!]!) {
  professionalsAvailableAtLocations(
    locationIds: $locationIds
    professionalIds: $professionalIds
  ) {
    professionalId
    locationIds
  }
}
    `;
export const AvailabilitySuggestionsDocument = gql`
    query availabilitySuggestions($includeNearby: Boolean) {
  availabilitySuggestions(includeNearby: $includeNearby) {
    _id
    day
    treatmentIds
    postcodeIds
    treatmentType
  }
}
    `;
export const GetProfessionalAgendasDocument = gql`
    query getProfessionalAgendas($days: [String], $memberId: String) {
  getProfessionalAgendas(days: $days, memberId: $memberId) {
    day
    isCustom
    events {
      date
      title
      color
      colors {
        color
        percentage
      }
      bookingId
      professionalId
      startHour
      durationHours
      outerCode
      type
      bookingStatus
      warningStatus
      paymentStatus
      consultationFormStatus
      treatments
      categories
      clientFirstName
      clientLastName
      repeating
      rescheduleRequested
      segments {
        durationHours
        type
        color
      }
    }
    availability {
      day
      status
      times
      workingTimes
      locationId
    }
  }
}
    `;
export const ExternalBookingDocument = gql`
    query externalBooking($_id: String!) {
  externalBooking(_id: $_id) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const SendReminderDocument = gql`
    mutation sendReminder($_id: String!, $reminder: String!) {
  sendReminder(_id: $_id, reminder: $reminder) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const ExternalBookingsDocument = gql`
    query externalBookings($filter: JSONObject, $sort: JSONObject, $pagination: Pagination) {
  externalBookings(filter: $filter, sort: $sort, pagination: $pagination) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const RefundStripePaymentDocument = gql`
    mutation refundStripePayment($data: RefundPaymentInput!) {
  refundStripePayment(data: $data) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const CreateOrUpdateExternalBookingDocument = gql`
    mutation createOrUpdateExternalBooking($data: ExternalBookingInput, $unsetFields: [String!]) {
  createOrUpdateExternalBooking(data: $data, unsetFields: $unsetFields) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const UpdateSpecificExternalBookingDataDocument = gql`
    mutation updateSpecificExternalBookingData($data: ExternalBookingSpecificInput!) {
  updateSpecificExternalBookingData(data: $data) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const BookingHasConflictsDocument = gql`
    query bookingHasConflicts($data: BookingConflictsInput!) {
  bookingHasConflicts(data: $data)
}
    `;
export const DeleteExternalBookingDocument = gql`
    mutation deleteExternalBooking($_id: String) {
  deleteExternalBooking(_id: $_id)
}
    `;
export const AcceptRescheduledBookingDocument = gql`
    mutation acceptRescheduledBooking($originalBookingId: String!) {
  acceptRescheduledBooking(originalBookingId: $originalBookingId) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const RejectRescheduledBookingDocument = gql`
    mutation rejectRescheduledBooking($originalBookingId: String!) {
  rejectRescheduledBooking(originalBookingId: $originalBookingId) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const ResolveRescheduledBookingDocument = gql`
    mutation resolveRescheduledBooking($originalBookingId: String!, $date: Date!) {
  resolveRescheduledBooking(originalBookingId: $originalBookingId, date: $date) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const AcceptExternalBookingDocument = gql`
    mutation acceptExternalBooking($data: ExternalBookingInput!) {
  acceptExternalBooking(data: $data) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const DeclineExternalBookingDocument = gql`
    mutation declineExternalBooking($_id: String!, $reason: String!, $deleteClient: Boolean!) {
  declineExternalBooking(_id: $_id, reason: $reason, deleteClient: $deleteClient) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const CancelAndRefundExternalBookingDocument = gql`
    mutation cancelAndRefundExternalBooking($data: cancelAndRefundExternalBookingInput!) {
  cancelAndRefundExternalBooking(data: $data) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const CancelAndChargeExternalBookingDocument = gql`
    mutation cancelAndChargeExternalBooking($data: CancelAndChargeExternalBookingInput!) {
  cancelAndChargeExternalBooking(data: $data) {
    externalBooking {
      ...ExternalBookingFields
    }
    charged
    error
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const ChargeExternalBookingDocument = gql`
    mutation chargeExternalBooking($data: ChargeExternalBookingInput!) {
  chargeExternalBooking(data: $data) {
    externalBooking {
      ...ExternalBookingFields
    }
    charged
    error
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const CompleteExternalBookingDocument = gql`
    mutation completeExternalBooking($_id: String!, $data: CompleteExternalBookingInput!) {
  completeExternalBooking(_id: $_id, data: $data) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const CreateOrUpdateProfessionalAvailabilityDocument = gql`
    mutation createOrUpdateProfessionalAvailability($data: CreateUpdateAvailabilityInput!) {
  createOrUpdateProfessionalAvailability(data: $data) {
    day
    status
    times
    workingTimes
    treatmentIds
    postcodeIds
    locationId
    bookingId
    defaultForDay
  }
}
    `;
export const RemoveProfessionalAvailabilityDocument = gql`
    mutation removeProfessionalAvailability($filter: ProfessionalAvailabilityInput, $memberId: String) {
  removeProfessionalAvailability(filter: $filter, memberId: $memberId)
}
    `;
export const GetProfessionalDocument = gql`
    query getProfessional($_id: String) {
  getProfessional(_id: $_id) {
    ...ProfessionalFields
  }
}
    ${ProfessionalFieldsFragmentDoc}`;
export const GetProfessionalWithStripeDocument = gql`
    query getProfessionalWithStripe($_id: String) {
  getProfessional(_id: $_id) {
    ...ProfessionalFields
    stripeDashboard
    stripeBusinessName
    stripeDescriptor
  }
}
    ${ProfessionalFieldsFragmentDoc}`;
export const UpdateProfessionalStripeDataDocument = gql`
    mutation updateProfessionalStripeData($data: ProfessionalStripeDataInput) {
  updateProfessionalStripeData(data: $data)
}
    `;
export const GetProfessionalAvailabilityDataDocument = gql`
    query getProfessionalAvailabilityData($_id: String) {
  getProfessional(_id: $_id) {
    professionalProfile {
      treatmentIds
      postcodeIds
      regions
      defaultTransportMode
    }
  }
}
    `;
export const UpdateSaasUserDocument = gql`
    mutation updateSaasUser($data: UpdateSaasUserInput!) {
  updateSaasUser(data: $data)
}
    `;
export const UpdateProfessionalProfileDocument = gql`
    mutation updateProfessionalProfile($data: UserProfessionalProfileInput) {
  updateProfessionalProfile(data: $data) {
    bio
    favouriteCount
    reviewCount
    averageReview
    treatmentIds
    postcodeIds
    regions
    defaultTransportMode
    treatments {
      _id
      name
      type
    }
    postcodes {
      ...PostcodeFields
    }
    numberOfBookings
    saasSettings {
      ...SaasSettingsFields
    }
    completedSetupSteps
    completedSetupTasks
  }
}
    ${PostcodeFieldsFragmentDoc}
${SaasSettingsFieldsFragmentDoc}`;
export const CreateOrUpdateDeviceDocument = gql`
    mutation createOrUpdateDevice($data: UserDeviceInput) {
  createOrUpdateDevice(data: $data) {
    uniqueDeviceId
    apnsToken
    fcmToken
    device
    platform
    platformVersion
    notificationsPermissionStatus
    notificationAccessRequested
    deviceRegisteredForNotifications
  }
}
    `;
export const GetPostcodesDocument = gql`
    query getPostcodes($filter: JSONObject, $sort: JSONObject, $pagination: Pagination, $search: String) {
  getPostcodes(
    filter: $filter
    sort: $sort
    pagination: $pagination
    search: $search
  ) {
    ...PostcodeFields
  }
}
    ${PostcodeFieldsFragmentDoc}`;
export const PayoutsDocument = gql`
    query payouts($filter: JSONObject, $pagination: Pagination) {
  payouts(filter: $filter, pagination: $pagination) {
    _id
    status
    amount
    createdAt
    items {
      bookingId
      adjustmentId
      amount
      date
      note
      type
    }
  }
}
    `;
export const ExternalBookingPaymentsDocument = gql`
    query externalBookingPayments($filter: JSONObject, $pagination: Pagination) {
  externalBookingPayments(filter: $filter, pagination: $pagination) {
    _id
    date
    status
    amount
    privatePaymentDetails {
      externalBooking {
        _id
        title
        formattedDate
        externalClientName
      }
      net
      type
    }
  }
}
    `;
export const PaymentsForExternalBookingDocument = gql`
    query paymentsForExternalBooking($data: ExternalBookingPaymentsInput!) {
  paymentsForExternalBooking(data: $data) {
    _id
    date
    status
    amount
    privatePaymentDetails {
      externalBooking {
        _id
        title
        formattedDate
        externalClientName
      }
      net
      type
    }
  }
}
    `;
export const BookingStubsDocument = gql`
    query bookingStubs($filter: JSONObject, $sort: JSONObject, $pagination: Pagination) {
  bookings(filter: $filter, sort: $sort, pagination: $pagination) {
    _id
    status
    date
    userId
    clientDetails {
      firstName
      gender
      contactNumber
      note
      accountOwner
    }
    postcode {
      _id
      code
    }
  }
}
    `;
export const PageDocument = gql`
    query page($type: String) {
  page(type: $type) {
    _id
    title
    body
    type
  }
}
    `;
export const SettingsDocument = gql`
    query settings {
  settings {
    _id
    platform
    settings
  }
}
    `;
export const CreateOrGetReferralDocument = gql`
    mutation createOrGetReferral($data: ReferralCodeInput) {
  createOrGetReferral(data: $data) {
    _id
    promoCode
    title
    description
    createdAt
    startDate
    active
    discountType
    value
    useCount
    redeemAction {
      receiveAmount
    }
  }
}
    `;
export const GetCrossSellPromoCodeDocument = gql`
    mutation getCrossSellPromoCode($bookingId: String!) {
  getCrossSellPromoCode(bookingId: $bookingId) {
    _id
    promoCode
    value
    limits {
      excludedTreatmentTypes
    }
    redeemAction {
      receiveAmount
    }
  }
}
    `;
export const InvalidatePagesDocument = gql`
    mutation invalidatePages {
  invalidatePages
}
    `;
export const AdjustmentsDocument = gql`
    query adjustments($query: JSONObject) {
  adjustments(query: $query) {
    _id
    createdAt
    bookingId
    professionalId
    note
    amount
    payoutDrafted
    adjustmentType
  }
}
    `;
export const PromoCodeApplicationsDocument = gql`
    query promoCodeApplications($data: PromoCodeApplicationsInput) {
  promoCodeApplications(data: $data) {
    _id
    user {
      _id
      firstName
    }
    booking {
      _id
      status
      date
    }
    createdAt
    status
    promoCode {
      redeemAction {
        receiveAmount
        action
      }
    }
  }
}
    `;
export const CategoriesDocument = gql`
    query categories($filter: JSONObject, $region: String) {
  categories(filter: $filter, region: $region) {
    _id
    name
    treatmentIds
    slug
  }
}
    `;
export const GetParkingInformationDocument = gql`
    query getParkingInformation($_id: String, $addressId: String) {
  getParkingInformation(_id: $_id, addressId: $addressId) {
    _id
    locationDetails
    locationType
    cost
    note
    postcode
    addressId
    proComments
  }
}
    `;
export const AddorUpdateParkingInformationDocument = gql`
    mutation addorUpdateParkingInformation($data: ParkingInformationInput!) {
  addorUpdateParkingInformation(data: $data) {
    _id
    locationDetails
    locationType
    cost
    note
    postcode
    addressId
    proComments
  }
}
    `;
export const RequestProfessionalPaymentCapabilityDocument = gql`
    query requestProfessionalPaymentCapability {
  requestProfessionalPaymentCapability
}
    `;
export const EmailCampaignsDocument = gql`
    query emailCampaigns($filter: JSONObject!, $pagination: Pagination!) {
  emailCampaigns(filter: $filter, pagination: $pagination) {
    ...EmailCampaignFields
  }
}
    ${EmailCampaignFieldsFragmentDoc}`;
export const EmailCampaignDocument = gql`
    query emailCampaign($_id: String!) {
  emailCampaign(_id: $_id) {
    ...EmailCampaignFields
  }
}
    ${EmailCampaignFieldsFragmentDoc}`;
export const CreateEmailCampaignDocument = gql`
    mutation createEmailCampaign($data: CreateEmailCampaignInput!) {
  createEmailCampaign(data: $data) {
    ...EmailCampaignFields
  }
}
    ${EmailCampaignFieldsFragmentDoc}`;
export const UpdateEmailCampaignDocument = gql`
    mutation updateEmailCampaign($data: UpdateEmailCampaignInput!) {
  updateEmailCampaign(data: $data) {
    ...EmailCampaignFields
  }
}
    ${EmailCampaignFieldsFragmentDoc}`;
export const DeleteAutomatedCampaignsDocument = gql`
    mutation deleteAutomatedCampaigns($emailCampaignId: String, $smsCampaignId: String) {
  deleteAutomatedCampaigns(
    emailCampaignId: $emailCampaignId
    smsCampaignId: $smsCampaignId
  )
}
    `;
export const ResetAutomatedEmailThemesDocument = gql`
    mutation resetAutomatedEmailThemes($data: ResetAutomatedEmailThemesInput) {
  resetAutomatedEmailThemes(data: $data)
}
    `;
export const SendTestEmailDocument = gql`
    query sendTestEmail($data: SendTestEmailInput!) {
  sendTestEmail(data: $data)
}
    `;
export const SmsCampaignsDocument = gql`
    query smsCampaigns($filter: JSONObject!, $pagination: Pagination!) {
  smsCampaigns(filter: $filter, pagination: $pagination) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export const SmsCampaignDocument = gql`
    query smsCampaign($_id: String!) {
  smsCampaign(_id: $_id) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export const CreateSmsCampaignDocument = gql`
    mutation createSmsCampaign($data: CreateSmsCampaignInput!) {
  createSmsCampaign(data: $data) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export const UpdateSmsCampaignDocument = gql`
    mutation updateSmsCampaign($data: UpdateSmsCampaignInput!) {
  updateSmsCampaign(data: $data) {
    ...SmsCampaignFields
  }
}
    ${SmsCampaignFieldsFragmentDoc}`;
export const ScheduledCampaignDocument = gql`
    query scheduledCampaign($_id: String, $campaignId: String) {
  scheduledCampaign(_id: $_id, campaignId: $campaignId) {
    ...ScheduledCampaignFields
  }
}
    ${ScheduledCampaignFieldsFragmentDoc}`;
export const AutomatedCampaignDocument = gql`
    query automatedCampaign($_id: String, $campaignId: String) {
  automatedCampaign(_id: $_id, campaignId: $campaignId) {
    ...AutomatedCampaignFields
  }
}
    ${AutomatedCampaignFieldsFragmentDoc}`;
export const UpdateAutomatedCampaignDocument = gql`
    mutation updateAutomatedCampaign($data: AutomatedCampaignInput!) {
  updateAutomatedCampaign(data: $data) {
    ...AutomatedCampaignFields
  }
}
    ${AutomatedCampaignFieldsFragmentDoc}`;
export const UpdateScheduledCampaignDocument = gql`
    mutation updateScheduledCampaign($data: ScheduledCampaignInput!) {
  updateScheduledCampaign(data: $data) {
    ...ScheduledCampaignFields
  }
}
    ${ScheduledCampaignFieldsFragmentDoc}`;
export const ExternalTreatmentsDocument = gql`
    query externalTreatments {
  externalTreatments {
    ...ExternalTreatmentFields
  }
}
    ${ExternalTreatmentFieldsFragmentDoc}`;
export const AddOrUpdateExternalTreatmentDocument = gql`
    mutation addOrUpdateExternalTreatment($data: ExternalTreatmentInput!) {
  addOrUpdateExternalTreatment(data: $data) {
    ...ExternalTreatmentFields
  }
}
    ${ExternalTreatmentFieldsFragmentDoc}`;
export const UpdateTreatmentPricingDocument = gql`
    mutation updateTreatmentPricing($defaults: [TreatmentDefaultInput!]!, $overrides: [TreatmentMemberOverrideInput!]!) {
  updateTreatmentPricing(defaults: $defaults, overrides: $overrides) {
    ...ExternalTreatmentFields
  }
}
    ${ExternalTreatmentFieldsFragmentDoc}`;
export const DeleteExternalTreatmentDocument = gql`
    mutation deleteExternalTreatment($_id: String!) {
  deleteExternalTreatment(_id: $_id)
}
    `;
export const ExternalPromocodesDocument = gql`
    query externalPromocodes($filter: JSONObject, $sort: JSONObject, $pagination: Pagination) {
  externalPromocodes(filter: $filter, sort: $sort, pagination: $pagination) {
    ...ExternalPromocodeFields
  }
}
    ${ExternalPromocodeFieldsFragmentDoc}`;
export const ExternalPromocodeDocument = gql`
    query externalPromocode($_id: String!) {
  externalPromocode(_id: $_id) {
    ...ExternalPromocodeFields
  }
}
    ${ExternalPromocodeFieldsFragmentDoc}`;
export const CreateExternalPromocodeDocument = gql`
    mutation createExternalPromocode($data: CreateExternalPromocodeInput!) {
  createExternalPromocode(data: $data) {
    ...ExternalPromocodeFields
  }
}
    ${ExternalPromocodeFieldsFragmentDoc}`;
export const ValidateExternalPromocodeDocument = gql`
    mutation validateExternalPromocode($data: ValidateExternalPromocodeInput!) {
  validateExternalPromocode(data: $data)
}
    `;
export const UpdateExternalPromocodeDocument = gql`
    mutation updateExternalPromocode($data: UpdateExternalPromocodeInput!) {
  updateExternalPromocode(data: $data) {
    ...ExternalPromocodeFields
  }
}
    ${ExternalPromocodeFieldsFragmentDoc}`;
export const ExternalTreatmentDocument = gql`
    query externalTreatment($_id: String!) {
  externalTreatment(_id: $_id) {
    ...ExternalTreatmentFields
  }
}
    ${ExternalTreatmentFieldsFragmentDoc}`;
export const ExternalClientsDocument = gql`
    query externalClients($pagination: Pagination, $sort: JSONObject, $groups: [String!], $filter: JSONObject) {
  externalClients(
    pagination: $pagination
    sort: $sort
    groups: $groups
    filter: $filter
  ) {
    ...ExternalClientFields
  }
}
    ${ExternalClientFieldsFragmentDoc}`;
export const ClientGroupCountsDocument = gql`
    query clientGroupCounts {
  clientGroupCounts {
    group
    count
  }
}
    `;
export const SearchExternalClientsDocument = gql`
    query searchExternalClients($search: String!) {
  searchExternalClients(search: $search) {
    ...ExternalClientFields
  }
}
    ${ExternalClientFieldsFragmentDoc}`;
export const AddOrUpdateExternalClientDocument = gql`
    mutation addOrUpdateExternalClient($data: ExternalClientInput!) {
  addOrUpdateExternalClient(data: $data) {
    ...ExternalClientFields
  }
}
    ${ExternalClientFieldsFragmentDoc}`;
export const DeleteExternalClientDocument = gql`
    mutation deleteExternalClient($_id: String!) {
  deleteExternalClient(_id: $_id)
}
    `;
export const ExternalClientDocument = gql`
    query externalClient($_id: String!) {
  externalClient(_id: $_id) {
    ...ExternalClientFields
  }
}
    ${ExternalClientFieldsFragmentDoc}`;
export const AddExternalClientsDocument = gql`
    mutation addExternalClients($data: [ExternalClientInput!]!) {
  addExternalClients(data: $data)
}
    `;
export const SwitchClientBookingsDocument = gql`
    mutation switchClientBookings($data: SwitchClientBookingsInput!) {
  switchClientBookings(data: $data)
}
    `;
export const ExternalAddressesDocument = gql`
    query externalAddresses($filter: ExternalAddressFilter) {
  externalAddresses(filter: $filter) {
    ...ExternalAddressFields
  }
}
    ${ExternalAddressFieldsFragmentDoc}`;
export const AddOrUpdateExternalAddressDocument = gql`
    mutation addOrUpdateExternalAddress($data: ExternalAddressInput!) {
  addOrUpdateExternalAddress(data: $data) {
    ...ExternalAddressFields
  }
}
    ${ExternalAddressFieldsFragmentDoc}`;
export const DeleteExternalAddressDocument = gql`
    mutation deleteExternalAddress($_id: String!) {
  deleteExternalAddress(_id: $_id)
}
    `;
export const ExternalAddressDocument = gql`
    query externalAddress($_id: String!) {
  externalAddress(_id: $_id) {
    ...ExternalAddressFields
  }
}
    ${ExternalAddressFieldsFragmentDoc}`;
export const CheckSaasProfileUrlAvailableDocument = gql`
    query checkSaasProfileUrlAvailable($data: SaasProfileUrlInput!) {
  checkSaasProfileUrlAvailable(data: $data)
}
    `;
export const GetBookingsForHomepageDocument = gql`
    query getBookingsForHomepage {
  getBookingsForHomepage {
    bookings {
      ...BookingFields
    }
    externalBookings {
      ...ExternalBookingFields
    }
    instants
    privateRequests
    requests
    cancel
    complete
    outstandingPayments
    outstandingConsultationForms
    chats
    reschedule
  }
}
    ${BookingFieldsFragmentDoc}
${ExternalBookingFieldsFragmentDoc}`;
export const SoloBookingsForDashboardDocument = gql`
    query soloBookingsForDashboard($filters: [DashboardBookingFilter!]!) {
  soloBookingsForDashboard(filters: $filters) {
    filter
    externalBookingIds
    externalBookings {
      ...ExternalBookingFields
    }
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const ExternalReviewsDocument = gql`
    query externalReviews($filter: JSONObject, $sort: JSONObject, $pagination: Pagination) {
  externalReviews(filter: $filter, sort: $sort, pagination: $pagination) {
    ...ExternalReviewFields
  }
}
    ${ExternalReviewFieldsFragmentDoc}`;
export const UpdateExternalReviewVisibleDocument = gql`
    mutation updateExternalReviewVisible($_id: String!, $visible: Boolean!) {
  updateExternalReviewVisible(_id: $_id, visible: $visible) {
    ...ExternalReviewFields
  }
}
    ${ExternalReviewFieldsFragmentDoc}`;
export const CreateExternalReviewDocument = gql`
    mutation createExternalReview($data: ExternalReviewInput!) {
  createExternalReview(data: $data) {
    _id
  }
}
    `;
export const CreateSecretSpaExternalReviewDocument = gql`
    mutation createSecretSpaExternalReview($data: SecretSpaExternalReviewInput!) {
  createSecretSpaExternalReview(data: $data)
}
    `;
export const ConsultationFormDocument = gql`
    query consultationForm($_id: String!, $professionalId: String!) {
  consultationForm(_id: $_id, professionalId: $professionalId) {
    ...ConsultationFormFields
    questions {
      ...ConsultationFormQuestionFields
    }
  }
}
    ${ConsultationFormFieldsFragmentDoc}
${ConsultationFormQuestionFieldsFragmentDoc}`;
export const ConsultationFormsDocument = gql`
    query consultationForms {
  consultationForms {
    ...ConsultationFormFields
    questionIds
  }
}
    ${ConsultationFormFieldsFragmentDoc}`;
export const CreateOrUpdateConsultationFormDocument = gql`
    mutation createOrUpdateConsultationForm($data: ConsultationFormInput!) {
  createOrUpdateConsultationForm(data: $data) {
    ...ConsultationFormFields
    questions {
      ...ConsultationFormQuestionFields
    }
  }
}
    ${ConsultationFormFieldsFragmentDoc}
${ConsultationFormQuestionFieldsFragmentDoc}`;
export const ConsultationFormDefaultQuestionsDocument = gql`
    query consultationFormDefaultQuestions {
  consultationFormDefaultQuestions {
    ...ConsultationFormQuestionFields
  }
}
    ${ConsultationFormQuestionFieldsFragmentDoc}`;
export const ConsultationFormCompletedDocument = gql`
    query consultationFormCompleted($externalBookingId: String!) {
  consultationFormCompleted(externalBookingId: $externalBookingId)
}
    `;
export const ConsultationFormAnswersDocument = gql`
    query consultationFormAnswers($externalBookingId: String!) {
  consultationFormAnswers(externalBookingId: $externalBookingId) {
    answers {
      _id
      question
      answer
      questionType
    }
    updatedAt
  }
}
    `;
export const DeleteConsultationFormDocument = gql`
    mutation deleteConsultationForm($_id: String!) {
  deleteConsultationForm(_id: $_id)
}
    `;
export const UploadFileDocument = gql`
    mutation uploadFile($file: Upload!, $path: String, $filename: String, $type: String, $resizeOptions: ResizeImageOptions) {
  uploadFile(
    file: $file
    path: $path
    filename: $filename
    type: $type
    resizeOptions: $resizeOptions
  )
}
    `;
export const DeleteFileDocument = gql`
    mutation deleteFile($filename: String, $type: String) {
  deleteFile(filename: $filename, type: $type)
}
    `;
export const DeleteUserDocument = gql`
    mutation deleteUser {
  deleteUser
}
    `;
export const CreateNewSaasUserWithMobileDocument = gql`
    mutation createNewSaasUserWithMobile($mobile: String) {
  createNewSaasUserWithMobile(mobile: $mobile) {
    authToken {
      role
      auth
    }
  }
}
    `;
export const VerifyMobileAndCompleteAccountDocument = gql`
    mutation verifyMobileAndCompleteAccount($mobile: String!, $code: String!, $userData: RegistrationDetails!, $onboardingId: String!, $trialLength: Int!) {
  verifyMobileAndCompleteAccount(
    mobile: $mobile
    code: $code
    userData: $userData
    onboardingId: $onboardingId
    trialLength: $trialLength
  ) {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const InAppMessagesDocument = gql`
    query inAppMessages($filter: InAppMessageFilter!) {
  inAppMessages(filter: $filter) {
    ...InAppMessageFields
  }
}
    ${InAppMessageFieldsFragmentDoc}`;
export const InAppMessageDocument = gql`
    query inAppMessage($_id: String!) {
  inAppMessage(_id: $_id) {
    name
    content
  }
}
    `;
export const SubmitOnboardingAnswersDocument = gql`
    mutation submitOnboardingAnswers($data: [OnboardingSurveyAnswersInput!]!, $forNewBusiness: Boolean) {
  submitOnboardingAnswers(data: $data, forNewBusiness: $forNewBusiness)
}
    `;
export const ExternalTreatmentLibraryDocument = gql`
    query externalTreatmentLibrary {
  externalTreatmentLibrary {
    ...ExternalTreatmentFields
  }
}
    ${ExternalTreatmentFieldsFragmentDoc}`;
export const ImportLibraryTreatmentsDocument = gql`
    mutation importLibraryTreatments($treatmentIds: [String!]!) {
  importLibraryTreatments(treatmentIds: $treatmentIds)
}
    `;
export const ManageSoloSubscriptionUrlDocument = gql`
    query manageSoloSubscriptionUrl {
  manageSoloSubscriptionUrl
}
    `;
export const SoloSubscriptionUrlDocument = gql`
    query soloSubscriptionUrl($data: SoloSubscriptionUrlCheckout!) {
  soloSubscriptionUrl(data: $data)
}
    `;
export const TestSubscriptionDocument = gql`
    mutation testSubscription($data: SoloSubscriptionTestData!) {
  testSubscription(data: $data)
}
    `;
export const SyncWithChargebeeDocument = gql`
    mutation syncWithChargebee {
  syncWithChargebee
}
    `;
export const BookingsForCalendarSyncDocument = gql`
    query bookingsForCalendarSync {
  bookingsForCalendarSync {
    bookings {
      ...BookingFields
    }
    externalBookings {
      ...ExternalBookingFields
    }
    cancelledBookings {
      ...BookingFields
    }
  }
}
    ${BookingFieldsFragmentDoc}
${ExternalBookingFieldsFragmentDoc}`;
export const MarketplacesDocument = gql`
    query marketplaces {
  marketplaces {
    _id
    websiteSlug
    name
    branding {
      primaryColor
      secondaryColor
    }
  }
}
    `;
export const CreateDefaultAvailabilityDocument = gql`
    mutation createDefaultAvailability($data: CreateDefaultAvailabilityInput!) {
  createDefaultAvailability(data: $data)
}
    `;
export const ClientSavedCardDocument = gql`
    query clientSavedCard($_id: String!) {
  clientSavedCard(_id: $_id) {
    hasCardId
    last4
  }
}
    `;
export const SaveAttributionSurveyDataDocument = gql`
    mutation saveAttributionSurveyData($data: JSONObject!) {
  saveAttributionSurveyData(data: $data)
}
    `;
export const EnrollReferralProgramDocument = gql`
    mutation enrollReferralProgram {
  enrollReferralProgram {
    ...ProfessionalFields
  }
}
    ${ProfessionalFieldsFragmentDoc}`;
export const GetSoloReferralsDocument = gql`
    query getSoloReferrals {
  getSoloReferrals {
    _id
    status
    actions {
      action
      actionDate
    }
    rewards {
      rewardType
      rewardDate
      amount
      status
    }
    referredProfessional {
      _id
      firstName
      lastName
      saasProfileUrl
      createdAt
    }
  }
}
    `;
export const CheckSoloReferralCodeDocument = gql`
    query checkSoloReferralCode($referralCode: String!) {
  checkSoloReferralCode(referralCode: $referralCode) {
    _id
    firstName
    lastName
  }
}
    `;
export const CrmInvoicesDocument = gql`
    query crmInvoices($filter: JSONObject, $sort: JSONObject, $pagination: Pagination) {
  crmInvoices(filter: $filter, sort: $sort, pagination: $pagination) {
    _id
    professionalId
    usageLines {
      ids
      usageType
    }
    paid
    totalAmount
    unpaidAmount
    startDate
    endDate
  }
}
    `;
export const CrmUsagesDocument = gql`
    query crmUsages($filter: CrmUsagesFilter!, $pagination: Pagination) {
  crmUsages(filter: $filter, pagination: $pagination) {
    _id
    externalBookingId
    emailCampaignId
    smsCampaignId
    externalClientId
    professionalId
    price
    usageType
    messageType
    createdAt
    invoiceId
    automatedTriggerType
    deliveryStatus
  }
}
    `;
export const CrmUsageErrorsDocument = gql`
    query crmUsageErrors {
  crmUsageErrors {
    _id
    externalBookingId
    professionalId
    usageType
    messageType
    createdAt
    errorCode
  }
}
    `;
export const DeleteCrmUsageErrorsDocument = gql`
    mutation deleteCrmUsageErrors {
  deleteCrmUsageErrors
}
    `;
export const GetTerminalSecretDocument = gql`
    query getTerminalSecret($staticLocationId: String, $externalBookingId: String) {
  getTerminalSecret(
    staticLocationId: $staticLocationId
    externalBookingId: $externalBookingId
  ) {
    secret
    locationId
  }
}
    `;
export const CreateTerminalPaymentIntentDocument = gql`
    query createTerminalPaymentIntent($data: CreateTerminalPaymentIntentInput!) {
  createTerminalPaymentIntent(data: $data) {
    paymentIntentId
    clientSecret
  }
}
    `;
export const CaptureTerminalPaymentDocument = gql`
    query captureTerminalPayment($data: CaptureTerminalPaymentInput!) {
  captureTerminalPayment(data: $data) {
    id
    error {
      code
      message
    }
    externalBooking {
      ...ExternalBookingFields
    }
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const TerminalReadersDocument = gql`
    query terminalReaders {
  terminalReaders {
    ...TerminalReaderFields
  }
}
    ${TerminalReaderFieldsFragmentDoc}`;
export const RegisterTerminalReaderDocument = gql`
    mutation registerTerminalReader($data: RegisterTerminalReaderInput!) {
  registerTerminalReader(data: $data) {
    ...TerminalReaderFields
  }
}
    ${TerminalReaderFieldsFragmentDoc}`;
export const RemoveTerminalReaderDocument = gql`
    mutation removeTerminalReader($readerId: String!) {
  removeTerminalReader(readerId: $readerId)
}
    `;
export const TerminalTipSettingsDocument = gql`
    query terminalTipSettings {
  terminalTipSettings {
    ...TerminalTipSettingsFields
  }
}
    ${TerminalTipSettingsFieldsFragmentDoc}`;
export const UpdateTerminalTipSettingsDocument = gql`
    mutation updateTerminalTipSettings($data: UpdateTerminalTipSettingsInput!) {
  updateTerminalTipSettings(data: $data) {
    ...TerminalTipSettingsFields
  }
}
    ${TerminalTipSettingsFieldsFragmentDoc}`;
export const GetStripeTransactionsDocument = gql`
    query getStripeTransactions($filters: StripeTransactionsFilterInput!) {
  getStripeTransactions(filters: $filters) {
    __typename
    type
    amount
    date
    _id
    ... on StripeTransactionPayout {
      arrivalDate
      status
    }
    ... on StripeTransactionPayment {
      applicationFeeAmount
      description
      status
      customerName
      paidOn
      stripeFee
    }
    ... on StripeTransactionRefund {
      customerName
      paymentIntentId
      description
    }
    ... on StripeTransactionReferral {
      soloPayoutId
    }
    ... on StripeTransactionFee {
      stripeChargeId
    }
    ... on StripeTransactionSsPayout {
      status
    }
  }
}
    `;
export const StripeBalancesDocument = gql`
    query stripeBalances {
  stripeBalances {
    availableNow
    availableSoon
    inTransit
  }
}
    `;
export const GetProfessionalFromSaasUrlDocument = gql`
    query getProfessionalFromSaasUrl($slug: String!, $professionalId: String) {
  getProfessionalFromSaasUrl(slug: $slug, professionalId: $professionalId) {
    _id
    webPages {
      title
      path
    }
  }
}
    `;
export const GetStripeTransactionDetailsDocument = gql`
    query getStripeTransactionDetails($data: StripeTransactionDetailsInput!) {
  getStripeTransactionDetails(data: $data) {
    externalBooking {
      _id
      title
      date
      totalDuration
    }
    crmInvoice {
      _id
      usageLines {
        ids
        usageType
      }
      startDate
      endDate
    }
    rewards {
      rewardType
      rewardDate
      amount
    }
    ssPayout {
      _id
      status
      amount
      items {
        bookingId
        adjustmentId
        amount
        date
        note
        type
      }
    }
    giftCard {
      ...ExternalGiftCardFields
    }
  }
}
    ${ExternalGiftCardFieldsFragmentDoc}`;
export const GetAccountingDataDocument = gql`
    query getAccountingData($data: AccountingDataInput!) {
  getAccountingData(data: $data) {
    earnings {
      total
      accountingType
    }
    expenses {
      total
      accountingType
    }
  }
}
    `;
export const WebPageDocument = gql`
    query webPage($_id: String!) {
  webPage(_id: $_id) {
    ...WebPageFields
  }
}
    ${WebPageFieldsFragmentDoc}`;
export const CreateWebPageDocument = gql`
    mutation createWebPage($data: WebPageInput!) {
  createWebPage(data: $data) {
    ...WebPageFields
  }
}
    ${WebPageFieldsFragmentDoc}`;
export const UpdateWebPageDocument = gql`
    mutation updateWebPage($_id: String!, $data: WebPageInput!) {
  updateWebPage(_id: $_id, data: $data) {
    ...WebPageFields
  }
}
    ${WebPageFieldsFragmentDoc}`;
export const DeleteWebPageDocument = gql`
    mutation deleteWebPage($path: String!) {
  deleteWebPage(path: $path)
}
    `;
export const WebPagesDocument = gql`
    query webPages {
  webPages {
    ...WebPageFields
  }
}
    ${WebPageFieldsFragmentDoc}`;
export const CreateDefaultWebPagesDocument = gql`
    mutation createDefaultWebPages($businessType: String) {
  createDefaultWebPages(businessType: $businessType) {
    ...WebPageFields
  }
}
    ${WebPageFieldsFragmentDoc}`;
export const Dev_RemoveAllWebPagesDocument = gql`
    mutation dev_RemoveAllWebPages {
  dev_RemoveAllWebPages
}
    `;
export const GetLoyaltySchemesDocument = gql`
    query getLoyaltySchemes {
  getLoyaltySchemes {
    ...LoyaltySchemeFields
  }
}
    ${LoyaltySchemeFieldsFragmentDoc}`;
export const UpdateLoyaltySchemeDocument = gql`
    mutation updateLoyaltyScheme($scheme: LoyaltySchemeInput!) {
  updateLoyaltyScheme(scheme: $scheme) {
    ...LoyaltySchemeFields
  }
}
    ${LoyaltySchemeFieldsFragmentDoc}`;
export const CreateLoyaltySchemeDocument = gql`
    mutation createLoyaltyScheme($scheme: LoyaltySchemeInput!) {
  createLoyaltyScheme(scheme: $scheme) {
    ...LoyaltySchemeFields
  }
}
    ${LoyaltySchemeFieldsFragmentDoc}`;
export const CampaignsForLoyaltySchemeDocument = gql`
    query campaignsForLoyaltyScheme {
  campaignsForLoyaltyScheme {
    emails {
      ...EmailCampaignFields
    }
    sms {
      ...SmsCampaignFields
    }
    automatedCampaigns {
      ...AutomatedCampaignFields
    }
  }
}
    ${EmailCampaignFieldsFragmentDoc}
${SmsCampaignFieldsFragmentDoc}
${AutomatedCampaignFieldsFragmentDoc}`;
export const CampaignsForClientReferralSchemeDocument = gql`
    query campaignsForClientReferralScheme {
  campaignsForClientReferralScheme {
    emails {
      ...EmailCampaignFields
    }
    sms {
      ...SmsCampaignFields
    }
    automatedCampaigns {
      ...AutomatedCampaignFields
    }
  }
}
    ${EmailCampaignFieldsFragmentDoc}
${SmsCampaignFieldsFragmentDoc}
${AutomatedCampaignFieldsFragmentDoc}`;
export const ActivitiesDocument = gql`
    query activities {
  activities {
    _id
    activityId
    status
    professionalId
    priority
    title
    body
    link
    icon
    iconColor
    expiryDate
    persistAfterInteraction
  }
}
    `;
export const UpdateActivityStatusDocument = gql`
    mutation updateActivityStatus($_id: String!, $status: ActivityStatus!) {
  updateActivityStatus(_id: $_id, status: $status) {
    _id
    activityId
    status
    professionalId
    priority
    title
    body
    link
    icon
    iconColor
    expiryDate
    persistAfterInteraction
  }
}
    `;
export const ExternalGiftCardsDocument = gql`
    query externalGiftCards($filter: JSONObject, $sort: JSONObject, $pagination: Pagination) {
  externalGiftCards(filter: $filter, sort: $sort, pagination: $pagination) {
    ...ExternalGiftCardFields
  }
}
    ${ExternalGiftCardFieldsFragmentDoc}`;
export const ExternalGiftCardDocument = gql`
    query externalGiftCard($_id: String!) {
  externalGiftCard(_id: $_id) {
    ...ExternalGiftCardFields
  }
}
    ${ExternalGiftCardFieldsFragmentDoc}`;
export const RefundExternalGiftCardDocument = gql`
    mutation refundExternalGiftCard($_id: String!, $amount: Int!) {
  refundExternalGiftCard(_id: $_id, amount: $amount) {
    ...ExternalGiftCardFields
  }
}
    ${ExternalGiftCardFieldsFragmentDoc}`;
export const ApplyExternalGiftCardDocument = gql`
    mutation applyExternalGiftCard($_id: String!, $externalBookingId: String!) {
  applyExternalGiftCard(_id: $_id, externalBookingId: $externalBookingId) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const CreateExternalGiftCardDocument = gql`
    mutation createExternalGiftCard($data: CreateExternalGiftCardInput!) {
  createExternalGiftCard(data: $data) {
    ...ExternalGiftCardFields
  }
}
    ${ExternalGiftCardFieldsFragmentDoc}`;
export const UpdateExternalGiftCardDocument = gql`
    mutation updateExternalGiftCard($data: UpdateExternalGiftCardInput!) {
  updateExternalGiftCard(data: $data) {
    ...ExternalGiftCardFields
  }
}
    ${ExternalGiftCardFieldsFragmentDoc}`;
export const RefundExternalGiftCardPaymentDocument = gql`
    mutation refundExternalGiftCardPayment($_id: String!, $amount: Int!, $externalBookingId: String!) {
  refundExternalGiftCardPayment(
    _id: $_id
    amount: $amount
    externalBookingId: $externalBookingId
  ) {
    ...ExternalBookingFields
  }
}
    ${ExternalBookingFieldsFragmentDoc}`;
export const SearchExternalGiftCardsDocument = gql`
    query searchExternalGiftCards($search: String!) {
  searchExternalGiftCards(search: $search) {
    ...ExternalGiftCardFields
  }
}
    ${ExternalGiftCardFieldsFragmentDoc}`;
export const EstimateSmsCampaignCostDocument = gql`
    query estimateSmsCampaignCost($data: EstimateSmsCampaignCostInput!) {
  estimateSmsCampaignCost(data: $data)
}
    `;
export const GetHtmlForBlocksDocument = gql`
    query getHTMLForBlocks($data: GetHTMLForBlocksInput!) {
  getHTMLForBlocks(data: $data)
}
    `;
export const GetEmailTemplatesDocument = gql`
    query getEmailTemplates {
  getEmailTemplates {
    version
    emailTemplates
  }
}
    `;
export const ConnectGoogleAuthUrlDocument = gql`
    query connectGoogleAuthUrl($service: String!, $redirectPath: String) {
  connectGoogleAuthUrl(service: $service, redirectPath: $redirectPath)
}
    `;
export const DisconnectGoogleAuthDocument = gql`
    mutation disconnectGoogleAuth($service: String!) {
  disconnectGoogleAuth(service: $service) {
    ...ProfessionalFields
  }
}
    ${ProfessionalFieldsFragmentDoc}`;
export const GetGoogleBusinessDetailsDocument = gql`
    query getGoogleBusinessDetails {
  getGoogleBusinessDetails {
    name
    accountName
    type
    verificationState
    vettedState
    locations {
      name
      title
      storefrontAddress
      websiteUri
      placeId
      mapsUri
    }
  }
}
    `;
export const SelectGoogleBusinessAccountLocationDocument = gql`
    mutation selectGoogleBusinessAccountLocation($accountId: String!, $locationId: String!, $placeId: String) {
  selectGoogleBusinessAccountLocation(
    accountId: $accountId
    locationId: $locationId
    placeId: $placeId
  ) {
    ...ProfessionalFields
  }
}
    ${ProfessionalFieldsFragmentDoc}`;
export const ImportGoogleReviewsDocument = gql`
    mutation importGoogleReviews($minRating: Int!) {
  importGoogleReviews(minRating: $minRating)
}
    `;
export const DeleteImportedGoogleReviewsDocument = gql`
    mutation deleteImportedGoogleReviews {
  deleteImportedGoogleReviews
}
    `;
export const VerifyMagicLinkTokenDocument = gql`
    mutation verifyMagicLinkToken($token: String!) {
  verifyMagicLinkToken(token: $token) {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const GetMagicLinkTokenInfoDocument = gql`
    query getMagicLinkTokenInfo($token: String!) {
  getMagicLinkTokenInfo(token: $token) {
    email
    userId
  }
}
    `;
export const SendMagicLinkEmailDocument = gql`
    mutation sendMagicLinkEmail($email: String!, $adminEmail: String) {
  sendMagicLinkEmail(email: $email, adminEmail: $adminEmail)
}
    `;
export const GetGoogleStatsDocument = gql`
    query getGoogleStats($periods: [PeriodsInput!]!, $testProfileUrl: String) {
  getGoogleStats(periods: $periods, testProfileUrl: $testProfileUrl) {
    currentPeriod {
      analytics {
        keys
        clicks
        impressions
        ctr
        position
      }
      searchTerms {
        keys
        clicks
        impressions
        ctr
        position
      }
    }
    previousPeriod {
      analytics {
        keys
        clicks
        impressions
        ctr
        position
      }
      searchTerms {
        keys
        clicks
        impressions
        ctr
        position
      }
    }
  }
}
    `;
export const GetIncomeStatsDocument = gql`
    query getIncomeStats($input: IncomeStatsInput!) {
  getIncomeStats(input: $input) {
    day
    income
    bookings
  }
}
    `;
export const GetStatsOverviewDocument = gql`
    query getStatsOverview($periods: [PeriodsInput!]!, $memberId: String) {
  getStatsOverview(periods: $periods, memberId: $memberId) {
    averageBookingDiscount {
      currentPeriod
      previousPeriod
    }
    averageBookingHourlyRate {
      currentPeriod
      previousPeriod
    }
    averageBookingValue {
      currentPeriod
      previousPeriod
    }
    clicks {
      currentPeriod
      previousPeriod
    }
    completedBookings {
      currentPeriod
      previousPeriod
    }
    impressions {
      currentPeriod
      previousPeriod
    }
    newBookings {
      currentPeriod
      previousPeriod
    }
    repeatBookings {
      currentPeriod
      previousPeriod
    }
    websiteBookings {
      currentPeriod
      previousPeriod
    }
    websiteConversionRate {
      currentPeriod
      previousPeriod
    }
    websiteVisits {
      currentPeriod
      previousPeriod
    }
    topKeywords
  }
}
    `;
export const ProfessionalImageDocument = gql`
    query professionalImage($id: String!) {
  professionalImage(id: $id) {
    _id
    url
    professionalId
    createdAt
    updatedAt
  }
}
    `;
export const ProfessionalImagesByProfessionalDocument = gql`
    query professionalImagesByProfessional {
  professionalImagesByProfessional {
    _id
    url
    professionalId
    createdAt
    updatedAt
  }
}
    `;
export const CreateProfessionalImageDocument = gql`
    mutation createProfessionalImage($input: ProfessionalImageInput!) {
  createProfessionalImage(input: $input) {
    _id
    url
    professionalId
    createdAt
    updatedAt
  }
}
    `;
export const DeleteProfessionalImageDocument = gql`
    mutation deleteProfessionalImage($input: DeleteProfessionalImageInput!) {
  deleteProfessionalImage(input: $input) {
    _id
    url
    professionalId
    createdAt
    updatedAt
  }
}
    `;
export const FindPageReferencesDocument = gql`
    query findPageReferences($path: String!, $professionalId: String!) {
  findPageReferences(path: $path, professionalId: $professionalId) {
    totalCount
  }
}
    `;
export const GetFeesPerCountryDocument = gql`
    query getFeesPerCountry($currency: String!) {
  getFeesPerCountry(currency: $currency) {
    terminal {
      percentage
      fixed
    }
    online {
      percentage
      fixed
    }
  }
}
    `;
export const ExtendTrialDocument = gql`
    mutation extendTrial($data: ExtendTrialInput!) {
  extendTrial(data: $data)
}
    `;
export const SeoAnalysisDocument = gql`
    query seoAnalysis($analysisText: SeoPageDataText!, $location: String!, $primaryKeywords: [String!]!, $secondaryKeywords: [String!]!, $businessName: String!) {
  seoAnalysis(
    analysisText: $analysisText
    location: $location
    primaryKeywords: $primaryKeywords
    secondaryKeywords: $secondaryKeywords
    businessName: $businessName
  ) {
    rank
    improvementSuggestion
    alternatives
  }
}
    `;
export const GetBusinessProfileDataDocument = gql`
    query getBusinessProfileData($useRandomData: Boolean) {
  getBusinessProfileData(useRandomData: $useRandomData) {
    ...BusinessProfileDataFields
  }
}
    ${BusinessProfileDataFieldsFragmentDoc}`;
export const ThemePresetsDocument = gql`
    query themePresets {
  themePresets {
    name
    blockColor
    themeSettings {
      colorPrimary
      colorSecondary
      colorNeutralLight
      colorNeutralDark
      cornerStyle
      shadowStyle
      titlesFont
      titlesMotif
      bodyFont
    }
    headerBlockSettings {
      filter
      imageBorderWidth
      titleSize
      shape
      textPosition
      textColor
      borderStyle
      showReviews
      noImage
    }
  }
}
    `;
export const ScrapeUrlDocument = gql`
    mutation scrapeUrl($url: String!, $onboardingId: String!) {
  scrapeUrl(url: $url, onboardingId: $onboardingId) {
    items {
      ...ExternalTreatmentFields
    }
    pageInfo {
      about
      businessName
      galleryImages
    }
    stageTimings
  }
}
    ${ExternalTreatmentFieldsFragmentDoc}`;
export const ResetAccountDocument = gql`
    mutation resetAccount {
  resetAccount
}
    `;
export const ReplyToGoogleReviewDocument = gql`
    mutation replyToGoogleReview($reviewId: String!, $comment: String!) {
  replyToGoogleReview(reviewId: $reviewId, comment: $comment) {
    ...ExternalReviewFields
  }
}
    ${ExternalReviewFieldsFragmentDoc}`;
export const DeleteGoogleReviewReplyDocument = gql`
    mutation deleteGoogleReviewReply($reviewId: String!) {
  deleteGoogleReviewReply(reviewId: $reviewId) {
    ...ExternalReviewFields
  }
}
    ${ExternalReviewFieldsFragmentDoc}`;
export const SuggestReviewRepliesDocument = gql`
    mutation suggestReviewReplies($reviewText: String!, $toneOfVoice: ReviewReplyTone!, $starRating: Int, $businessName: String, $reviewerName: String) {
  suggestReviewReplies(
    reviewText: $reviewText
    toneOfVoice: $toneOfVoice
    starRating: $starRating
    businessName: $businessName
    reviewerName: $reviewerName
  ) {
    suggestion
  }
}
    `;
export const UpdateSalonMemberPermissionsDocument = gql`
    mutation updateSalonMemberPermissions($salonMemberId: String!, $permissions: [SalonMemberPermission!]!) {
  updateSalonMemberPermissions(
    salonMemberId: $salonMemberId
    permissions: $permissions
  ) {
    _id
    salonId
    memberId
    permissions
    displayName
  }
}
    `;
export const UpdateSalonMemberDocument = gql`
    mutation updateSalonMember($salonMemberId: String!, $color: String, $displayName: String, $picture: String, $title: String, $completedOnboardingSteps: [SalonMemberOnboardingStep!]) {
  updateSalonMember(
    salonMemberId: $salonMemberId
    color: $color
    displayName: $displayName
    picture: $picture
    title: $title
    completedOnboardingSteps: $completedOnboardingSteps
  ) {
    _id
    color
    displayName
    picture
    title
    memberId
    salonId
    permissions
    completedOnboardingSteps
  }
}
    `;
export const CreateSalonReceptionistAccountDocument = gql`
    mutation createSalonReceptionistAccount($name: String!, $email: String!, $color: String!) {
  createSalonReceptionistAccount(name: $name, email: $email, color: $color) {
    _id
    name
    email
    createdAt
  }
}
    `;
export const UpdateSalonReceptionistAccountDocument = gql`
    mutation updateSalonReceptionistAccount($salonMemberId: String!, $name: String, $email: String) {
  updateSalonReceptionistAccount(
    salonMemberId: $salonMemberId
    name: $name
    email: $email
  ) {
    _id
    name
    email
    createdAt
  }
}
    `;
export const ArchiveSalonMemberDocument = gql`
    mutation archiveSalonMember($salonMemberId: String!) {
  archiveSalonMember(salonMemberId: $salonMemberId)
}
    `;
export const RestoreSalonMemberDocument = gql`
    mutation restoreSalonMember($salonMemberId: String!) {
  restoreSalonMember(salonMemberId: $salonMemberId)
}
    `;
export const ArchivedSalonMembersDocument = gql`
    query archivedSalonMembers {
  archivedSalonMembers {
    _id
    salonId
    memberId
    displayName
    createdAt
    updatedAt
  }
}
    `;
export const SendReceptionistMagicLinkDocument = gql`
    mutation sendReceptionistMagicLink($receptionistId: String!) {
  sendReceptionistMagicLink(receptionistId: $receptionistId)
}
    `;
export const InviteMemberDocument = gql`
    mutation inviteMember($name: String!, $phoneNumber: String!, $color: String!, $addSeat: Boolean) {
  inviteMember(
    name: $name
    phoneNumber: $phoneNumber
    color: $color
    addSeat: $addSeat
  ) {
    _id
    memberId
    displayName
    mobile
    createdAt
    inviteSentAt
  }
}
    `;
export const Dev_SetSalonSeatsDocument = gql`
    mutation dev_setSalonSeats($seats: Int!) {
  dev_setSalonSeats(seats: $seats)
}
    `;
export const Dev_ClearOwnBusinessDocument = gql`
    mutation dev_clearOwnBusiness {
  dev_clearOwnBusiness {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const Dev_LeaveSalonDocument = gql`
    mutation dev_leaveSalon($salonId: String!) {
  dev_leaveSalon(salonId: $salonId)
}
    `;
export const Dev_DeleteSalonDocument = gql`
    mutation dev_deleteSalon($salonId: String!) {
  dev_deleteSalon(salonId: $salonId)
}
    `;
export const CancelMemberInviteDocument = gql`
    mutation cancelMemberInvite($salonMemberId: String!) {
  cancelMemberInvite(salonMemberId: $salonMemberId)
}
    `;
export const ResendMemberInviteDocument = gql`
    mutation resendMemberInvite($salonMemberId: String!) {
  resendMemberInvite(salonMemberId: $salonMemberId) {
    _id
    displayName
    status
    inviteSentAt
    inviteCode
  }
}
    `;
export const CheckInviteCodeDocument = gql`
    query checkInviteCode($inviteCode: String!) {
  checkInviteCode(inviteCode: $inviteCode) {
    businessName
  }
}
    `;
export const IdentifyWithInviteCodeDocument = gql`
    mutation identifyWithInviteCode($inviteCode: String!, $mobile: String!) {
  identifyWithInviteCode(inviteCode: $inviteCode, mobile: $mobile) {
    authToken {
      role
      auth
    }
  }
}
    `;
export const VerifyMobileAndJoinSalonDocument = gql`
    mutation verifyMobileAndJoinSalon($inviteCode: String!, $mobile: String!, $code: String!, $userData: SalonMemberDetails!) {
  verifyMobileAndJoinSalon(
    inviteCode: $inviteCode
    mobile: $mobile
    code: $code
    userData: $userData
  ) {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const VerifyMobileAndCreateSalonDocument = gql`
    mutation verifyMobileAndCreateSalon($mobile: String!, $code: String!, $userData: RegistrationDetails!, $onboardingId: String!, $trialLength: Int!) {
  verifyMobileAndCreateSalon(
    mobile: $mobile
    code: $code
    userData: $userData
    onboardingId: $onboardingId
    trialLength: $trialLength
  ) {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const CreateSalonDocument = gql`
    mutation createSalon($businessName: String!, $onboardingId: String, $trialLength: Int, $referrer: String) {
  createSalon(
    businessName: $businessName
    onboardingId: $onboardingId
    trialLength: $trialLength
    referrer: $referrer
  ) {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export const JoinSalonDocument = gql`
    mutation joinSalon($inviteCode: String!) {
  joinSalon(inviteCode: $inviteCode) {
    ...SalonMembershipFields
  }
}
    ${SalonMembershipFieldsFragmentDoc}`;
export const CreateSoloBusinessDocument = gql`
    mutation createSoloBusiness($businessName: String!, $onboardingId: String, $trialLength: Int, $referrer: String) {
  createSoloBusiness(
    businessName: $businessName
    onboardingId: $onboardingId
    trialLength: $trialLength
    referrer: $referrer
  ) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const GetSalonDocument = gql`
    query getSalon {
  salon {
    salonId
    salon {
      _id
    }
    members {
      _id
      salonId
      memberId
      permissions
      color
      displayName
      picture
      title
      status
      createdAt
      inviteSentAt
      inviteCode
      completedOnboardingSteps
      member {
        _id
        firstName
        lastName
        emailAddress
        mobile
      }
    }
  }
}
    `;
export const MySalonMembershipsDocument = gql`
    query mySalonMemberships {
  mySalonMemberships {
    ...SalonMembershipFields
  }
}
    ${SalonMembershipFieldsFragmentDoc}`;
export type Requester<C = {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    getConfig(variables?: GetConfigQueryVariables, options?: C): Promise<GetConfigQuery> {
      return requester<GetConfigQuery, GetConfigQueryVariables>(GetConfigDocument, variables, options) as Promise<GetConfigQuery>;
    },
    getConfigAndMessages(variables: GetConfigAndMessagesQueryVariables, options?: C): Promise<GetConfigAndMessagesQuery> {
      return requester<GetConfigAndMessagesQuery, GetConfigAndMessagesQueryVariables>(GetConfigAndMessagesDocument, variables, options) as Promise<GetConfigAndMessagesQuery>;
    },
    checkBlockedUser(variables?: CheckBlockedUserQueryVariables, options?: C): Promise<CheckBlockedUserQuery> {
      return requester<CheckBlockedUserQuery, CheckBlockedUserQueryVariables>(CheckBlockedUserDocument, variables, options) as Promise<CheckBlockedUserQuery>;
    },
    sendPreviewEmail(variables: SendPreviewEmailQueryVariables, options?: C): Promise<SendPreviewEmailQuery> {
      return requester<SendPreviewEmailQuery, SendPreviewEmailQueryVariables>(SendPreviewEmailDocument, variables, options) as Promise<SendPreviewEmailQuery>;
    },
    plansWithPrice(variables: PlansWithPriceQueryVariables, options?: C): Promise<PlansWithPriceQuery> {
      return requester<PlansWithPriceQuery, PlansWithPriceQueryVariables>(PlansWithPriceDocument, variables, options) as Promise<PlansWithPriceQuery>;
    },
    addonPrices(variables: AddonPricesQueryVariables, options?: C): Promise<AddonPricesQuery> {
      return requester<AddonPricesQuery, AddonPricesQueryVariables>(AddonPricesDocument, variables, options) as Promise<AddonPricesQuery>;
    },
    logout(variables?: LogoutMutationVariables, options?: C): Promise<LogoutMutation> {
      return requester<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables, options) as Promise<LogoutMutation>;
    },
    getMagicLinkToken(variables?: GetMagicLinkTokenMutationVariables, options?: C): Promise<GetMagicLinkTokenMutation> {
      return requester<GetMagicLinkTokenMutation, GetMagicLinkTokenMutationVariables>(GetMagicLinkTokenDocument, variables, options) as Promise<GetMagicLinkTokenMutation>;
    },
    getUserTraits(variables?: GetUserTraitsQueryVariables, options?: C): Promise<GetUserTraitsQuery> {
      return requester<GetUserTraitsQuery, GetUserTraitsQueryVariables>(GetUserTraitsDocument, variables, options) as Promise<GetUserTraitsQuery>;
    },
    appVer(variables?: AppVerQueryVariables, options?: C): Promise<AppVerQuery> {
      return requester<AppVerQuery, AppVerQueryVariables>(AppVerDocument, variables, options) as Promise<AppVerQuery>;
    },
    deleteSaasData(variables: DeleteSaasDataMutationVariables, options?: C): Promise<DeleteSaasDataMutation> {
      return requester<DeleteSaasDataMutation, DeleteSaasDataMutationVariables>(DeleteSaasDataDocument, variables, options) as Promise<DeleteSaasDataMutation>;
    },
    identifyWithMobile(variables?: IdentifyWithMobileQueryVariables, options?: C): Promise<IdentifyWithMobileQuery> {
      return requester<IdentifyWithMobileQuery, IdentifyWithMobileQueryVariables>(IdentifyWithMobileDocument, variables, options) as Promise<IdentifyWithMobileQuery>;
    },
    sendMobileVerification(variables?: SendMobileVerificationQueryVariables, options?: C): Promise<SendMobileVerificationQuery> {
      return requester<SendMobileVerificationQuery, SendMobileVerificationQueryVariables>(SendMobileVerificationDocument, variables, options) as Promise<SendMobileVerificationQuery>;
    },
    verifyMobileAndSignIn(variables?: VerifyMobileAndSignInMutationVariables, options?: C): Promise<VerifyMobileAndSignInMutation> {
      return requester<VerifyMobileAndSignInMutation, VerifyMobileAndSignInMutationVariables>(VerifyMobileAndSignInDocument, variables, options) as Promise<VerifyMobileAndSignInMutation>;
    },
    signInAsSalon(variables: SignInAsSalonMutationVariables, options?: C): Promise<SignInAsSalonMutation> {
      return requester<SignInAsSalonMutation, SignInAsSalonMutationVariables>(SignInAsSalonDocument, variables, options) as Promise<SignInAsSalonMutation>;
    },
    signOutOfSalon(variables?: SignOutOfSalonMutationVariables, options?: C): Promise<SignOutOfSalonMutation> {
      return requester<SignOutOfSalonMutation, SignOutOfSalonMutationVariables>(SignOutOfSalonDocument, variables, options) as Promise<SignOutOfSalonMutation>;
    },
    addReferralToUser(variables: AddReferralToUserMutationVariables, options?: C): Promise<AddReferralToUserMutation> {
      return requester<AddReferralToUserMutation, AddReferralToUserMutationVariables>(AddReferralToUserDocument, variables, options) as Promise<AddReferralToUserMutation>;
    },
    reviews(variables?: ReviewsQueryVariables, options?: C): Promise<ReviewsQuery> {
      return requester<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, variables, options) as Promise<ReviewsQuery>;
    },
    answers(variables: AnswersMutationVariables, options?: C): Promise<AnswersMutation> {
      return requester<AnswersMutation, AnswersMutationVariables>(AnswersDocument, variables, options) as Promise<AnswersMutation>;
    },
    chats(variables?: ChatsQueryVariables, options?: C): Promise<ChatsQuery> {
      return requester<ChatsQuery, ChatsQueryVariables>(ChatsDocument, variables, options) as Promise<ChatsQuery>;
    },
    marketplaceListing(variables?: MarketplaceListingQueryVariables, options?: C): Promise<MarketplaceListingQuery> {
      return requester<MarketplaceListingQuery, MarketplaceListingQueryVariables>(MarketplaceListingDocument, variables, options) as Promise<MarketplaceListingQuery>;
    },
    markChatAsRead(variables: MarkChatAsReadMutationVariables, options?: C): Promise<MarkChatAsReadMutation> {
      return requester<MarkChatAsReadMutation, MarkChatAsReadMutationVariables>(MarkChatAsReadDocument, variables, options) as Promise<MarkChatAsReadMutation>;
    },
    findOrCreateChat(variables: FindOrCreateChatMutationVariables, options?: C): Promise<FindOrCreateChatMutation> {
      return requester<FindOrCreateChatMutation, FindOrCreateChatMutationVariables>(FindOrCreateChatDocument, variables, options) as Promise<FindOrCreateChatMutation>;
    },
    getUnreadMessages(variables?: GetUnreadMessagesQueryVariables, options?: C): Promise<GetUnreadMessagesQuery> {
      return requester<GetUnreadMessagesQuery, GetUnreadMessagesQueryVariables>(GetUnreadMessagesDocument, variables, options) as Promise<GetUnreadMessagesQuery>;
    },
    bookings(variables?: BookingsQueryVariables, options?: C): Promise<BookingsQuery> {
      return requester<BookingsQuery, BookingsQueryVariables>(BookingsDocument, variables, options) as Promise<BookingsQuery>;
    },
    booking(variables?: BookingQueryVariables, options?: C): Promise<BookingQuery> {
      return requester<BookingQuery, BookingQueryVariables>(BookingDocument, variables, options) as Promise<BookingQuery>;
    },
    rejectBooking(variables?: RejectBookingMutationVariables, options?: C): Promise<RejectBookingMutation> {
      return requester<RejectBookingMutation, RejectBookingMutationVariables>(RejectBookingDocument, variables, options) as Promise<RejectBookingMutation>;
    },
    acceptBooking(variables?: AcceptBookingMutationVariables, options?: C): Promise<AcceptBookingMutation> {
      return requester<AcceptBookingMutation, AcceptBookingMutationVariables>(AcceptBookingDocument, variables, options) as Promise<AcceptBookingMutation>;
    },
    hasBookingClash(variables?: HasBookingClashQueryVariables, options?: C): Promise<HasBookingClashQuery> {
      return requester<HasBookingClashQuery, HasBookingClashQueryVariables>(HasBookingClashDocument, variables, options) as Promise<HasBookingClashQuery>;
    },
    professionalRequestResponse(variables?: ProfessionalRequestResponseMutationVariables, options?: C): Promise<ProfessionalRequestResponseMutation> {
      return requester<ProfessionalRequestResponseMutation, ProfessionalRequestResponseMutationVariables>(ProfessionalRequestResponseDocument, variables, options) as Promise<ProfessionalRequestResponseMutation>;
    },
    updateBookingStatus(variables?: UpdateBookingStatusMutationVariables, options?: C): Promise<UpdateBookingStatusMutation> {
      return requester<UpdateBookingStatusMutation, UpdateBookingStatusMutationVariables>(UpdateBookingStatusDocument, variables, options) as Promise<UpdateBookingStatusMutation>;
    },
    createReview(variables?: CreateReviewMutationVariables, options?: C): Promise<CreateReviewMutation> {
      return requester<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument, variables, options) as Promise<CreateReviewMutation>;
    },
    createMockReview(variables?: CreateMockReviewMutationVariables, options?: C): Promise<CreateMockReviewMutation> {
      return requester<CreateMockReviewMutation, CreateMockReviewMutationVariables>(CreateMockReviewDocument, variables, options) as Promise<CreateMockReviewMutation>;
    },
    getProfessionalAvailability(variables?: GetProfessionalAvailabilityQueryVariables, options?: C): Promise<GetProfessionalAvailabilityQuery> {
      return requester<GetProfessionalAvailabilityQuery, GetProfessionalAvailabilityQueryVariables>(GetProfessionalAvailabilityDocument, variables, options) as Promise<GetProfessionalAvailabilityQuery>;
    },
    professionalsAvailableAtLocations(variables: ProfessionalsAvailableAtLocationsQueryVariables, options?: C): Promise<ProfessionalsAvailableAtLocationsQuery> {
      return requester<ProfessionalsAvailableAtLocationsQuery, ProfessionalsAvailableAtLocationsQueryVariables>(ProfessionalsAvailableAtLocationsDocument, variables, options) as Promise<ProfessionalsAvailableAtLocationsQuery>;
    },
    availabilitySuggestions(variables?: AvailabilitySuggestionsQueryVariables, options?: C): Promise<AvailabilitySuggestionsQuery> {
      return requester<AvailabilitySuggestionsQuery, AvailabilitySuggestionsQueryVariables>(AvailabilitySuggestionsDocument, variables, options) as Promise<AvailabilitySuggestionsQuery>;
    },
    getProfessionalAgendas(variables?: GetProfessionalAgendasQueryVariables, options?: C): Promise<GetProfessionalAgendasQuery> {
      return requester<GetProfessionalAgendasQuery, GetProfessionalAgendasQueryVariables>(GetProfessionalAgendasDocument, variables, options) as Promise<GetProfessionalAgendasQuery>;
    },
    externalBooking(variables: ExternalBookingQueryVariables, options?: C): Promise<ExternalBookingQuery> {
      return requester<ExternalBookingQuery, ExternalBookingQueryVariables>(ExternalBookingDocument, variables, options) as Promise<ExternalBookingQuery>;
    },
    sendReminder(variables: SendReminderMutationVariables, options?: C): Promise<SendReminderMutation> {
      return requester<SendReminderMutation, SendReminderMutationVariables>(SendReminderDocument, variables, options) as Promise<SendReminderMutation>;
    },
    externalBookings(variables?: ExternalBookingsQueryVariables, options?: C): Promise<ExternalBookingsQuery> {
      return requester<ExternalBookingsQuery, ExternalBookingsQueryVariables>(ExternalBookingsDocument, variables, options) as Promise<ExternalBookingsQuery>;
    },
    refundStripePayment(variables: RefundStripePaymentMutationVariables, options?: C): Promise<RefundStripePaymentMutation> {
      return requester<RefundStripePaymentMutation, RefundStripePaymentMutationVariables>(RefundStripePaymentDocument, variables, options) as Promise<RefundStripePaymentMutation>;
    },
    createOrUpdateExternalBooking(variables?: CreateOrUpdateExternalBookingMutationVariables, options?: C): Promise<CreateOrUpdateExternalBookingMutation> {
      return requester<CreateOrUpdateExternalBookingMutation, CreateOrUpdateExternalBookingMutationVariables>(CreateOrUpdateExternalBookingDocument, variables, options) as Promise<CreateOrUpdateExternalBookingMutation>;
    },
    updateSpecificExternalBookingData(variables: UpdateSpecificExternalBookingDataMutationVariables, options?: C): Promise<UpdateSpecificExternalBookingDataMutation> {
      return requester<UpdateSpecificExternalBookingDataMutation, UpdateSpecificExternalBookingDataMutationVariables>(UpdateSpecificExternalBookingDataDocument, variables, options) as Promise<UpdateSpecificExternalBookingDataMutation>;
    },
    bookingHasConflicts(variables: BookingHasConflictsQueryVariables, options?: C): Promise<BookingHasConflictsQuery> {
      return requester<BookingHasConflictsQuery, BookingHasConflictsQueryVariables>(BookingHasConflictsDocument, variables, options) as Promise<BookingHasConflictsQuery>;
    },
    deleteExternalBooking(variables?: DeleteExternalBookingMutationVariables, options?: C): Promise<DeleteExternalBookingMutation> {
      return requester<DeleteExternalBookingMutation, DeleteExternalBookingMutationVariables>(DeleteExternalBookingDocument, variables, options) as Promise<DeleteExternalBookingMutation>;
    },
    acceptRescheduledBooking(variables: AcceptRescheduledBookingMutationVariables, options?: C): Promise<AcceptRescheduledBookingMutation> {
      return requester<AcceptRescheduledBookingMutation, AcceptRescheduledBookingMutationVariables>(AcceptRescheduledBookingDocument, variables, options) as Promise<AcceptRescheduledBookingMutation>;
    },
    rejectRescheduledBooking(variables: RejectRescheduledBookingMutationVariables, options?: C): Promise<RejectRescheduledBookingMutation> {
      return requester<RejectRescheduledBookingMutation, RejectRescheduledBookingMutationVariables>(RejectRescheduledBookingDocument, variables, options) as Promise<RejectRescheduledBookingMutation>;
    },
    resolveRescheduledBooking(variables: ResolveRescheduledBookingMutationVariables, options?: C): Promise<ResolveRescheduledBookingMutation> {
      return requester<ResolveRescheduledBookingMutation, ResolveRescheduledBookingMutationVariables>(ResolveRescheduledBookingDocument, variables, options) as Promise<ResolveRescheduledBookingMutation>;
    },
    acceptExternalBooking(variables: AcceptExternalBookingMutationVariables, options?: C): Promise<AcceptExternalBookingMutation> {
      return requester<AcceptExternalBookingMutation, AcceptExternalBookingMutationVariables>(AcceptExternalBookingDocument, variables, options) as Promise<AcceptExternalBookingMutation>;
    },
    declineExternalBooking(variables: DeclineExternalBookingMutationVariables, options?: C): Promise<DeclineExternalBookingMutation> {
      return requester<DeclineExternalBookingMutation, DeclineExternalBookingMutationVariables>(DeclineExternalBookingDocument, variables, options) as Promise<DeclineExternalBookingMutation>;
    },
    cancelAndRefundExternalBooking(variables: CancelAndRefundExternalBookingMutationVariables, options?: C): Promise<CancelAndRefundExternalBookingMutation> {
      return requester<CancelAndRefundExternalBookingMutation, CancelAndRefundExternalBookingMutationVariables>(CancelAndRefundExternalBookingDocument, variables, options) as Promise<CancelAndRefundExternalBookingMutation>;
    },
    cancelAndChargeExternalBooking(variables: CancelAndChargeExternalBookingMutationVariables, options?: C): Promise<CancelAndChargeExternalBookingMutation> {
      return requester<CancelAndChargeExternalBookingMutation, CancelAndChargeExternalBookingMutationVariables>(CancelAndChargeExternalBookingDocument, variables, options) as Promise<CancelAndChargeExternalBookingMutation>;
    },
    chargeExternalBooking(variables: ChargeExternalBookingMutationVariables, options?: C): Promise<ChargeExternalBookingMutation> {
      return requester<ChargeExternalBookingMutation, ChargeExternalBookingMutationVariables>(ChargeExternalBookingDocument, variables, options) as Promise<ChargeExternalBookingMutation>;
    },
    completeExternalBooking(variables: CompleteExternalBookingMutationVariables, options?: C): Promise<CompleteExternalBookingMutation> {
      return requester<CompleteExternalBookingMutation, CompleteExternalBookingMutationVariables>(CompleteExternalBookingDocument, variables, options) as Promise<CompleteExternalBookingMutation>;
    },
    createOrUpdateProfessionalAvailability(variables: CreateOrUpdateProfessionalAvailabilityMutationVariables, options?: C): Promise<CreateOrUpdateProfessionalAvailabilityMutation> {
      return requester<CreateOrUpdateProfessionalAvailabilityMutation, CreateOrUpdateProfessionalAvailabilityMutationVariables>(CreateOrUpdateProfessionalAvailabilityDocument, variables, options) as Promise<CreateOrUpdateProfessionalAvailabilityMutation>;
    },
    removeProfessionalAvailability(variables?: RemoveProfessionalAvailabilityMutationVariables, options?: C): Promise<RemoveProfessionalAvailabilityMutation> {
      return requester<RemoveProfessionalAvailabilityMutation, RemoveProfessionalAvailabilityMutationVariables>(RemoveProfessionalAvailabilityDocument, variables, options) as Promise<RemoveProfessionalAvailabilityMutation>;
    },
    getProfessional(variables?: GetProfessionalQueryVariables, options?: C): Promise<GetProfessionalQuery> {
      return requester<GetProfessionalQuery, GetProfessionalQueryVariables>(GetProfessionalDocument, variables, options) as Promise<GetProfessionalQuery>;
    },
    getProfessionalWithStripe(variables?: GetProfessionalWithStripeQueryVariables, options?: C): Promise<GetProfessionalWithStripeQuery> {
      return requester<GetProfessionalWithStripeQuery, GetProfessionalWithStripeQueryVariables>(GetProfessionalWithStripeDocument, variables, options) as Promise<GetProfessionalWithStripeQuery>;
    },
    updateProfessionalStripeData(variables?: UpdateProfessionalStripeDataMutationVariables, options?: C): Promise<UpdateProfessionalStripeDataMutation> {
      return requester<UpdateProfessionalStripeDataMutation, UpdateProfessionalStripeDataMutationVariables>(UpdateProfessionalStripeDataDocument, variables, options) as Promise<UpdateProfessionalStripeDataMutation>;
    },
    getProfessionalAvailabilityData(variables?: GetProfessionalAvailabilityDataQueryVariables, options?: C): Promise<GetProfessionalAvailabilityDataQuery> {
      return requester<GetProfessionalAvailabilityDataQuery, GetProfessionalAvailabilityDataQueryVariables>(GetProfessionalAvailabilityDataDocument, variables, options) as Promise<GetProfessionalAvailabilityDataQuery>;
    },
    updateSaasUser(variables: UpdateSaasUserMutationVariables, options?: C): Promise<UpdateSaasUserMutation> {
      return requester<UpdateSaasUserMutation, UpdateSaasUserMutationVariables>(UpdateSaasUserDocument, variables, options) as Promise<UpdateSaasUserMutation>;
    },
    updateProfessionalProfile(variables?: UpdateProfessionalProfileMutationVariables, options?: C): Promise<UpdateProfessionalProfileMutation> {
      return requester<UpdateProfessionalProfileMutation, UpdateProfessionalProfileMutationVariables>(UpdateProfessionalProfileDocument, variables, options) as Promise<UpdateProfessionalProfileMutation>;
    },
    createOrUpdateDevice(variables?: CreateOrUpdateDeviceMutationVariables, options?: C): Promise<CreateOrUpdateDeviceMutation> {
      return requester<CreateOrUpdateDeviceMutation, CreateOrUpdateDeviceMutationVariables>(CreateOrUpdateDeviceDocument, variables, options) as Promise<CreateOrUpdateDeviceMutation>;
    },
    getPostcodes(variables?: GetPostcodesQueryVariables, options?: C): Promise<GetPostcodesQuery> {
      return requester<GetPostcodesQuery, GetPostcodesQueryVariables>(GetPostcodesDocument, variables, options) as Promise<GetPostcodesQuery>;
    },
    payouts(variables?: PayoutsQueryVariables, options?: C): Promise<PayoutsQuery> {
      return requester<PayoutsQuery, PayoutsQueryVariables>(PayoutsDocument, variables, options) as Promise<PayoutsQuery>;
    },
    externalBookingPayments(variables?: ExternalBookingPaymentsQueryVariables, options?: C): Promise<ExternalBookingPaymentsQuery> {
      return requester<ExternalBookingPaymentsQuery, ExternalBookingPaymentsQueryVariables>(ExternalBookingPaymentsDocument, variables, options) as Promise<ExternalBookingPaymentsQuery>;
    },
    paymentsForExternalBooking(variables: PaymentsForExternalBookingQueryVariables, options?: C): Promise<PaymentsForExternalBookingQuery> {
      return requester<PaymentsForExternalBookingQuery, PaymentsForExternalBookingQueryVariables>(PaymentsForExternalBookingDocument, variables, options) as Promise<PaymentsForExternalBookingQuery>;
    },
    bookingStubs(variables?: BookingStubsQueryVariables, options?: C): Promise<BookingStubsQuery> {
      return requester<BookingStubsQuery, BookingStubsQueryVariables>(BookingStubsDocument, variables, options) as Promise<BookingStubsQuery>;
    },
    page(variables?: PageQueryVariables, options?: C): Promise<PageQuery> {
      return requester<PageQuery, PageQueryVariables>(PageDocument, variables, options) as Promise<PageQuery>;
    },
    settings(variables?: SettingsQueryVariables, options?: C): Promise<SettingsQuery> {
      return requester<SettingsQuery, SettingsQueryVariables>(SettingsDocument, variables, options) as Promise<SettingsQuery>;
    },
    createOrGetReferral(variables?: CreateOrGetReferralMutationVariables, options?: C): Promise<CreateOrGetReferralMutation> {
      return requester<CreateOrGetReferralMutation, CreateOrGetReferralMutationVariables>(CreateOrGetReferralDocument, variables, options) as Promise<CreateOrGetReferralMutation>;
    },
    getCrossSellPromoCode(variables: GetCrossSellPromoCodeMutationVariables, options?: C): Promise<GetCrossSellPromoCodeMutation> {
      return requester<GetCrossSellPromoCodeMutation, GetCrossSellPromoCodeMutationVariables>(GetCrossSellPromoCodeDocument, variables, options) as Promise<GetCrossSellPromoCodeMutation>;
    },
    invalidatePages(variables?: InvalidatePagesMutationVariables, options?: C): Promise<InvalidatePagesMutation> {
      return requester<InvalidatePagesMutation, InvalidatePagesMutationVariables>(InvalidatePagesDocument, variables, options) as Promise<InvalidatePagesMutation>;
    },
    adjustments(variables?: AdjustmentsQueryVariables, options?: C): Promise<AdjustmentsQuery> {
      return requester<AdjustmentsQuery, AdjustmentsQueryVariables>(AdjustmentsDocument, variables, options) as Promise<AdjustmentsQuery>;
    },
    promoCodeApplications(variables?: PromoCodeApplicationsQueryVariables, options?: C): Promise<PromoCodeApplicationsQuery> {
      return requester<PromoCodeApplicationsQuery, PromoCodeApplicationsQueryVariables>(PromoCodeApplicationsDocument, variables, options) as Promise<PromoCodeApplicationsQuery>;
    },
    categories(variables?: CategoriesQueryVariables, options?: C): Promise<CategoriesQuery> {
      return requester<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, variables, options) as Promise<CategoriesQuery>;
    },
    getParkingInformation(variables?: GetParkingInformationQueryVariables, options?: C): Promise<GetParkingInformationQuery> {
      return requester<GetParkingInformationQuery, GetParkingInformationQueryVariables>(GetParkingInformationDocument, variables, options) as Promise<GetParkingInformationQuery>;
    },
    addorUpdateParkingInformation(variables: AddorUpdateParkingInformationMutationVariables, options?: C): Promise<AddorUpdateParkingInformationMutation> {
      return requester<AddorUpdateParkingInformationMutation, AddorUpdateParkingInformationMutationVariables>(AddorUpdateParkingInformationDocument, variables, options) as Promise<AddorUpdateParkingInformationMutation>;
    },
    requestProfessionalPaymentCapability(variables?: RequestProfessionalPaymentCapabilityQueryVariables, options?: C): Promise<RequestProfessionalPaymentCapabilityQuery> {
      return requester<RequestProfessionalPaymentCapabilityQuery, RequestProfessionalPaymentCapabilityQueryVariables>(RequestProfessionalPaymentCapabilityDocument, variables, options) as Promise<RequestProfessionalPaymentCapabilityQuery>;
    },
    emailCampaigns(variables: EmailCampaignsQueryVariables, options?: C): Promise<EmailCampaignsQuery> {
      return requester<EmailCampaignsQuery, EmailCampaignsQueryVariables>(EmailCampaignsDocument, variables, options) as Promise<EmailCampaignsQuery>;
    },
    emailCampaign(variables: EmailCampaignQueryVariables, options?: C): Promise<EmailCampaignQuery> {
      return requester<EmailCampaignQuery, EmailCampaignQueryVariables>(EmailCampaignDocument, variables, options) as Promise<EmailCampaignQuery>;
    },
    createEmailCampaign(variables: CreateEmailCampaignMutationVariables, options?: C): Promise<CreateEmailCampaignMutation> {
      return requester<CreateEmailCampaignMutation, CreateEmailCampaignMutationVariables>(CreateEmailCampaignDocument, variables, options) as Promise<CreateEmailCampaignMutation>;
    },
    updateEmailCampaign(variables: UpdateEmailCampaignMutationVariables, options?: C): Promise<UpdateEmailCampaignMutation> {
      return requester<UpdateEmailCampaignMutation, UpdateEmailCampaignMutationVariables>(UpdateEmailCampaignDocument, variables, options) as Promise<UpdateEmailCampaignMutation>;
    },
    deleteAutomatedCampaigns(variables?: DeleteAutomatedCampaignsMutationVariables, options?: C): Promise<DeleteAutomatedCampaignsMutation> {
      return requester<DeleteAutomatedCampaignsMutation, DeleteAutomatedCampaignsMutationVariables>(DeleteAutomatedCampaignsDocument, variables, options) as Promise<DeleteAutomatedCampaignsMutation>;
    },
    resetAutomatedEmailThemes(variables?: ResetAutomatedEmailThemesMutationVariables, options?: C): Promise<ResetAutomatedEmailThemesMutation> {
      return requester<ResetAutomatedEmailThemesMutation, ResetAutomatedEmailThemesMutationVariables>(ResetAutomatedEmailThemesDocument, variables, options) as Promise<ResetAutomatedEmailThemesMutation>;
    },
    sendTestEmail(variables: SendTestEmailQueryVariables, options?: C): Promise<SendTestEmailQuery> {
      return requester<SendTestEmailQuery, SendTestEmailQueryVariables>(SendTestEmailDocument, variables, options) as Promise<SendTestEmailQuery>;
    },
    smsCampaigns(variables: SmsCampaignsQueryVariables, options?: C): Promise<SmsCampaignsQuery> {
      return requester<SmsCampaignsQuery, SmsCampaignsQueryVariables>(SmsCampaignsDocument, variables, options) as Promise<SmsCampaignsQuery>;
    },
    smsCampaign(variables: SmsCampaignQueryVariables, options?: C): Promise<SmsCampaignQuery> {
      return requester<SmsCampaignQuery, SmsCampaignQueryVariables>(SmsCampaignDocument, variables, options) as Promise<SmsCampaignQuery>;
    },
    createSmsCampaign(variables: CreateSmsCampaignMutationVariables, options?: C): Promise<CreateSmsCampaignMutation> {
      return requester<CreateSmsCampaignMutation, CreateSmsCampaignMutationVariables>(CreateSmsCampaignDocument, variables, options) as Promise<CreateSmsCampaignMutation>;
    },
    updateSmsCampaign(variables: UpdateSmsCampaignMutationVariables, options?: C): Promise<UpdateSmsCampaignMutation> {
      return requester<UpdateSmsCampaignMutation, UpdateSmsCampaignMutationVariables>(UpdateSmsCampaignDocument, variables, options) as Promise<UpdateSmsCampaignMutation>;
    },
    scheduledCampaign(variables?: ScheduledCampaignQueryVariables, options?: C): Promise<ScheduledCampaignQuery> {
      return requester<ScheduledCampaignQuery, ScheduledCampaignQueryVariables>(ScheduledCampaignDocument, variables, options) as Promise<ScheduledCampaignQuery>;
    },
    automatedCampaign(variables?: AutomatedCampaignQueryVariables, options?: C): Promise<AutomatedCampaignQuery> {
      return requester<AutomatedCampaignQuery, AutomatedCampaignQueryVariables>(AutomatedCampaignDocument, variables, options) as Promise<AutomatedCampaignQuery>;
    },
    updateAutomatedCampaign(variables: UpdateAutomatedCampaignMutationVariables, options?: C): Promise<UpdateAutomatedCampaignMutation> {
      return requester<UpdateAutomatedCampaignMutation, UpdateAutomatedCampaignMutationVariables>(UpdateAutomatedCampaignDocument, variables, options) as Promise<UpdateAutomatedCampaignMutation>;
    },
    updateScheduledCampaign(variables: UpdateScheduledCampaignMutationVariables, options?: C): Promise<UpdateScheduledCampaignMutation> {
      return requester<UpdateScheduledCampaignMutation, UpdateScheduledCampaignMutationVariables>(UpdateScheduledCampaignDocument, variables, options) as Promise<UpdateScheduledCampaignMutation>;
    },
    externalTreatments(variables?: ExternalTreatmentsQueryVariables, options?: C): Promise<ExternalTreatmentsQuery> {
      return requester<ExternalTreatmentsQuery, ExternalTreatmentsQueryVariables>(ExternalTreatmentsDocument, variables, options) as Promise<ExternalTreatmentsQuery>;
    },
    addOrUpdateExternalTreatment(variables: AddOrUpdateExternalTreatmentMutationVariables, options?: C): Promise<AddOrUpdateExternalTreatmentMutation> {
      return requester<AddOrUpdateExternalTreatmentMutation, AddOrUpdateExternalTreatmentMutationVariables>(AddOrUpdateExternalTreatmentDocument, variables, options) as Promise<AddOrUpdateExternalTreatmentMutation>;
    },
    updateTreatmentPricing(variables: UpdateTreatmentPricingMutationVariables, options?: C): Promise<UpdateTreatmentPricingMutation> {
      return requester<UpdateTreatmentPricingMutation, UpdateTreatmentPricingMutationVariables>(UpdateTreatmentPricingDocument, variables, options) as Promise<UpdateTreatmentPricingMutation>;
    },
    deleteExternalTreatment(variables: DeleteExternalTreatmentMutationVariables, options?: C): Promise<DeleteExternalTreatmentMutation> {
      return requester<DeleteExternalTreatmentMutation, DeleteExternalTreatmentMutationVariables>(DeleteExternalTreatmentDocument, variables, options) as Promise<DeleteExternalTreatmentMutation>;
    },
    externalPromocodes(variables?: ExternalPromocodesQueryVariables, options?: C): Promise<ExternalPromocodesQuery> {
      return requester<ExternalPromocodesQuery, ExternalPromocodesQueryVariables>(ExternalPromocodesDocument, variables, options) as Promise<ExternalPromocodesQuery>;
    },
    externalPromocode(variables: ExternalPromocodeQueryVariables, options?: C): Promise<ExternalPromocodeQuery> {
      return requester<ExternalPromocodeQuery, ExternalPromocodeQueryVariables>(ExternalPromocodeDocument, variables, options) as Promise<ExternalPromocodeQuery>;
    },
    createExternalPromocode(variables: CreateExternalPromocodeMutationVariables, options?: C): Promise<CreateExternalPromocodeMutation> {
      return requester<CreateExternalPromocodeMutation, CreateExternalPromocodeMutationVariables>(CreateExternalPromocodeDocument, variables, options) as Promise<CreateExternalPromocodeMutation>;
    },
    validateExternalPromocode(variables: ValidateExternalPromocodeMutationVariables, options?: C): Promise<ValidateExternalPromocodeMutation> {
      return requester<ValidateExternalPromocodeMutation, ValidateExternalPromocodeMutationVariables>(ValidateExternalPromocodeDocument, variables, options) as Promise<ValidateExternalPromocodeMutation>;
    },
    updateExternalPromocode(variables: UpdateExternalPromocodeMutationVariables, options?: C): Promise<UpdateExternalPromocodeMutation> {
      return requester<UpdateExternalPromocodeMutation, UpdateExternalPromocodeMutationVariables>(UpdateExternalPromocodeDocument, variables, options) as Promise<UpdateExternalPromocodeMutation>;
    },
    externalTreatment(variables: ExternalTreatmentQueryVariables, options?: C): Promise<ExternalTreatmentQuery> {
      return requester<ExternalTreatmentQuery, ExternalTreatmentQueryVariables>(ExternalTreatmentDocument, variables, options) as Promise<ExternalTreatmentQuery>;
    },
    externalClients(variables?: ExternalClientsQueryVariables, options?: C): Promise<ExternalClientsQuery> {
      return requester<ExternalClientsQuery, ExternalClientsQueryVariables>(ExternalClientsDocument, variables, options) as Promise<ExternalClientsQuery>;
    },
    clientGroupCounts(variables?: ClientGroupCountsQueryVariables, options?: C): Promise<ClientGroupCountsQuery> {
      return requester<ClientGroupCountsQuery, ClientGroupCountsQueryVariables>(ClientGroupCountsDocument, variables, options) as Promise<ClientGroupCountsQuery>;
    },
    searchExternalClients(variables: SearchExternalClientsQueryVariables, options?: C): Promise<SearchExternalClientsQuery> {
      return requester<SearchExternalClientsQuery, SearchExternalClientsQueryVariables>(SearchExternalClientsDocument, variables, options) as Promise<SearchExternalClientsQuery>;
    },
    addOrUpdateExternalClient(variables: AddOrUpdateExternalClientMutationVariables, options?: C): Promise<AddOrUpdateExternalClientMutation> {
      return requester<AddOrUpdateExternalClientMutation, AddOrUpdateExternalClientMutationVariables>(AddOrUpdateExternalClientDocument, variables, options) as Promise<AddOrUpdateExternalClientMutation>;
    },
    deleteExternalClient(variables: DeleteExternalClientMutationVariables, options?: C): Promise<DeleteExternalClientMutation> {
      return requester<DeleteExternalClientMutation, DeleteExternalClientMutationVariables>(DeleteExternalClientDocument, variables, options) as Promise<DeleteExternalClientMutation>;
    },
    externalClient(variables: ExternalClientQueryVariables, options?: C): Promise<ExternalClientQuery> {
      return requester<ExternalClientQuery, ExternalClientQueryVariables>(ExternalClientDocument, variables, options) as Promise<ExternalClientQuery>;
    },
    addExternalClients(variables: AddExternalClientsMutationVariables, options?: C): Promise<AddExternalClientsMutation> {
      return requester<AddExternalClientsMutation, AddExternalClientsMutationVariables>(AddExternalClientsDocument, variables, options) as Promise<AddExternalClientsMutation>;
    },
    switchClientBookings(variables: SwitchClientBookingsMutationVariables, options?: C): Promise<SwitchClientBookingsMutation> {
      return requester<SwitchClientBookingsMutation, SwitchClientBookingsMutationVariables>(SwitchClientBookingsDocument, variables, options) as Promise<SwitchClientBookingsMutation>;
    },
    externalAddresses(variables?: ExternalAddressesQueryVariables, options?: C): Promise<ExternalAddressesQuery> {
      return requester<ExternalAddressesQuery, ExternalAddressesQueryVariables>(ExternalAddressesDocument, variables, options) as Promise<ExternalAddressesQuery>;
    },
    addOrUpdateExternalAddress(variables: AddOrUpdateExternalAddressMutationVariables, options?: C): Promise<AddOrUpdateExternalAddressMutation> {
      return requester<AddOrUpdateExternalAddressMutation, AddOrUpdateExternalAddressMutationVariables>(AddOrUpdateExternalAddressDocument, variables, options) as Promise<AddOrUpdateExternalAddressMutation>;
    },
    deleteExternalAddress(variables: DeleteExternalAddressMutationVariables, options?: C): Promise<DeleteExternalAddressMutation> {
      return requester<DeleteExternalAddressMutation, DeleteExternalAddressMutationVariables>(DeleteExternalAddressDocument, variables, options) as Promise<DeleteExternalAddressMutation>;
    },
    externalAddress(variables: ExternalAddressQueryVariables, options?: C): Promise<ExternalAddressQuery> {
      return requester<ExternalAddressQuery, ExternalAddressQueryVariables>(ExternalAddressDocument, variables, options) as Promise<ExternalAddressQuery>;
    },
    checkSaasProfileUrlAvailable(variables: CheckSaasProfileUrlAvailableQueryVariables, options?: C): Promise<CheckSaasProfileUrlAvailableQuery> {
      return requester<CheckSaasProfileUrlAvailableQuery, CheckSaasProfileUrlAvailableQueryVariables>(CheckSaasProfileUrlAvailableDocument, variables, options) as Promise<CheckSaasProfileUrlAvailableQuery>;
    },
    getBookingsForHomepage(variables?: GetBookingsForHomepageQueryVariables, options?: C): Promise<GetBookingsForHomepageQuery> {
      return requester<GetBookingsForHomepageQuery, GetBookingsForHomepageQueryVariables>(GetBookingsForHomepageDocument, variables, options) as Promise<GetBookingsForHomepageQuery>;
    },
    soloBookingsForDashboard(variables: SoloBookingsForDashboardQueryVariables, options?: C): Promise<SoloBookingsForDashboardQuery> {
      return requester<SoloBookingsForDashboardQuery, SoloBookingsForDashboardQueryVariables>(SoloBookingsForDashboardDocument, variables, options) as Promise<SoloBookingsForDashboardQuery>;
    },
    externalReviews(variables?: ExternalReviewsQueryVariables, options?: C): Promise<ExternalReviewsQuery> {
      return requester<ExternalReviewsQuery, ExternalReviewsQueryVariables>(ExternalReviewsDocument, variables, options) as Promise<ExternalReviewsQuery>;
    },
    updateExternalReviewVisible(variables: UpdateExternalReviewVisibleMutationVariables, options?: C): Promise<UpdateExternalReviewVisibleMutation> {
      return requester<UpdateExternalReviewVisibleMutation, UpdateExternalReviewVisibleMutationVariables>(UpdateExternalReviewVisibleDocument, variables, options) as Promise<UpdateExternalReviewVisibleMutation>;
    },
    createExternalReview(variables: CreateExternalReviewMutationVariables, options?: C): Promise<CreateExternalReviewMutation> {
      return requester<CreateExternalReviewMutation, CreateExternalReviewMutationVariables>(CreateExternalReviewDocument, variables, options) as Promise<CreateExternalReviewMutation>;
    },
    createSecretSpaExternalReview(variables: CreateSecretSpaExternalReviewMutationVariables, options?: C): Promise<CreateSecretSpaExternalReviewMutation> {
      return requester<CreateSecretSpaExternalReviewMutation, CreateSecretSpaExternalReviewMutationVariables>(CreateSecretSpaExternalReviewDocument, variables, options) as Promise<CreateSecretSpaExternalReviewMutation>;
    },
    consultationForm(variables: ConsultationFormQueryVariables, options?: C): Promise<ConsultationFormQuery> {
      return requester<ConsultationFormQuery, ConsultationFormQueryVariables>(ConsultationFormDocument, variables, options) as Promise<ConsultationFormQuery>;
    },
    consultationForms(variables?: ConsultationFormsQueryVariables, options?: C): Promise<ConsultationFormsQuery> {
      return requester<ConsultationFormsQuery, ConsultationFormsQueryVariables>(ConsultationFormsDocument, variables, options) as Promise<ConsultationFormsQuery>;
    },
    createOrUpdateConsultationForm(variables: CreateOrUpdateConsultationFormMutationVariables, options?: C): Promise<CreateOrUpdateConsultationFormMutation> {
      return requester<CreateOrUpdateConsultationFormMutation, CreateOrUpdateConsultationFormMutationVariables>(CreateOrUpdateConsultationFormDocument, variables, options) as Promise<CreateOrUpdateConsultationFormMutation>;
    },
    consultationFormDefaultQuestions(variables?: ConsultationFormDefaultQuestionsQueryVariables, options?: C): Promise<ConsultationFormDefaultQuestionsQuery> {
      return requester<ConsultationFormDefaultQuestionsQuery, ConsultationFormDefaultQuestionsQueryVariables>(ConsultationFormDefaultQuestionsDocument, variables, options) as Promise<ConsultationFormDefaultQuestionsQuery>;
    },
    consultationFormCompleted(variables: ConsultationFormCompletedQueryVariables, options?: C): Promise<ConsultationFormCompletedQuery> {
      return requester<ConsultationFormCompletedQuery, ConsultationFormCompletedQueryVariables>(ConsultationFormCompletedDocument, variables, options) as Promise<ConsultationFormCompletedQuery>;
    },
    consultationFormAnswers(variables: ConsultationFormAnswersQueryVariables, options?: C): Promise<ConsultationFormAnswersQuery> {
      return requester<ConsultationFormAnswersQuery, ConsultationFormAnswersQueryVariables>(ConsultationFormAnswersDocument, variables, options) as Promise<ConsultationFormAnswersQuery>;
    },
    deleteConsultationForm(variables: DeleteConsultationFormMutationVariables, options?: C): Promise<DeleteConsultationFormMutation> {
      return requester<DeleteConsultationFormMutation, DeleteConsultationFormMutationVariables>(DeleteConsultationFormDocument, variables, options) as Promise<DeleteConsultationFormMutation>;
    },
    uploadFile(variables: UploadFileMutationVariables, options?: C): Promise<UploadFileMutation> {
      return requester<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, variables, options) as Promise<UploadFileMutation>;
    },
    deleteFile(variables?: DeleteFileMutationVariables, options?: C): Promise<DeleteFileMutation> {
      return requester<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, variables, options) as Promise<DeleteFileMutation>;
    },
    deleteUser(variables?: DeleteUserMutationVariables, options?: C): Promise<DeleteUserMutation> {
      return requester<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, variables, options) as Promise<DeleteUserMutation>;
    },
    createNewSaasUserWithMobile(variables?: CreateNewSaasUserWithMobileMutationVariables, options?: C): Promise<CreateNewSaasUserWithMobileMutation> {
      return requester<CreateNewSaasUserWithMobileMutation, CreateNewSaasUserWithMobileMutationVariables>(CreateNewSaasUserWithMobileDocument, variables, options) as Promise<CreateNewSaasUserWithMobileMutation>;
    },
    verifyMobileAndCompleteAccount(variables: VerifyMobileAndCompleteAccountMutationVariables, options?: C): Promise<VerifyMobileAndCompleteAccountMutation> {
      return requester<VerifyMobileAndCompleteAccountMutation, VerifyMobileAndCompleteAccountMutationVariables>(VerifyMobileAndCompleteAccountDocument, variables, options) as Promise<VerifyMobileAndCompleteAccountMutation>;
    },
    inAppMessages(variables: InAppMessagesQueryVariables, options?: C): Promise<InAppMessagesQuery> {
      return requester<InAppMessagesQuery, InAppMessagesQueryVariables>(InAppMessagesDocument, variables, options) as Promise<InAppMessagesQuery>;
    },
    inAppMessage(variables: InAppMessageQueryVariables, options?: C): Promise<InAppMessageQuery> {
      return requester<InAppMessageQuery, InAppMessageQueryVariables>(InAppMessageDocument, variables, options) as Promise<InAppMessageQuery>;
    },
    submitOnboardingAnswers(variables: SubmitOnboardingAnswersMutationVariables, options?: C): Promise<SubmitOnboardingAnswersMutation> {
      return requester<SubmitOnboardingAnswersMutation, SubmitOnboardingAnswersMutationVariables>(SubmitOnboardingAnswersDocument, variables, options) as Promise<SubmitOnboardingAnswersMutation>;
    },
    externalTreatmentLibrary(variables?: ExternalTreatmentLibraryQueryVariables, options?: C): Promise<ExternalTreatmentLibraryQuery> {
      return requester<ExternalTreatmentLibraryQuery, ExternalTreatmentLibraryQueryVariables>(ExternalTreatmentLibraryDocument, variables, options) as Promise<ExternalTreatmentLibraryQuery>;
    },
    importLibraryTreatments(variables: ImportLibraryTreatmentsMutationVariables, options?: C): Promise<ImportLibraryTreatmentsMutation> {
      return requester<ImportLibraryTreatmentsMutation, ImportLibraryTreatmentsMutationVariables>(ImportLibraryTreatmentsDocument, variables, options) as Promise<ImportLibraryTreatmentsMutation>;
    },
    manageSoloSubscriptionUrl(variables?: ManageSoloSubscriptionUrlQueryVariables, options?: C): Promise<ManageSoloSubscriptionUrlQuery> {
      return requester<ManageSoloSubscriptionUrlQuery, ManageSoloSubscriptionUrlQueryVariables>(ManageSoloSubscriptionUrlDocument, variables, options) as Promise<ManageSoloSubscriptionUrlQuery>;
    },
    soloSubscriptionUrl(variables: SoloSubscriptionUrlQueryVariables, options?: C): Promise<SoloSubscriptionUrlQuery> {
      return requester<SoloSubscriptionUrlQuery, SoloSubscriptionUrlQueryVariables>(SoloSubscriptionUrlDocument, variables, options) as Promise<SoloSubscriptionUrlQuery>;
    },
    testSubscription(variables: TestSubscriptionMutationVariables, options?: C): Promise<TestSubscriptionMutation> {
      return requester<TestSubscriptionMutation, TestSubscriptionMutationVariables>(TestSubscriptionDocument, variables, options) as Promise<TestSubscriptionMutation>;
    },
    syncWithChargebee(variables?: SyncWithChargebeeMutationVariables, options?: C): Promise<SyncWithChargebeeMutation> {
      return requester<SyncWithChargebeeMutation, SyncWithChargebeeMutationVariables>(SyncWithChargebeeDocument, variables, options) as Promise<SyncWithChargebeeMutation>;
    },
    bookingsForCalendarSync(variables?: BookingsForCalendarSyncQueryVariables, options?: C): Promise<BookingsForCalendarSyncQuery> {
      return requester<BookingsForCalendarSyncQuery, BookingsForCalendarSyncQueryVariables>(BookingsForCalendarSyncDocument, variables, options) as Promise<BookingsForCalendarSyncQuery>;
    },
    marketplaces(variables?: MarketplacesQueryVariables, options?: C): Promise<MarketplacesQuery> {
      return requester<MarketplacesQuery, MarketplacesQueryVariables>(MarketplacesDocument, variables, options) as Promise<MarketplacesQuery>;
    },
    createDefaultAvailability(variables: CreateDefaultAvailabilityMutationVariables, options?: C): Promise<CreateDefaultAvailabilityMutation> {
      return requester<CreateDefaultAvailabilityMutation, CreateDefaultAvailabilityMutationVariables>(CreateDefaultAvailabilityDocument, variables, options) as Promise<CreateDefaultAvailabilityMutation>;
    },
    clientSavedCard(variables: ClientSavedCardQueryVariables, options?: C): Promise<ClientSavedCardQuery> {
      return requester<ClientSavedCardQuery, ClientSavedCardQueryVariables>(ClientSavedCardDocument, variables, options) as Promise<ClientSavedCardQuery>;
    },
    saveAttributionSurveyData(variables: SaveAttributionSurveyDataMutationVariables, options?: C): Promise<SaveAttributionSurveyDataMutation> {
      return requester<SaveAttributionSurveyDataMutation, SaveAttributionSurveyDataMutationVariables>(SaveAttributionSurveyDataDocument, variables, options) as Promise<SaveAttributionSurveyDataMutation>;
    },
    enrollReferralProgram(variables?: EnrollReferralProgramMutationVariables, options?: C): Promise<EnrollReferralProgramMutation> {
      return requester<EnrollReferralProgramMutation, EnrollReferralProgramMutationVariables>(EnrollReferralProgramDocument, variables, options) as Promise<EnrollReferralProgramMutation>;
    },
    getSoloReferrals(variables?: GetSoloReferralsQueryVariables, options?: C): Promise<GetSoloReferralsQuery> {
      return requester<GetSoloReferralsQuery, GetSoloReferralsQueryVariables>(GetSoloReferralsDocument, variables, options) as Promise<GetSoloReferralsQuery>;
    },
    checkSoloReferralCode(variables: CheckSoloReferralCodeQueryVariables, options?: C): Promise<CheckSoloReferralCodeQuery> {
      return requester<CheckSoloReferralCodeQuery, CheckSoloReferralCodeQueryVariables>(CheckSoloReferralCodeDocument, variables, options) as Promise<CheckSoloReferralCodeQuery>;
    },
    crmInvoices(variables?: CrmInvoicesQueryVariables, options?: C): Promise<CrmInvoicesQuery> {
      return requester<CrmInvoicesQuery, CrmInvoicesQueryVariables>(CrmInvoicesDocument, variables, options) as Promise<CrmInvoicesQuery>;
    },
    crmUsages(variables: CrmUsagesQueryVariables, options?: C): Promise<CrmUsagesQuery> {
      return requester<CrmUsagesQuery, CrmUsagesQueryVariables>(CrmUsagesDocument, variables, options) as Promise<CrmUsagesQuery>;
    },
    crmUsageErrors(variables?: CrmUsageErrorsQueryVariables, options?: C): Promise<CrmUsageErrorsQuery> {
      return requester<CrmUsageErrorsQuery, CrmUsageErrorsQueryVariables>(CrmUsageErrorsDocument, variables, options) as Promise<CrmUsageErrorsQuery>;
    },
    deleteCrmUsageErrors(variables?: DeleteCrmUsageErrorsMutationVariables, options?: C): Promise<DeleteCrmUsageErrorsMutation> {
      return requester<DeleteCrmUsageErrorsMutation, DeleteCrmUsageErrorsMutationVariables>(DeleteCrmUsageErrorsDocument, variables, options) as Promise<DeleteCrmUsageErrorsMutation>;
    },
    getTerminalSecret(variables?: GetTerminalSecretQueryVariables, options?: C): Promise<GetTerminalSecretQuery> {
      return requester<GetTerminalSecretQuery, GetTerminalSecretQueryVariables>(GetTerminalSecretDocument, variables, options) as Promise<GetTerminalSecretQuery>;
    },
    createTerminalPaymentIntent(variables: CreateTerminalPaymentIntentQueryVariables, options?: C): Promise<CreateTerminalPaymentIntentQuery> {
      return requester<CreateTerminalPaymentIntentQuery, CreateTerminalPaymentIntentQueryVariables>(CreateTerminalPaymentIntentDocument, variables, options) as Promise<CreateTerminalPaymentIntentQuery>;
    },
    captureTerminalPayment(variables: CaptureTerminalPaymentQueryVariables, options?: C): Promise<CaptureTerminalPaymentQuery> {
      return requester<CaptureTerminalPaymentQuery, CaptureTerminalPaymentQueryVariables>(CaptureTerminalPaymentDocument, variables, options) as Promise<CaptureTerminalPaymentQuery>;
    },
    terminalReaders(variables?: TerminalReadersQueryVariables, options?: C): Promise<TerminalReadersQuery> {
      return requester<TerminalReadersQuery, TerminalReadersQueryVariables>(TerminalReadersDocument, variables, options) as Promise<TerminalReadersQuery>;
    },
    registerTerminalReader(variables: RegisterTerminalReaderMutationVariables, options?: C): Promise<RegisterTerminalReaderMutation> {
      return requester<RegisterTerminalReaderMutation, RegisterTerminalReaderMutationVariables>(RegisterTerminalReaderDocument, variables, options) as Promise<RegisterTerminalReaderMutation>;
    },
    removeTerminalReader(variables: RemoveTerminalReaderMutationVariables, options?: C): Promise<RemoveTerminalReaderMutation> {
      return requester<RemoveTerminalReaderMutation, RemoveTerminalReaderMutationVariables>(RemoveTerminalReaderDocument, variables, options) as Promise<RemoveTerminalReaderMutation>;
    },
    terminalTipSettings(variables?: TerminalTipSettingsQueryVariables, options?: C): Promise<TerminalTipSettingsQuery> {
      return requester<TerminalTipSettingsQuery, TerminalTipSettingsQueryVariables>(TerminalTipSettingsDocument, variables, options) as Promise<TerminalTipSettingsQuery>;
    },
    updateTerminalTipSettings(variables: UpdateTerminalTipSettingsMutationVariables, options?: C): Promise<UpdateTerminalTipSettingsMutation> {
      return requester<UpdateTerminalTipSettingsMutation, UpdateTerminalTipSettingsMutationVariables>(UpdateTerminalTipSettingsDocument, variables, options) as Promise<UpdateTerminalTipSettingsMutation>;
    },
    getStripeTransactions(variables: GetStripeTransactionsQueryVariables, options?: C): Promise<GetStripeTransactionsQuery> {
      return requester<GetStripeTransactionsQuery, GetStripeTransactionsQueryVariables>(GetStripeTransactionsDocument, variables, options) as Promise<GetStripeTransactionsQuery>;
    },
    stripeBalances(variables?: StripeBalancesQueryVariables, options?: C): Promise<StripeBalancesQuery> {
      return requester<StripeBalancesQuery, StripeBalancesQueryVariables>(StripeBalancesDocument, variables, options) as Promise<StripeBalancesQuery>;
    },
    getProfessionalFromSaasUrl(variables: GetProfessionalFromSaasUrlQueryVariables, options?: C): Promise<GetProfessionalFromSaasUrlQuery> {
      return requester<GetProfessionalFromSaasUrlQuery, GetProfessionalFromSaasUrlQueryVariables>(GetProfessionalFromSaasUrlDocument, variables, options) as Promise<GetProfessionalFromSaasUrlQuery>;
    },
    getStripeTransactionDetails(variables: GetStripeTransactionDetailsQueryVariables, options?: C): Promise<GetStripeTransactionDetailsQuery> {
      return requester<GetStripeTransactionDetailsQuery, GetStripeTransactionDetailsQueryVariables>(GetStripeTransactionDetailsDocument, variables, options) as Promise<GetStripeTransactionDetailsQuery>;
    },
    getAccountingData(variables: GetAccountingDataQueryVariables, options?: C): Promise<GetAccountingDataQuery> {
      return requester<GetAccountingDataQuery, GetAccountingDataQueryVariables>(GetAccountingDataDocument, variables, options) as Promise<GetAccountingDataQuery>;
    },
    webPage(variables: WebPageQueryVariables, options?: C): Promise<WebPageQuery> {
      return requester<WebPageQuery, WebPageQueryVariables>(WebPageDocument, variables, options) as Promise<WebPageQuery>;
    },
    createWebPage(variables: CreateWebPageMutationVariables, options?: C): Promise<CreateWebPageMutation> {
      return requester<CreateWebPageMutation, CreateWebPageMutationVariables>(CreateWebPageDocument, variables, options) as Promise<CreateWebPageMutation>;
    },
    updateWebPage(variables: UpdateWebPageMutationVariables, options?: C): Promise<UpdateWebPageMutation> {
      return requester<UpdateWebPageMutation, UpdateWebPageMutationVariables>(UpdateWebPageDocument, variables, options) as Promise<UpdateWebPageMutation>;
    },
    deleteWebPage(variables: DeleteWebPageMutationVariables, options?: C): Promise<DeleteWebPageMutation> {
      return requester<DeleteWebPageMutation, DeleteWebPageMutationVariables>(DeleteWebPageDocument, variables, options) as Promise<DeleteWebPageMutation>;
    },
    webPages(variables?: WebPagesQueryVariables, options?: C): Promise<WebPagesQuery> {
      return requester<WebPagesQuery, WebPagesQueryVariables>(WebPagesDocument, variables, options) as Promise<WebPagesQuery>;
    },
    createDefaultWebPages(variables?: CreateDefaultWebPagesMutationVariables, options?: C): Promise<CreateDefaultWebPagesMutation> {
      return requester<CreateDefaultWebPagesMutation, CreateDefaultWebPagesMutationVariables>(CreateDefaultWebPagesDocument, variables, options) as Promise<CreateDefaultWebPagesMutation>;
    },
    dev_RemoveAllWebPages(variables?: Dev_RemoveAllWebPagesMutationVariables, options?: C): Promise<Dev_RemoveAllWebPagesMutation> {
      return requester<Dev_RemoveAllWebPagesMutation, Dev_RemoveAllWebPagesMutationVariables>(Dev_RemoveAllWebPagesDocument, variables, options) as Promise<Dev_RemoveAllWebPagesMutation>;
    },
    getLoyaltySchemes(variables?: GetLoyaltySchemesQueryVariables, options?: C): Promise<GetLoyaltySchemesQuery> {
      return requester<GetLoyaltySchemesQuery, GetLoyaltySchemesQueryVariables>(GetLoyaltySchemesDocument, variables, options) as Promise<GetLoyaltySchemesQuery>;
    },
    updateLoyaltyScheme(variables: UpdateLoyaltySchemeMutationVariables, options?: C): Promise<UpdateLoyaltySchemeMutation> {
      return requester<UpdateLoyaltySchemeMutation, UpdateLoyaltySchemeMutationVariables>(UpdateLoyaltySchemeDocument, variables, options) as Promise<UpdateLoyaltySchemeMutation>;
    },
    createLoyaltyScheme(variables: CreateLoyaltySchemeMutationVariables, options?: C): Promise<CreateLoyaltySchemeMutation> {
      return requester<CreateLoyaltySchemeMutation, CreateLoyaltySchemeMutationVariables>(CreateLoyaltySchemeDocument, variables, options) as Promise<CreateLoyaltySchemeMutation>;
    },
    campaignsForLoyaltyScheme(variables?: CampaignsForLoyaltySchemeQueryVariables, options?: C): Promise<CampaignsForLoyaltySchemeQuery> {
      return requester<CampaignsForLoyaltySchemeQuery, CampaignsForLoyaltySchemeQueryVariables>(CampaignsForLoyaltySchemeDocument, variables, options) as Promise<CampaignsForLoyaltySchemeQuery>;
    },
    campaignsForClientReferralScheme(variables?: CampaignsForClientReferralSchemeQueryVariables, options?: C): Promise<CampaignsForClientReferralSchemeQuery> {
      return requester<CampaignsForClientReferralSchemeQuery, CampaignsForClientReferralSchemeQueryVariables>(CampaignsForClientReferralSchemeDocument, variables, options) as Promise<CampaignsForClientReferralSchemeQuery>;
    },
    activities(variables?: ActivitiesQueryVariables, options?: C): Promise<ActivitiesQuery> {
      return requester<ActivitiesQuery, ActivitiesQueryVariables>(ActivitiesDocument, variables, options) as Promise<ActivitiesQuery>;
    },
    updateActivityStatus(variables: UpdateActivityStatusMutationVariables, options?: C): Promise<UpdateActivityStatusMutation> {
      return requester<UpdateActivityStatusMutation, UpdateActivityStatusMutationVariables>(UpdateActivityStatusDocument, variables, options) as Promise<UpdateActivityStatusMutation>;
    },
    externalGiftCards(variables?: ExternalGiftCardsQueryVariables, options?: C): Promise<ExternalGiftCardsQuery> {
      return requester<ExternalGiftCardsQuery, ExternalGiftCardsQueryVariables>(ExternalGiftCardsDocument, variables, options) as Promise<ExternalGiftCardsQuery>;
    },
    externalGiftCard(variables: ExternalGiftCardQueryVariables, options?: C): Promise<ExternalGiftCardQuery> {
      return requester<ExternalGiftCardQuery, ExternalGiftCardQueryVariables>(ExternalGiftCardDocument, variables, options) as Promise<ExternalGiftCardQuery>;
    },
    refundExternalGiftCard(variables: RefundExternalGiftCardMutationVariables, options?: C): Promise<RefundExternalGiftCardMutation> {
      return requester<RefundExternalGiftCardMutation, RefundExternalGiftCardMutationVariables>(RefundExternalGiftCardDocument, variables, options) as Promise<RefundExternalGiftCardMutation>;
    },
    applyExternalGiftCard(variables: ApplyExternalGiftCardMutationVariables, options?: C): Promise<ApplyExternalGiftCardMutation> {
      return requester<ApplyExternalGiftCardMutation, ApplyExternalGiftCardMutationVariables>(ApplyExternalGiftCardDocument, variables, options) as Promise<ApplyExternalGiftCardMutation>;
    },
    createExternalGiftCard(variables: CreateExternalGiftCardMutationVariables, options?: C): Promise<CreateExternalGiftCardMutation> {
      return requester<CreateExternalGiftCardMutation, CreateExternalGiftCardMutationVariables>(CreateExternalGiftCardDocument, variables, options) as Promise<CreateExternalGiftCardMutation>;
    },
    updateExternalGiftCard(variables: UpdateExternalGiftCardMutationVariables, options?: C): Promise<UpdateExternalGiftCardMutation> {
      return requester<UpdateExternalGiftCardMutation, UpdateExternalGiftCardMutationVariables>(UpdateExternalGiftCardDocument, variables, options) as Promise<UpdateExternalGiftCardMutation>;
    },
    refundExternalGiftCardPayment(variables: RefundExternalGiftCardPaymentMutationVariables, options?: C): Promise<RefundExternalGiftCardPaymentMutation> {
      return requester<RefundExternalGiftCardPaymentMutation, RefundExternalGiftCardPaymentMutationVariables>(RefundExternalGiftCardPaymentDocument, variables, options) as Promise<RefundExternalGiftCardPaymentMutation>;
    },
    searchExternalGiftCards(variables: SearchExternalGiftCardsQueryVariables, options?: C): Promise<SearchExternalGiftCardsQuery> {
      return requester<SearchExternalGiftCardsQuery, SearchExternalGiftCardsQueryVariables>(SearchExternalGiftCardsDocument, variables, options) as Promise<SearchExternalGiftCardsQuery>;
    },
    estimateSmsCampaignCost(variables: EstimateSmsCampaignCostQueryVariables, options?: C): Promise<EstimateSmsCampaignCostQuery> {
      return requester<EstimateSmsCampaignCostQuery, EstimateSmsCampaignCostQueryVariables>(EstimateSmsCampaignCostDocument, variables, options) as Promise<EstimateSmsCampaignCostQuery>;
    },
    getHTMLForBlocks(variables: GetHtmlForBlocksQueryVariables, options?: C): Promise<GetHtmlForBlocksQuery> {
      return requester<GetHtmlForBlocksQuery, GetHtmlForBlocksQueryVariables>(GetHtmlForBlocksDocument, variables, options) as Promise<GetHtmlForBlocksQuery>;
    },
    getEmailTemplates(variables?: GetEmailTemplatesQueryVariables, options?: C): Promise<GetEmailTemplatesQuery> {
      return requester<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, variables, options) as Promise<GetEmailTemplatesQuery>;
    },
    connectGoogleAuthUrl(variables: ConnectGoogleAuthUrlQueryVariables, options?: C): Promise<ConnectGoogleAuthUrlQuery> {
      return requester<ConnectGoogleAuthUrlQuery, ConnectGoogleAuthUrlQueryVariables>(ConnectGoogleAuthUrlDocument, variables, options) as Promise<ConnectGoogleAuthUrlQuery>;
    },
    disconnectGoogleAuth(variables: DisconnectGoogleAuthMutationVariables, options?: C): Promise<DisconnectGoogleAuthMutation> {
      return requester<DisconnectGoogleAuthMutation, DisconnectGoogleAuthMutationVariables>(DisconnectGoogleAuthDocument, variables, options) as Promise<DisconnectGoogleAuthMutation>;
    },
    getGoogleBusinessDetails(variables?: GetGoogleBusinessDetailsQueryVariables, options?: C): Promise<GetGoogleBusinessDetailsQuery> {
      return requester<GetGoogleBusinessDetailsQuery, GetGoogleBusinessDetailsQueryVariables>(GetGoogleBusinessDetailsDocument, variables, options) as Promise<GetGoogleBusinessDetailsQuery>;
    },
    selectGoogleBusinessAccountLocation(variables: SelectGoogleBusinessAccountLocationMutationVariables, options?: C): Promise<SelectGoogleBusinessAccountLocationMutation> {
      return requester<SelectGoogleBusinessAccountLocationMutation, SelectGoogleBusinessAccountLocationMutationVariables>(SelectGoogleBusinessAccountLocationDocument, variables, options) as Promise<SelectGoogleBusinessAccountLocationMutation>;
    },
    importGoogleReviews(variables: ImportGoogleReviewsMutationVariables, options?: C): Promise<ImportGoogleReviewsMutation> {
      return requester<ImportGoogleReviewsMutation, ImportGoogleReviewsMutationVariables>(ImportGoogleReviewsDocument, variables, options) as Promise<ImportGoogleReviewsMutation>;
    },
    deleteImportedGoogleReviews(variables?: DeleteImportedGoogleReviewsMutationVariables, options?: C): Promise<DeleteImportedGoogleReviewsMutation> {
      return requester<DeleteImportedGoogleReviewsMutation, DeleteImportedGoogleReviewsMutationVariables>(DeleteImportedGoogleReviewsDocument, variables, options) as Promise<DeleteImportedGoogleReviewsMutation>;
    },
    verifyMagicLinkToken(variables: VerifyMagicLinkTokenMutationVariables, options?: C): Promise<VerifyMagicLinkTokenMutation> {
      return requester<VerifyMagicLinkTokenMutation, VerifyMagicLinkTokenMutationVariables>(VerifyMagicLinkTokenDocument, variables, options) as Promise<VerifyMagicLinkTokenMutation>;
    },
    getMagicLinkTokenInfo(variables: GetMagicLinkTokenInfoQueryVariables, options?: C): Promise<GetMagicLinkTokenInfoQuery> {
      return requester<GetMagicLinkTokenInfoQuery, GetMagicLinkTokenInfoQueryVariables>(GetMagicLinkTokenInfoDocument, variables, options) as Promise<GetMagicLinkTokenInfoQuery>;
    },
    sendMagicLinkEmail(variables: SendMagicLinkEmailMutationVariables, options?: C): Promise<SendMagicLinkEmailMutation> {
      return requester<SendMagicLinkEmailMutation, SendMagicLinkEmailMutationVariables>(SendMagicLinkEmailDocument, variables, options) as Promise<SendMagicLinkEmailMutation>;
    },
    getGoogleStats(variables: GetGoogleStatsQueryVariables, options?: C): Promise<GetGoogleStatsQuery> {
      return requester<GetGoogleStatsQuery, GetGoogleStatsQueryVariables>(GetGoogleStatsDocument, variables, options) as Promise<GetGoogleStatsQuery>;
    },
    getIncomeStats(variables: GetIncomeStatsQueryVariables, options?: C): Promise<GetIncomeStatsQuery> {
      return requester<GetIncomeStatsQuery, GetIncomeStatsQueryVariables>(GetIncomeStatsDocument, variables, options) as Promise<GetIncomeStatsQuery>;
    },
    getStatsOverview(variables: GetStatsOverviewQueryVariables, options?: C): Promise<GetStatsOverviewQuery> {
      return requester<GetStatsOverviewQuery, GetStatsOverviewQueryVariables>(GetStatsOverviewDocument, variables, options) as Promise<GetStatsOverviewQuery>;
    },
    professionalImage(variables: ProfessionalImageQueryVariables, options?: C): Promise<ProfessionalImageQuery> {
      return requester<ProfessionalImageQuery, ProfessionalImageQueryVariables>(ProfessionalImageDocument, variables, options) as Promise<ProfessionalImageQuery>;
    },
    professionalImagesByProfessional(variables?: ProfessionalImagesByProfessionalQueryVariables, options?: C): Promise<ProfessionalImagesByProfessionalQuery> {
      return requester<ProfessionalImagesByProfessionalQuery, ProfessionalImagesByProfessionalQueryVariables>(ProfessionalImagesByProfessionalDocument, variables, options) as Promise<ProfessionalImagesByProfessionalQuery>;
    },
    createProfessionalImage(variables: CreateProfessionalImageMutationVariables, options?: C): Promise<CreateProfessionalImageMutation> {
      return requester<CreateProfessionalImageMutation, CreateProfessionalImageMutationVariables>(CreateProfessionalImageDocument, variables, options) as Promise<CreateProfessionalImageMutation>;
    },
    deleteProfessionalImage(variables: DeleteProfessionalImageMutationVariables, options?: C): Promise<DeleteProfessionalImageMutation> {
      return requester<DeleteProfessionalImageMutation, DeleteProfessionalImageMutationVariables>(DeleteProfessionalImageDocument, variables, options) as Promise<DeleteProfessionalImageMutation>;
    },
    findPageReferences(variables: FindPageReferencesQueryVariables, options?: C): Promise<FindPageReferencesQuery> {
      return requester<FindPageReferencesQuery, FindPageReferencesQueryVariables>(FindPageReferencesDocument, variables, options) as Promise<FindPageReferencesQuery>;
    },
    getFeesPerCountry(variables: GetFeesPerCountryQueryVariables, options?: C): Promise<GetFeesPerCountryQuery> {
      return requester<GetFeesPerCountryQuery, GetFeesPerCountryQueryVariables>(GetFeesPerCountryDocument, variables, options) as Promise<GetFeesPerCountryQuery>;
    },
    extendTrial(variables: ExtendTrialMutationVariables, options?: C): Promise<ExtendTrialMutation> {
      return requester<ExtendTrialMutation, ExtendTrialMutationVariables>(ExtendTrialDocument, variables, options) as Promise<ExtendTrialMutation>;
    },
    seoAnalysis(variables: SeoAnalysisQueryVariables, options?: C): Promise<SeoAnalysisQuery> {
      return requester<SeoAnalysisQuery, SeoAnalysisQueryVariables>(SeoAnalysisDocument, variables, options) as Promise<SeoAnalysisQuery>;
    },
    getBusinessProfileData(variables?: GetBusinessProfileDataQueryVariables, options?: C): Promise<GetBusinessProfileDataQuery> {
      return requester<GetBusinessProfileDataQuery, GetBusinessProfileDataQueryVariables>(GetBusinessProfileDataDocument, variables, options) as Promise<GetBusinessProfileDataQuery>;
    },
    themePresets(variables?: ThemePresetsQueryVariables, options?: C): Promise<ThemePresetsQuery> {
      return requester<ThemePresetsQuery, ThemePresetsQueryVariables>(ThemePresetsDocument, variables, options) as Promise<ThemePresetsQuery>;
    },
    scrapeUrl(variables: ScrapeUrlMutationVariables, options?: C): Promise<ScrapeUrlMutation> {
      return requester<ScrapeUrlMutation, ScrapeUrlMutationVariables>(ScrapeUrlDocument, variables, options) as Promise<ScrapeUrlMutation>;
    },
    resetAccount(variables?: ResetAccountMutationVariables, options?: C): Promise<ResetAccountMutation> {
      return requester<ResetAccountMutation, ResetAccountMutationVariables>(ResetAccountDocument, variables, options) as Promise<ResetAccountMutation>;
    },
    replyToGoogleReview(variables: ReplyToGoogleReviewMutationVariables, options?: C): Promise<ReplyToGoogleReviewMutation> {
      return requester<ReplyToGoogleReviewMutation, ReplyToGoogleReviewMutationVariables>(ReplyToGoogleReviewDocument, variables, options) as Promise<ReplyToGoogleReviewMutation>;
    },
    deleteGoogleReviewReply(variables: DeleteGoogleReviewReplyMutationVariables, options?: C): Promise<DeleteGoogleReviewReplyMutation> {
      return requester<DeleteGoogleReviewReplyMutation, DeleteGoogleReviewReplyMutationVariables>(DeleteGoogleReviewReplyDocument, variables, options) as Promise<DeleteGoogleReviewReplyMutation>;
    },
    suggestReviewReplies(variables: SuggestReviewRepliesMutationVariables, options?: C): Promise<SuggestReviewRepliesMutation> {
      return requester<SuggestReviewRepliesMutation, SuggestReviewRepliesMutationVariables>(SuggestReviewRepliesDocument, variables, options) as Promise<SuggestReviewRepliesMutation>;
    },
    updateSalonMemberPermissions(variables: UpdateSalonMemberPermissionsMutationVariables, options?: C): Promise<UpdateSalonMemberPermissionsMutation> {
      return requester<UpdateSalonMemberPermissionsMutation, UpdateSalonMemberPermissionsMutationVariables>(UpdateSalonMemberPermissionsDocument, variables, options) as Promise<UpdateSalonMemberPermissionsMutation>;
    },
    updateSalonMember(variables: UpdateSalonMemberMutationVariables, options?: C): Promise<UpdateSalonMemberMutation> {
      return requester<UpdateSalonMemberMutation, UpdateSalonMemberMutationVariables>(UpdateSalonMemberDocument, variables, options) as Promise<UpdateSalonMemberMutation>;
    },
    createSalonReceptionistAccount(variables: CreateSalonReceptionistAccountMutationVariables, options?: C): Promise<CreateSalonReceptionistAccountMutation> {
      return requester<CreateSalonReceptionistAccountMutation, CreateSalonReceptionistAccountMutationVariables>(CreateSalonReceptionistAccountDocument, variables, options) as Promise<CreateSalonReceptionistAccountMutation>;
    },
    updateSalonReceptionistAccount(variables: UpdateSalonReceptionistAccountMutationVariables, options?: C): Promise<UpdateSalonReceptionistAccountMutation> {
      return requester<UpdateSalonReceptionistAccountMutation, UpdateSalonReceptionistAccountMutationVariables>(UpdateSalonReceptionistAccountDocument, variables, options) as Promise<UpdateSalonReceptionistAccountMutation>;
    },
    archiveSalonMember(variables: ArchiveSalonMemberMutationVariables, options?: C): Promise<ArchiveSalonMemberMutation> {
      return requester<ArchiveSalonMemberMutation, ArchiveSalonMemberMutationVariables>(ArchiveSalonMemberDocument, variables, options) as Promise<ArchiveSalonMemberMutation>;
    },
    restoreSalonMember(variables: RestoreSalonMemberMutationVariables, options?: C): Promise<RestoreSalonMemberMutation> {
      return requester<RestoreSalonMemberMutation, RestoreSalonMemberMutationVariables>(RestoreSalonMemberDocument, variables, options) as Promise<RestoreSalonMemberMutation>;
    },
    archivedSalonMembers(variables?: ArchivedSalonMembersQueryVariables, options?: C): Promise<ArchivedSalonMembersQuery> {
      return requester<ArchivedSalonMembersQuery, ArchivedSalonMembersQueryVariables>(ArchivedSalonMembersDocument, variables, options) as Promise<ArchivedSalonMembersQuery>;
    },
    sendReceptionistMagicLink(variables: SendReceptionistMagicLinkMutationVariables, options?: C): Promise<SendReceptionistMagicLinkMutation> {
      return requester<SendReceptionistMagicLinkMutation, SendReceptionistMagicLinkMutationVariables>(SendReceptionistMagicLinkDocument, variables, options) as Promise<SendReceptionistMagicLinkMutation>;
    },
    inviteMember(variables: InviteMemberMutationVariables, options?: C): Promise<InviteMemberMutation> {
      return requester<InviteMemberMutation, InviteMemberMutationVariables>(InviteMemberDocument, variables, options) as Promise<InviteMemberMutation>;
    },
    dev_setSalonSeats(variables: Dev_SetSalonSeatsMutationVariables, options?: C): Promise<Dev_SetSalonSeatsMutation> {
      return requester<Dev_SetSalonSeatsMutation, Dev_SetSalonSeatsMutationVariables>(Dev_SetSalonSeatsDocument, variables, options) as Promise<Dev_SetSalonSeatsMutation>;
    },
    dev_clearOwnBusiness(variables?: Dev_ClearOwnBusinessMutationVariables, options?: C): Promise<Dev_ClearOwnBusinessMutation> {
      return requester<Dev_ClearOwnBusinessMutation, Dev_ClearOwnBusinessMutationVariables>(Dev_ClearOwnBusinessDocument, variables, options) as Promise<Dev_ClearOwnBusinessMutation>;
    },
    dev_leaveSalon(variables: Dev_LeaveSalonMutationVariables, options?: C): Promise<Dev_LeaveSalonMutation> {
      return requester<Dev_LeaveSalonMutation, Dev_LeaveSalonMutationVariables>(Dev_LeaveSalonDocument, variables, options) as Promise<Dev_LeaveSalonMutation>;
    },
    dev_deleteSalon(variables: Dev_DeleteSalonMutationVariables, options?: C): Promise<Dev_DeleteSalonMutation> {
      return requester<Dev_DeleteSalonMutation, Dev_DeleteSalonMutationVariables>(Dev_DeleteSalonDocument, variables, options) as Promise<Dev_DeleteSalonMutation>;
    },
    cancelMemberInvite(variables: CancelMemberInviteMutationVariables, options?: C): Promise<CancelMemberInviteMutation> {
      return requester<CancelMemberInviteMutation, CancelMemberInviteMutationVariables>(CancelMemberInviteDocument, variables, options) as Promise<CancelMemberInviteMutation>;
    },
    resendMemberInvite(variables: ResendMemberInviteMutationVariables, options?: C): Promise<ResendMemberInviteMutation> {
      return requester<ResendMemberInviteMutation, ResendMemberInviteMutationVariables>(ResendMemberInviteDocument, variables, options) as Promise<ResendMemberInviteMutation>;
    },
    checkInviteCode(variables: CheckInviteCodeQueryVariables, options?: C): Promise<CheckInviteCodeQuery> {
      return requester<CheckInviteCodeQuery, CheckInviteCodeQueryVariables>(CheckInviteCodeDocument, variables, options) as Promise<CheckInviteCodeQuery>;
    },
    identifyWithInviteCode(variables: IdentifyWithInviteCodeMutationVariables, options?: C): Promise<IdentifyWithInviteCodeMutation> {
      return requester<IdentifyWithInviteCodeMutation, IdentifyWithInviteCodeMutationVariables>(IdentifyWithInviteCodeDocument, variables, options) as Promise<IdentifyWithInviteCodeMutation>;
    },
    verifyMobileAndJoinSalon(variables: VerifyMobileAndJoinSalonMutationVariables, options?: C): Promise<VerifyMobileAndJoinSalonMutation> {
      return requester<VerifyMobileAndJoinSalonMutation, VerifyMobileAndJoinSalonMutationVariables>(VerifyMobileAndJoinSalonDocument, variables, options) as Promise<VerifyMobileAndJoinSalonMutation>;
    },
    verifyMobileAndCreateSalon(variables: VerifyMobileAndCreateSalonMutationVariables, options?: C): Promise<VerifyMobileAndCreateSalonMutation> {
      return requester<VerifyMobileAndCreateSalonMutation, VerifyMobileAndCreateSalonMutationVariables>(VerifyMobileAndCreateSalonDocument, variables, options) as Promise<VerifyMobileAndCreateSalonMutation>;
    },
    createSalon(variables: CreateSalonMutationVariables, options?: C): Promise<CreateSalonMutation> {
      return requester<CreateSalonMutation, CreateSalonMutationVariables>(CreateSalonDocument, variables, options) as Promise<CreateSalonMutation>;
    },
    joinSalon(variables: JoinSalonMutationVariables, options?: C): Promise<JoinSalonMutation> {
      return requester<JoinSalonMutation, JoinSalonMutationVariables>(JoinSalonDocument, variables, options) as Promise<JoinSalonMutation>;
    },
    createSoloBusiness(variables: CreateSoloBusinessMutationVariables, options?: C): Promise<CreateSoloBusinessMutation> {
      return requester<CreateSoloBusinessMutation, CreateSoloBusinessMutationVariables>(CreateSoloBusinessDocument, variables, options) as Promise<CreateSoloBusinessMutation>;
    },
    getSalon(variables?: GetSalonQueryVariables, options?: C): Promise<GetSalonQuery> {
      return requester<GetSalonQuery, GetSalonQueryVariables>(GetSalonDocument, variables, options) as Promise<GetSalonQuery>;
    },
    mySalonMemberships(variables?: MySalonMembershipsQueryVariables, options?: C): Promise<MySalonMembershipsQuery> {
      return requester<MySalonMembershipsQuery, MySalonMembershipsQueryVariables>(MySalonMembershipsDocument, variables, options) as Promise<MySalonMembershipsQuery>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;